import { jsx as o, jsxs as u, Fragment as $ } from "react/jsx-runtime";
import ye, { forwardRef as Qt, createElement as Ft, useState as j, useRef as le, useEffect as X, useMemo as pe, useCallback as me, useLayoutEffect as mr, createContext as ur, useContext as hr } from "react";
import je from "react-dom";
import { useQueryClient as Xt, useQuery as yr } from "@tanstack/react-query";
function Ss(e) {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}
function Bs(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function Is(e) {
  const t = new Date(e), r = (/* @__PURE__ */ new Date()).getTime() - t.getTime(), i = Math.floor(r / (1e3 * 60 * 60 * 24));
  return i === 0 ? "Today" : i === 1 ? "Yesterday" : i < 7 ? `${i} days ago` : t.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function Ps(e, t) {
  return t > 0 ? Math.round(e * 100 / t) : 0;
}
function zs(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function Fs(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function Ts(e, t) {
  return e.length <= t ? e : e.slice(0, t - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const br = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), fr = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
), ro = (e) => {
  const t = fr(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, Bn = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim(), xr = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Cr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kr = Qt(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: a,
    iconNode: l,
    ...d
  }, p) => Ft(
    "svg",
    {
      ref: p,
      ...Cr,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Bn("lucide", i),
      ...!a && !xr(d) && { "aria-hidden": "true" },
      ...d
    },
    [
      ...l.map(([h, g]) => Ft(h, g)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const se = (e, t) => {
  const n = Qt(
    ({ className: r, ...i }, a) => Ft(kr, {
      ref: a,
      iconNode: t,
      className: Bn(
        `lucide-${br(ro(e))}`,
        `lucide-${e}`,
        r
      ),
      ...i
    })
  );
  return n.displayName = ro(e), n;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vr = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], nt = se("check", vr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wr = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], Sr = se("chevron-down", wr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Br = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], ht = se("chevron-right", Br);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ir = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], Pr = se("circle-check-big", Ir);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Fr = se("circle-x", zr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Tr = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Mr = se("ellipsis-vertical", Tr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Er = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Ar = se("eye", Er);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hr = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], Jt = se("info", Hr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Lr = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Rr = se("loader", Lr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nr = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], vt = se("log-out", Nr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wr = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Dr = se("maximize-2", Wr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Or = [
  [
    "path",
    {
      d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
      key: "1sd12s"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], jr = se("message-circle-plus", Or);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gr = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], $r = se("minimize-2", Gr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yr = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], In = se("monitor", Yr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qr = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], io = se("palette", Qr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xr = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], Pn = se("pencil", Xr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Jr = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Ut = se("plus", Jr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ur = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], zn = se("rotate-ccw", Ur);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _r = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], yt = se("search", _r);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zr = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Tt = se("settings", Zr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Vr = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], Fn = se("smartphone", Vr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qr = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], Tn = se("upload", qr);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Kr = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Ge = se("x", Kr), c = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, Mn = () => typeof window > "u" ? !1 : window.self !== window.top, bt = () => {
  var e, t;
  return typeof window > "u" ? document.body : window.self !== window.top && ((t = (e = window.parent) == null ? void 0 : e.document) != null && t.body) ? window.parent.document.body : document.body;
}, Mt = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, ei = async () => {
  if (typeof window > "u") return !0;
  try {
    const t = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(t != null && t.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, ti = () => {
  const [e, t] = j({ x: 0, y: 0 }), [n, r] = j(!1), i = le({ x: 0, y: 0 }), a = (l) => {
    r(!0), i.current = {
      x: l.clientX - e.x,
      y: l.clientY - e.y
    };
  };
  return X(() => {
    const l = (p) => {
      n && t({
        x: p.clientX - i.current.x,
        y: p.clientY - i.current.y
      });
    }, d = () => {
      r(!1);
    };
    if (n) {
      const p = Mt();
      return p.addEventListener("mousemove", l), p.addEventListener("mouseup", d), () => {
        p.removeEventListener("mousemove", l), p.removeEventListener("mouseup", d);
      };
    }
  }, [n]), { dragOffset: e, isDragging: n, handleMouseDown: a };
};
function ao(e, t) {
  if (!e) return !0;
  if (typeof e == "string")
    return !!t[e];
  const { field: n, value: r, operator: i } = e, a = t[n];
  return i === "includes" && r !== void 0 ? typeof a == "string" && a.includes(r) : i === "not_equals" && r !== void 0 ? a !== r : i === "equals" || r !== void 0 ? a === r : !!a;
}
const oi = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  h6: "H6",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell",
  carousel: "Carousel",
  "Card Container": "Card Container",
  title: "Title",
  price: "Price",
  "Retailer Icons": "Retailer Icons",
  image: "Image"
};
function En(e) {
  return oi[e] || e;
}
function ni(e, t) {
  const [n, r] = j("desktop"), [i, a] = j(""), [l, d] = j(null), [p, h] = j(
    /* @__PURE__ */ new Set()
  ), g = pe(
    () => e.some((I) => I.responsive),
    [e]
  ), b = pe(() => n === "mobile" && g ? e.filter((I) => I.responsive).map(
    (I) => ({
      ...I,
      key: `mobile_${I.key}`,
      label: I.label
    })
  ).filter((I) => ao(I.condition, t)) : e.filter((I) => !I.key.startsWith("mobile_")).filter((I) => ao(I.condition, t)), [e, n, g, t]), B = pe(() => {
    const I = [], v = {};
    return b.forEach((k) => {
      if (k.group)
        v[k.group] || (v[k.group] = []), v[k.group].push(k);
      else {
        const T = k.key.match(/^elementStyles\.([^.]+)\./);
        if (T) {
          const A = T[1];
          v[A] || (v[A] = []), v[A].push(k);
        } else
          I.push(k);
      }
    }), { baseFields: I, groups: v };
  }, [b]), z = pe(() => {
    const I = [];
    return I.push({
      name: "All",
      key: "__all__",
      count: b.length
    }), B.baseFields.length > 0 && I.push({
      name: "General",
      key: "__general__",
      count: B.baseFields.length
    }), Object.entries(B.groups).forEach(([v, k]) => {
      I.push({
        name: En(v),
        key: v,
        count: k.length
      });
    }), I;
  }, [b, B]), C = z.length > 3, x = C || b.length >= 8, f = me(
    (I, v) => v ? I.label.toLowerCase().includes(v) || (I.group ? I.group.toLowerCase().includes(v) : !1) || I.key.toLowerCase().includes(v) : !0,
    []
  ), S = pe(() => {
    const I = i.toLowerCase().trim();
    let v = B.baseFields, k = { ...B.groups };
    if (I) {
      v = v.filter((A) => f(A, I));
      const T = {};
      Object.entries(k).forEach(([A, P]) => {
        const W = P.filter((w) => f(w, I));
        W.length > 0 && (T[A] = W);
      }), k = T;
    }
    return l && l !== "__all__" && (l === "__general__" ? k = {} : (v = [], k = k[l] ? { [l]: k[l] } : {})), { baseFields: v, groups: k };
  }, [B, i, l, f]), F = pe(() => {
    const I = i.toLowerCase().trim();
    if (!I) return null;
    const v = {};
    return v.__general__ = B.baseFields.filter(
      (k) => f(k, I)
    ).length, Object.entries(B.groups).forEach(([k, T]) => {
      v[k] = T.filter((A) => f(A, I)).length;
    }), v.__all__ = Object.values(v).reduce((k, T) => k + T, 0), v;
  }, [i, B, f]), m = S.baseFields.length + Object.values(S.groups).reduce(
    (I, v) => I + v.length,
    0
  ), H = !l || l === "__all__", y = me((I) => {
    h((v) => {
      const k = new Set(v);
      return k.has(I) ? k.delete(I) : k.add(I), k;
    });
  }, []);
  return {
    activeTab: n,
    setActiveTab: r,
    hasResponsiveFields: g,
    searchQuery: i,
    setSearchQuery: a,
    activeCategory: l,
    setActiveCategory: d,
    categoryList: z,
    hasSidebar: C,
    hasSearchBar: x,
    displayedGroupedFields: S,
    totalDisplayedFields: m,
    isShowingAllCategories: H,
    searchMatchCounts: F,
    collapsedGroups: p,
    toggleGroupCollapse: y
  };
}
function ri(e) {
  return `
    @keyframes edit-panel-slideIn {
      from {
        opacity: 0;
        transform: translateY(-8px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    .edit-panel-close {
      transition: all 0.15s ease;
    }

    .edit-panel-close:hover {
      background-color: ${c.overlay_light};
      color: ${c.primary};
      transform: scale(1.1);
    }

    .edit-panel-input:focus,
    .edit-panel-select:focus {
      border-color: ${c.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
    }

    .edit-panel-input:hover:not(:focus),
    .edit-panel-select:hover:not(:focus) {
      border-color: ${c.gray_border};
    }

    .edit-panel-color-text:focus {
      border-color: ${c.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
      background: ${c.white};
    }

    .edit-panel-color-swatch:hover {
      border-color: ${c.gray_border};
      transform: scale(1.05);
    }

    .edit-panel-reset-field:hover {
      opacity: 1 !important;
      color: ${c.blue} !important;
    }

    .drag-handle {
      cursor: ${e ? "grabbing" : "grab"};
      transition: background-color 0.15s ease;
    }

    .drag-handle:hover {
      background-color: ${c.overlay_light};
    }

    .edit-panel-save-button {
      background: linear-gradient(135deg, ${c.blue} 0%, ${c.blue_dark} 100%);
      color: ${c.white};
      border: none;
      padding: 10px 18px;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.15s ease;
      box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
      letter-spacing: 0.3px;
    }

    .edit-panel-save-button:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
    }

    .edit-panel-save-button:active:not(:disabled) {
      transform: translateY(0);
    }

    .edit-panel-save-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    /* Custom scrollbar for fields area */
    .edit-panel-content::-webkit-scrollbar {
      width: 6px;
    }

    .edit-panel-content::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-content::-webkit-scrollbar-thumb {
      background: ${c.gray_border};
      border-radius: 3px;
    }

    .edit-panel-content::-webkit-scrollbar-thumb:hover {
      background: ${c.gray_medium};
    }

    /* Custom scrollbar for sidebar */
    .edit-panel-sidebar::-webkit-scrollbar {
      width: 4px;
    }

    .edit-panel-sidebar::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-sidebar::-webkit-scrollbar-thumb {
      background: ${c.gray_border};
      border-radius: 2px;
    }

    .edit-panel-sidebar-item {
      transition: all 0.12s ease;
    }

    .edit-panel-sidebar-item:hover {
      background-color: rgba(85, 114, 183, 0.08) !important;
    }

    .edit-panel-search:focus {
      border-color: ${c.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.08);
    }

    .edit-panel-group-header {
      cursor: pointer;
      transition: color 0.12s ease;
      user-select: none;
    }

    .edit-panel-group-header:hover {
      color: ${c.blue} !important;
    }

    /* Reset client-site global CSS that applies min-width to buttons */
    .edit-panel-root button {
      min-width: 0;
    }
  `;
}
const ii = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, ai = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, li = (e, t, n) => {
  switch (e) {
    case "primary":
      return {
        background: n ? c.blue_dark : t ? `linear-gradient(135deg, ${c.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${c.blue_dark} 0%, #1f2463 100%)`,
        color: c.white,
        border: "none",
        boxShadow: t ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: n ? c.gray_border : c.gray_light,
        color: c.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: n ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : t ? `linear-gradient(135deg, ${c.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${c.red} 0%, #e63e37 100%)`,
        color: c.white,
        border: "none",
        boxShadow: t ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: n ? "rgba(0, 0, 0, 0.08)" : t ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: c.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: n ? c.blue_light : t ? "rgba(24, 29, 86, 0.04)" : c.white,
        color: c.blue_dark,
        border: `2px solid ${c.blue_dark}`,
        boxShadow: "none",
        transform: t && !n ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: n ? "rgba(0, 0, 0, 0.1)" : t ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: c.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, oe = Qt(
  ({
    variant: e = "primary",
    size: t = "md",
    leftIcon: n,
    rightIcon: r,
    isLoading: i = !1,
    pill: a = !1,
    disabled: l,
    children: d,
    style: p,
    ...h
  }, g) => {
    const [b, B] = j(!1), [z, C] = j(!1), x = l || i, f = e === "icon" ? ai[t] : ii[t], S = a ? "200px" : f.borderRadius, F = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: x ? "not-allowed" : "pointer",
      opacity: x ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...f,
      borderRadius: S,
      ...li(
        e,
        !x && b,
        !x && z
      ),
      ...p
    };
    return /* @__PURE__ */ o(
      "button",
      {
        ref: g,
        disabled: x,
        style: F,
        onMouseEnter: () => B(!0),
        onMouseLeave: () => {
          B(!1), C(!1);
        },
        onMouseDown: () => C(!0),
        onMouseUp: () => C(!1),
        ...h,
        children: i ? /* @__PURE__ */ o(si, { size: t }) : /* @__PURE__ */ u($, { children: [
          n && /* @__PURE__ */ o(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          ),
          d,
          r && /* @__PURE__ */ o(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: r
            }
          )
        ] })
      }
    );
  }
);
oe.displayName = "Button";
const si = ({ size: e }) => {
  const t = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ u(
    "svg",
    {
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ o("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ o(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, rt = ({
  title: e,
  message: t,
  confirmLabel: n = "Save",
  cancelLabel: r = "Discard",
  dismissLabel: i = "Cancel",
  onConfirm: a,
  onCancel: l,
  onDismiss: d,
  isLoading: p = !1
}) => {
  const h = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${c.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${c.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${c.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .confirm-dialog-actions-right {
          display: flex;
          gap: 12px;
        }

        /* Reset client-site global CSS that applies min-width to buttons */
        .confirm-dialog-container button {
          min-width: 0;
        }
      ` }),
    /* @__PURE__ */ o("div", { className: "confirm-dialog-overlay", onClick: l, children: /* @__PURE__ */ u(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (g) => g.stopPropagation(),
        children: [
          /* @__PURE__ */ o("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ o("p", { className: "confirm-dialog-message", children: t }),
          /* @__PURE__ */ u("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ o("div", { children: d && /* @__PURE__ */ o(
              oe,
              {
                variant: "ghost",
                size: "sm",
                onClick: d,
                disabled: p,
                children: i
              }
            ) }),
            /* @__PURE__ */ u("div", { className: "confirm-dialog-actions-right", children: [
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: l,
                  disabled: p,
                  children: r
                }
              ),
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "primary",
                  size: "sm",
                  onClick: a,
                  isLoading: p,
                  disabled: p,
                  children: n
                }
              )
            ] })
          ] })
        ]
      }
    ) })
  ] });
  return je.createPortal(h, bt());
}, ci = ({
  displayName: e,
  isDirty: t,
  isSaving: n,
  onReset: r,
  onSave: i,
  onClose: a,
  handleMouseDown: l
}) => /* @__PURE__ */ u(
  "div",
  {
    className: "drag-handle",
    onMouseDown: l,
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${c.border_glass}`,
      borderRadius: "20px 20px 0 0",
      userSelect: "none"
    },
    children: [
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flex: 1
          },
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "3px",
                  opacity: 0.3
                },
                children: [...Array(6)].map((d, p) => /* @__PURE__ */ o(
                  "div",
                  {
                    style: {
                      width: "4px",
                      height: "4px",
                      background: c.gray_medium,
                      borderRadius: "1px"
                    }
                  },
                  p
                ))
              }
            ),
            /* @__PURE__ */ o(
              "h3",
              {
                style: {
                  fontSize: "13px",
                  fontWeight: 600,
                  color: c.primary,
                  margin: 0,
                  letterSpacing: "0.2px"
                },
                children: e || "Edit Properties"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ u("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
        t && r && /* @__PURE__ */ o(
          oe,
          {
            variant: "ghost",
            size: "sm",
            onClick: r,
            disabled: n,
            "aria-label": "Reset changes",
            leftIcon: /* @__PURE__ */ o(zn, { size: 14 }),
            children: "Reset"
          }
        ),
        t && i && /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            size: "sm",
            onClick: i,
            disabled: n,
            isLoading: n,
            "aria-label": "Save changes",
            type: "submit",
            children: "Save"
          }
        ),
        /* @__PURE__ */ o(oe, { variant: "icon", size: "md", onClick: a, "aria-label": "Close", children: /* @__PURE__ */ o(Ge, { size: 18 }) })
      ] })
    ]
  }
), di = ({
  searchQuery: e,
  setSearchQuery: t,
  searchInputRef: n
}) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      padding: "12px 20px",
      borderBottom: `1px solid ${c.border_glass}`
    },
    children: /* @__PURE__ */ u("div", { style: { position: "relative" }, children: [
      /* @__PURE__ */ o(
        yt,
        {
          size: 14,
          style: {
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: c.gray_medium,
            pointerEvents: "none"
          }
        }
      ),
      /* @__PURE__ */ o(
        "input",
        {
          ref: n,
          type: "text",
          value: e,
          onChange: (r) => t(r.target.value),
          onKeyDown: (r) => {
            var i;
            r.key === "Escape" && (t(""), (i = n.current) == null || i.blur());
          },
          placeholder: "Search properties...",
          className: "edit-panel-search",
          style: {
            width: "100%",
            padding: "8px 30px 8px 32px",
            fontSize: "12px",
            border: `1px solid ${c.border_glass}`,
            borderRadius: "10px",
            background: c.bg_light,
            color: c.primary,
            outline: "none",
            transition: "border-color 0.15s, box-shadow 0.15s",
            fontFamily: "inherit",
            boxSizing: "border-box"
          }
        }
      ),
      e && /* @__PURE__ */ o(
        "button",
        {
          onClick: () => {
            var r;
            t(""), (r = n.current) == null || r.focus();
          },
          style: {
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "inline-flex",
            alignItems: "center",
            color: c.gray_medium
          },
          children: /* @__PURE__ */ o(Ge, { size: 12 })
        }
      )
    ] })
  }
), pi = ({
  activeTab: e,
  setActiveTab: t
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      gap: "0",
      padding: "0 20px",
      borderBottom: `1px solid ${c.border_glass}`
    },
    children: [
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => t("desktop"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "desktop" ? `2px solid ${c.blue}` : "2px solid transparent",
            color: e === "desktop" ? c.blue : c.gray_medium,
            fontSize: "12px",
            fontWeight: e === "desktop" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ o(In, { size: 14 }),
            "Desktop"
          ]
        }
      ),
      /* @__PURE__ */ u(
        "button",
        {
          onClick: () => t("mobile"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "mobile" ? `2px solid ${c.blue}` : "2px solid transparent",
            color: e === "mobile" ? c.blue : c.gray_medium,
            fontSize: "12px",
            fontWeight: e === "mobile" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ o(Fn, { size: 14 }),
            "Mobile"
          ]
        }
      )
    ]
  }
), gi = ({
  categoryList: e,
  activeCategory: t,
  setActiveCategory: n,
  searchMatchCounts: r
}) => /* @__PURE__ */ o(
  "div",
  {
    className: "edit-panel-sidebar",
    style: {
      width: "160px",
      minWidth: "160px",
      borderRight: `1px solid ${c.border_glass}`,
      overflowY: "auto",
      padding: "8px 0"
    },
    children: e.map((i) => {
      const a = t === i.key || !t && i.key === "__all__", l = r ? r[i.key] ?? 0 : i.count, d = r !== null && l === 0;
      return /* @__PURE__ */ u(
        "button",
        {
          className: "edit-panel-sidebar-item",
          onClick: () => n(
            a && i.key !== "__all__" ? null : i.key
          ),
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "7px 16px 7px 20px",
            background: a ? "rgba(85, 114, 183, 0.1)" : "none",
            border: "none",
            borderLeft: a ? `3px solid ${c.blue}` : "3px solid transparent",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: a ? 600 : 500,
            color: a ? c.blue : c.gray_medium,
            textAlign: "left",
            opacity: d ? 0.35 : 1,
            fontFamily: "inherit"
          },
          children: [
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                children: i.name
              }
            ),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: "10px",
                  fontWeight: 500,
                  color: a ? c.blue : c.gray_border,
                  marginLeft: "6px",
                  flexShrink: 0
                },
                children: r ? l : i.count
              }
            )
          ]
        },
        i.key
      );
    })
  }
), mi = ({ value: e, onChange: t }) => {
  const [n, r] = j(e || "");
  return X(() => {
    r(e || "");
  }, [e]), /* @__PURE__ */ o(
    "input",
    {
      type: "text",
      value: n,
      onChange: (a) => {
        const l = a.target.value;
        r(l), t(l);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${c.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: c.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: c.white,
        outline: "none"
      }
    }
  );
}, ui = ({
  value: e,
  onChange: t,
  field: n
}) => {
  var r, i;
  return /* @__PURE__ */ o(
    "select",
    {
      value: e ?? ((i = (r = n.options) == null ? void 0 : r[0]) == null ? void 0 : i.value) ?? "",
      onChange: (a) => t(a.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${c.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: c.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: c.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (n.options ?? []).map((a) => /* @__PURE__ */ o("option", { value: a.value, children: a.label }, a.value))
    }
  );
};
function ft() {
  return (ft = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function An(e, t) {
  if (e == null) return {};
  var n, r, i = {}, a = Object.keys(e);
  for (r = 0; r < a.length; r++) t.indexOf(n = a[r]) >= 0 || (i[n] = e[n]);
  return i;
}
function Et(e) {
  var t = le(e), n = le(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var it = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, ot = function(e) {
  return "touches" in e;
}, At = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, lo = function(e, t, n) {
  var r = e.getBoundingClientRect(), i = ot(t) ? function(a, l) {
    for (var d = 0; d < a.length; d++) if (a[d].identifier === l) return a[d];
    return a[0];
  }(t.touches, n) : t;
  return { left: it((i.pageX - (r.left + At(e).pageXOffset)) / r.width), top: it((i.pageY - (r.top + At(e).pageYOffset)) / r.height) };
}, so = function(e) {
  !ot(e) && e.preventDefault();
}, Hn = ye.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = An(e, ["onMove", "onKey"]), i = le(null), a = Et(t), l = Et(n), d = le(null), p = le(!1), h = pe(function() {
    var z = function(f) {
      so(f), (ot(f) ? f.touches.length > 0 : f.buttons > 0) && i.current ? a(lo(i.current, f, d.current)) : x(!1);
    }, C = function() {
      return x(!1);
    };
    function x(f) {
      var S = p.current, F = At(i.current), m = f ? F.addEventListener : F.removeEventListener;
      m(S ? "touchmove" : "mousemove", z), m(S ? "touchend" : "mouseup", C);
    }
    return [function(f) {
      var S = f.nativeEvent, F = i.current;
      if (F && (so(S), !function(H, y) {
        return y && !ot(H);
      }(S, p.current) && F)) {
        if (ot(S)) {
          p.current = !0;
          var m = S.changedTouches || [];
          m.length && (d.current = m[0].identifier);
        }
        F.focus(), a(lo(F, S, d.current)), x(!0);
      }
    }, function(f) {
      var S = f.which || f.keyCode;
      S < 37 || S > 40 || (f.preventDefault(), l({ left: S === 39 ? 0.05 : S === 37 ? -0.05 : 0, top: S === 40 ? 0.05 : S === 38 ? -0.05 : 0 }));
    }, x];
  }, [l, a]), g = h[0], b = h[1], B = h[2];
  return X(function() {
    return B;
  }, [B]), ye.createElement("div", ft({}, r, { onTouchStart: g, onMouseDown: g, className: "react-colorful__interactive", ref: i, onKeyDown: b, tabIndex: 0, role: "slider" }));
}), _t = function(e) {
  return e.filter(Boolean).join(" ");
}, Ln = function(e) {
  var t = e.color, n = e.left, r = e.top, i = r === void 0 ? 0.5 : r, a = _t(["react-colorful__pointer", e.className]);
  return ye.createElement("div", { className: a, style: { top: 100 * i + "%", left: 100 * n + "%" } }, ye.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, be = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, hi = function(e) {
  return Ci(Ht(e));
}, Ht = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? be(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? be(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, yi = function(e) {
  return xi(fi(e));
}, bi = function(e) {
  var t = e.s, n = e.v, r = e.a, i = (200 - t) * n / 100;
  return { h: be(e.h), s: be(i > 0 && i < 200 ? t * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: be(i / 2), a: be(r, 2) };
}, Lt = function(e) {
  var t = bi(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, fi = function(e) {
  var t = e.h, n = e.s, r = e.v, i = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var a = Math.floor(t), l = r * (1 - n), d = r * (1 - (t - a) * n), p = r * (1 - (1 - t + a) * n), h = a % 6;
  return { r: be(255 * [r, d, l, l, p, r][h]), g: be(255 * [p, r, r, d, l, l][h]), b: be(255 * [l, l, p, r, r, d][h]), a: be(i, 2) };
}, lt = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, xi = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, a = i < 1 ? lt(be(255 * i)) : "";
  return "#" + lt(t) + lt(n) + lt(r) + a;
}, Ci = function(e) {
  var t = e.r, n = e.g, r = e.b, i = e.a, a = Math.max(t, n, r), l = a - Math.min(t, n, r), d = l ? a === t ? (n - r) / l : a === n ? 2 + (r - t) / l : 4 + (t - n) / l : 0;
  return { h: be(60 * (d < 0 ? d + 6 : d)), s: be(a ? l / a * 100 : 0), v: be(a / 255 * 100), a: i };
}, ki = ye.memo(function(e) {
  var t = e.hue, n = e.onChange, r = _t(["react-colorful__hue", e.className]);
  return ye.createElement("div", { className: r }, ye.createElement(Hn, { onMove: function(i) {
    n({ h: 360 * i.left });
  }, onKey: function(i) {
    n({ h: it(t + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": be(t), "aria-valuemax": "360", "aria-valuemin": "0" }, ye.createElement(Ln, { className: "react-colorful__hue-pointer", left: t / 360, color: Lt({ h: t, s: 100, v: 100, a: 1 }) })));
}), vi = ye.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: Lt({ h: t.h, s: 100, v: 100, a: 1 }) };
  return ye.createElement("div", { className: "react-colorful__saturation", style: r }, ye.createElement(Hn, { onMove: function(i) {
    n({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    n({ s: it(t.s + 100 * i.left, 0, 100), v: it(t.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + be(t.s) + "%, Brightness " + be(t.v) + "%" }, ye.createElement(Ln, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: Lt(t) })));
}), Rn = function(e, t) {
  if (e === t) return !0;
  for (var n in e) if (e[n] !== t[n]) return !1;
  return !0;
}, wi = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || Rn(Ht(e), Ht(t));
};
function Si(e, t, n) {
  var r = Et(n), i = j(function() {
    return e.toHsva(t);
  }), a = i[0], l = i[1], d = le({ color: t, hsva: a });
  X(function() {
    if (!e.equal(t, d.current.color)) {
      var h = e.toHsva(t);
      d.current = { hsva: h, color: t }, l(h);
    }
  }, [t, e]), X(function() {
    var h;
    Rn(a, d.current.hsva) || e.equal(h = e.fromHsva(a), d.current.color) || (d.current = { hsva: a, color: h }, r(h));
  }, [a, e, r]);
  var p = me(function(h) {
    l(function(g) {
      return Object.assign({}, g, h);
    });
  }, []);
  return [a, p];
}
var Bi = typeof window < "u" ? mr : X, Ii = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, co = /* @__PURE__ */ new Map(), Pi = function(e) {
  Bi(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !co.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, co.set(t, n);
      var r = Ii();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, zi = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, i = r === void 0 ? n.defaultColor : r, a = e.onChange, l = An(e, ["className", "colorModel", "color", "onChange"]), d = le(null);
  Pi(d);
  var p = Si(n, i, a), h = p[0], g = p[1], b = _t(["react-colorful", t]);
  return ye.createElement("div", ft({}, l, { ref: d, className: b }), ye.createElement(vi, { hsva: h, onChange: g }), ye.createElement(ki, { hue: h.h, onChange: g, className: "react-colorful__last-control" }));
}, Fi = { defaultColor: "000", toHsva: hi, fromHsva: function(e) {
  return yi({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: wi }, Ti = function(e) {
  return ye.createElement(zi, ft({}, e, { colorModel: Fi }));
};
const po = (e) => {
  const t = e.startsWith("#") ? e : `#${e}`, n = t.slice(0, 7).padEnd(7, "0"), r = t.slice(7, 9) || "ff", i = parseInt(r, 16), a = Math.round(i / 255 * 100);
  return { hex: n, opacity: a };
}, Ye = (e, t) => {
  const n = Math.round(t / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${n}`;
}, go = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, Nn = ({
  value: e,
  onChange: t,
  className: n
}) => {
  const { hex: r, opacity: i } = po(
    e || "#000000ff"
  ), [a, l] = j(r), [d, p] = j(i), [h, g] = j(
    i < 100 ? e || "#000000ff" : r
  );
  X(() => {
    const { hex: x, opacity: f } = po(
      e || "#000000ff"
    );
    l(x), p(f), g(f < 100 ? e || "#000000ff" : x);
  }, [e]);
  const b = (x) => {
    l(x), g(d < 100 ? Ye(x, d) : x), t(Ye(x, d));
  }, B = (x) => {
    const f = x.target.value;
    g(f);
    const S = go(f);
    if (S)
      if (S.length === 9) {
        const F = S.slice(0, 7), m = S.slice(7, 9), H = parseInt(m, 16), y = Math.round(H / 255 * 100);
        l(F), p(y), t(S);
      } else
        l(S), t(Ye(S, d));
  }, z = () => {
    const x = go(h);
    if (x)
      if (x.length === 9)
        g(x);
      else {
        const f = Ye(x, d);
        g(d < 100 ? f : x);
      }
    else {
      const f = Ye(a, d);
      g(d < 100 ? f : a);
    }
  }, C = (x) => {
    const f = parseInt(x.target.value, 10);
    p(f);
    const S = Ye(a, f);
    t(S), g(f < 100 ? S : a);
  };
  return /* @__PURE__ */ u("div", { className: `bc-color-picker ${n || ""}`, children: [
    /* @__PURE__ */ o("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${c.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${c.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${c.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${c.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${c.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${a} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${c.white};
          border: 2px solid ${c.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${c.white};
          border: 2px solid ${c.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${c.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ o(Ti, { color: a, onChange: b }),
    /* @__PURE__ */ o(
      "input",
      {
        type: "text",
        value: h,
        onChange: B,
        onBlur: z,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ u("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ o(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: d,
          onChange: C,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${a} 100%)`
          }
        }
      ),
      /* @__PURE__ */ o("span", { className: "bc-color-picker-opacity-value", children: d })
    ] })
  ] });
}, Mi = "data:image/png;base64,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", Rt = ({
  color: e,
  size: t = 32,
  borderRadius: n = 4,
  className: r,
  style: i
}) => /* @__PURE__ */ u(
  "div",
  {
    className: r,
    style: {
      position: "relative",
      width: t,
      height: t,
      borderRadius: n,
      overflow: "hidden",
      ...i
    },
    children: [
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Mi})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), Ei = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), s = (e) => ({
  type: "theme",
  value: e
}), q = (e) => ({
  type: "custom",
  value: e
}), Qe = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, mo = (e) => {
  const t = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(t) ? `#${t.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(t) ? `#${t.toLowerCase()}` : null;
}, Ai = ({
  value: e,
  onChange: t,
  field: n,
  themeColors: r,
  openColorPicker: i,
  setOpenColorPicker: a
}) => {
  const d = Ei(e) && e.type === "theme" ? e.value : "", p = pe(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return Qe(e);
    if (e.type === "custom")
      return Qe(e.value);
    if (e.type === "theme") {
      const k = r[e.value];
      return k ? Qe(k) : "#000000ff";
    }
    return "#000000ff";
  }, [e, r]), h = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), g = (k) => {
    if (k === "") {
      const T = h();
      t({ type: "custom", value: T });
    } else
      t({ type: "theme", value: k });
  }, b = (k) => {
    t({ type: "custom", value: k });
  }, B = i === n.key, z = p, C = le(null), x = le(null), [f, S] = ye.useState(!1), F = (k) => {
    const T = Qe(k);
    return T.length === 9 && T.slice(7, 9).toLowerCase() === "ff" ? T.slice(0, 7) : T;
  }, [m, H] = j(() => F(z));
  X(() => {
    H(F(p));
  }, [p]);
  const y = (k) => {
    const T = k.target.value;
    H(T);
    const A = mo(T);
    if (A) {
      const P = Qe(A);
      b(P);
    }
  }, I = () => {
    const k = mo(m);
    if (!k)
      H(F(z));
    else {
      const T = Qe(k);
      H(F(T));
    }
  }, v = 300;
  return X(() => {
    if (B && x.current) {
      const k = x.current.getBoundingClientRect(), A = window.innerHeight - k.bottom, P = k.top;
      S(A < v && P > A);
    }
  }, [B]), X(() => {
    if (!B) return;
    const k = (T) => {
      C.current && !C.current.contains(T.target) && a(null);
    };
    return document.addEventListener("mousedown", k, !0), () => {
      document.removeEventListener("mousedown", k, !0);
    };
  }, [B, a]), /* @__PURE__ */ u(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ u(
          "select",
          {
            value: d,
            onChange: (k) => g(k.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${c.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: c.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: c.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ o("option", { value: "", children: "Custom" }),
              Object.keys(r).map((k) => /* @__PURE__ */ o("option", { value: k, children: k }, k))
            ]
          }
        ),
        /* @__PURE__ */ u("div", { ref: C, style: { position: "relative" }, children: [
          /* @__PURE__ */ o(
            "button",
            {
              ref: x,
              type: "button",
              onClick: () => a(B ? null : n.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${c.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: c.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ o(
                Rt,
                {
                  color: z,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          B && /* @__PURE__ */ o(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...f ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: c.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${c.shadow_medium}, 0 0 0 1px ${c.border_glass}`
              },
              onClick: (k) => k.stopPropagation(),
              children: /* @__PURE__ */ o(
                Nn,
                {
                  value: z,
                  onChange: b
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            value: m,
            onChange: y,
            onBlur: I,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${c.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: c.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: c.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (k) => k.target.select()
          }
        )
      ]
    }
  );
}, Hi = ({
  value: e,
  onChange: t,
  field: n
}) => /* @__PURE__ */ o(
  "input",
  {
    type: "number",
    value: e || 0,
    min: n.min,
    max: n.max,
    step: n.step || 1,
    onChange: (r) => t(parseFloat(r.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${c.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: c.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: c.white,
      outline: "none"
    }
  }
), Li = ({ value: e, onChange: t }) => {
  const n = !!e;
  return /* @__PURE__ */ o(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": n,
      onClick: () => t(!n),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: n ? c.blue : c.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: n ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ o(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: c.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, Ri = ({
  value: e,
  onChange: t,
  themeFonts: n
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "inherit",
    onChange: (r) => t(r.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${c.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: c.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: c.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ o("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(n).map(([r, i]) => /* @__PURE__ */ o("option", { value: r, children: i.name }, r))
    ]
  }
), Nt = "bc-widget-panel-opened", Wt = "bc-widget-upload-icon-request", Wn = (e) => {
  const t = new CustomEvent(Nt, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(t);
}, Dn = (e) => {
  const t = (n) => {
    e(n.detail.widgetId);
  };
  return document.addEventListener(Nt, t), () => {
    document.removeEventListener(Nt, t);
  };
}, Ni = () => {
  const e = new CustomEvent(Wt, { bubbles: !0 });
  document.dispatchEvent(e);
}, Wi = (e) => {
  const t = () => {
    e();
  };
  return document.addEventListener(Wt, t), () => {
    document.removeEventListener(Wt, t);
  };
}, uo = "__upload_new__", Di = ({
  value: e,
  onChange: t,
  themeIcons: n
}) => /* @__PURE__ */ u(
  "select",
  {
    value: e || "default",
    onChange: (i) => {
      const a = i.target.value;
      if (a === uo) {
        Ni();
        return;
      }
      t(a);
    },
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${c.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: c.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: c.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ o("option", { value: "default", children: "Default" }),
      Object.entries(n).map(([i, a]) => /* @__PURE__ */ o("option", { value: i, children: a.name }, i)),
      /* @__PURE__ */ o("option", { value: uo, children: "Upload new..." })
    ]
  }
);
function Oi(e, t) {
  const n = t.values[e.key];
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ o(
        mi,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "options":
      return /* @__PURE__ */ o(
        ui,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "color":
      return /* @__PURE__ */ o(
        Ai,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeColors: t.themeColors,
          openColorPicker: t.openColorPicker,
          setOpenColorPicker: t.setOpenColorPicker
        }
      );
    case "number":
      return /* @__PURE__ */ o(
        Hi,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "toggle":
      return /* @__PURE__ */ o(
        Li,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e
        }
      );
    case "font":
      return /* @__PURE__ */ o(
        Ri,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeFonts: t.themeFonts
        }
      );
    case "icon":
      return /* @__PURE__ */ o(
        Di,
        {
          value: n,
          onChange: (r) => t.onChange(e.key, r),
          field: e,
          themeIcons: t.themeIcons
        }
      );
    default:
      return null;
  }
}
const ji = (e) => {
  const { field: t, savedKeys: n, studioLockedKeys: r, onResetField: i } = e, a = n == null ? void 0 : n.has(t.key), l = r == null ? void 0 : r.has(t.key);
  return /* @__PURE__ */ u(
    "div",
    {
      style: {
        minWidth: 0,
        opacity: l ? 0.5 : 1,
        pointerEvents: l ? "none" : void 0
      },
      children: [
        /* @__PURE__ */ u(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: 600,
              color: c.gray_medium,
              marginBottom: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            },
            children: [
              t.label,
              l && /* @__PURE__ */ o(
                "span",
                {
                  title: "Edit this property from Concierge Studio",
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    color: c.blue,
                    marginLeft: "2px",
                    flexShrink: 0,
                    cursor: "help",
                    pointerEvents: "auto"
                  },
                  children: /* @__PURE__ */ o(Jt, { size: 10 })
                }
              ),
              !l && a && i && /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => i(t.key),
                  title: "Reset to default",
                  className: "edit-panel-reset-field",
                  style: {
                    background: "none",
                    border: "none",
                    padding: "1px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    color: c.gray_medium,
                    opacity: 0.5,
                    transition: "opacity 0.15s, color 0.15s",
                    marginLeft: "2px",
                    flexShrink: 0
                  },
                  children: /* @__PURE__ */ o(zn, { size: 10 })
                }
              )
            ]
          }
        ),
        Oi(t, e)
      ]
    }
  );
}, ho = ({ label: e, count: t, isCollapsed: n, onClick: r, marginBottom: i }) => /* @__PURE__ */ u(
  "button",
  {
    className: "edit-panel-group-header",
    onClick: r,
    style: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "12px",
      fontWeight: 700,
      color: c.primary,
      margin: 0,
      padding: 0,
      paddingBottom: "8px",
      marginBottom: i ?? 0,
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
      borderBottom: `2px solid ${c.border_glass}`,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      background: "none",
      width: "100%",
      textAlign: "left",
      fontFamily: "inherit"
    },
    children: [
      n ? /* @__PURE__ */ o(ht, { size: 14 }) : /* @__PURE__ */ o(Sr, { size: 14 }),
      e,
      /* @__PURE__ */ o(
        "span",
        {
          style: {
            fontSize: "10px",
            fontWeight: 500,
            color: c.gray_medium,
            marginLeft: "auto"
          },
          children: t
        }
      )
    ]
  }
), yo = ({
  fields: e,
  itemProps: t
}) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px"
    },
    children: e.map((n) => /* @__PURE__ */ o(ji, { field: n, ...t }, n.key))
  }
), Gi = ({
  displayedGroupedFields: e,
  totalDisplayedFields: t,
  isShowingAllCategories: n,
  collapsedGroups: r,
  toggleGroupCollapse: i,
  searchQuery: a,
  setSearchQuery: l,
  fieldItemProps: d
}) => {
  if (t === 0)
    return /* @__PURE__ */ o(
      "div",
      {
        className: "edit-panel-content",
        style: {
          padding: "16px 20px 20px",
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 20px",
              color: c.gray_medium,
              gap: "8px"
            },
            children: [
              /* @__PURE__ */ o(yt, { size: 24, style: { opacity: 0.3 } }),
              /* @__PURE__ */ o("span", { style: { fontSize: "12px", fontWeight: 500 }, children: "No matching properties" }),
              a && /* @__PURE__ */ o(
                "button",
                {
                  onClick: () => l(""),
                  style: {
                    background: "none",
                    border: `1px solid ${c.border_glass}`,
                    borderRadius: "8px",
                    padding: "6px 12px",
                    fontSize: "11px",
                    color: c.blue,
                    cursor: "pointer",
                    fontFamily: "inherit",
                    marginTop: "4px"
                  },
                  children: "Clear search"
                }
              )
            ]
          }
        )
      }
    );
  const p = Object.keys(e.groups).length > 0;
  return /* @__PURE__ */ o(
    "div",
    {
      className: "edit-panel-content",
      style: {
        padding: "16px 20px 20px",
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1
      },
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          },
          children: [
            e.baseFields.length > 0 && /* @__PURE__ */ u($, { children: [
              n && p && /* @__PURE__ */ o(
                ho,
                {
                  label: "General",
                  count: e.baseFields.length,
                  isCollapsed: r.has("__general__"),
                  onClick: () => i("__general__")
                }
              ),
              (!n || !r.has("__general__") || !p) && /* @__PURE__ */ o(
                yo,
                {
                  fields: e.baseFields,
                  itemProps: d
                }
              )
            ] }),
            Object.entries(e.groups).map(
              ([h, g]) => {
                const b = n && r.has(h);
                return /* @__PURE__ */ u("div", { children: [
                  n && /* @__PURE__ */ o(
                    ho,
                    {
                      label: En(h),
                      count: g.length,
                      isCollapsed: b,
                      onClick: () => i(h),
                      marginBottom: b ? 0 : "16px"
                    }
                  ),
                  !b && /* @__PURE__ */ o(yo, { fields: g, itemProps: d })
                ] }, h);
              }
            )
          ]
        }
      )
    }
  );
}, On = ({
  displayName: e,
  fields: t,
  values: n,
  initialValues: r,
  onChange: i,
  onClose: a,
  onReset: l,
  screenPosition: d,
  onSave: p,
  isSaving: h = !1,
  savedKeys: g,
  studioLockedKeys: b,
  onResetField: B,
  themeColors: z = {},
  themeFonts: C = {},
  themeIcons: x = {}
}) => {
  const { dragOffset: f, isDragging: S, handleMouseDown: F } = ti(), m = le(null), H = le(null), [y, I] = j(null), [v, k] = j(!1), {
    activeTab: T,
    setActiveTab: A,
    hasResponsiveFields: P,
    searchQuery: W,
    setSearchQuery: w,
    activeCategory: M,
    setActiveCategory: O,
    categoryList: J,
    hasSidebar: L,
    hasSearchBar: R,
    displayedGroupedFields: D,
    totalDisplayedFields: N,
    isShowingAllCategories: Y,
    searchMatchCounts: G,
    collapsedGroups: K,
    toggleGroupCollapse: Q
  } = ni(t, n), _ = pe(() => r ? JSON.stringify(n) !== JSON.stringify(r) : !1, [n, r]), re = () => {
    _ ? k(!0) : a();
  }, V = () => {
    k(!1), l && l(), a();
  }, ne = () => {
    k(!1), a();
  }, ee = async () => {
    p && p(), k(!1);
  };
  X(() => {
    if (!y) return;
    const xe = Mt(), ze = (we) => {
      const Ae = we.target;
      !Ae.closest(".edit-panel-color-popover") && !Ae.closest(".edit-panel-color-swatch") && I(null);
    };
    return xe.addEventListener("mousedown", ze, !0), () => {
      xe.removeEventListener("mousedown", ze, !0);
    };
  }, [y]), X(() => {
    if (!Mn()) return;
    const xe = Mt(), ze = "edit-panel-styles";
    if (!xe.getElementById(ze)) {
      const we = xe.createElement("style");
      we.id = ze, we.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, xe.head.appendChild(we);
    }
    return () => {
      const we = xe.getElementById(ze);
      we && we.remove();
    };
  }, []);
  const fe = {
    values: n,
    onChange: i,
    savedKeys: g,
    studioLockedKeys: b,
    onResetField: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    openColorPicker: y,
    setOpenColorPicker: I
  }, De = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: ri(S) }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: m,
        className: "edit-panel-root",
        style: {
          position: "fixed",
          top: d.y + f.y,
          left: d.x + f.x,
          background: c.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${c.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${c.shadow_medium},
            0 20px 60px ${c.shadow_soft},
            0 0 0 1px ${c.border_glass}
          `,
          zIndex: 999999,
          width: L ? "800px" : "620px",
          maxWidth: L ? "800px" : "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (xe) => xe.stopPropagation(),
        onMouseDown: (xe) => xe.stopPropagation(),
        children: [
          /* @__PURE__ */ o(
            ci,
            {
              displayName: e,
              isDirty: _,
              isSaving: h,
              onReset: l,
              onSave: p,
              onClose: re,
              handleMouseDown: F
            }
          ),
          R && /* @__PURE__ */ o(
            di,
            {
              searchQuery: W,
              setSearchQuery: w,
              searchInputRef: H
            }
          ),
          P && /* @__PURE__ */ o(pi, { activeTab: T, setActiveTab: A }),
          /* @__PURE__ */ u("div", { style: { display: "flex", flex: 1, overflow: "hidden" }, children: [
            L && /* @__PURE__ */ o(
              gi,
              {
                categoryList: J,
                activeCategory: M,
                setActiveCategory: O,
                searchMatchCounts: G
              }
            ),
            /* @__PURE__ */ o(
              Gi,
              {
                displayedGroupedFields: D,
                totalDisplayedFields: N,
                isShowingAllCategories: Y,
                collapsedGroups: K,
                toggleGroupCollapse: Q,
                searchQuery: W,
                setSearchQuery: w,
                fieldItemProps: fe
              }
            )
          ] })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ u($, { children: [
    je.createPortal(De, bt()),
    v && /* @__PURE__ */ o(
      rt,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: ee,
        onCancel: V,
        onDismiss: ne,
        isLoading: h
      }
    )
  ] });
}, ce = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken",
  PREVIEW_MODE: "bc_previewMode",
  APP_ID: "bc_appId",
  SCOPE: "bc_scope"
}, $i = (e, t, n, r, i, a) => {
  try {
    e ? localStorage.setItem(ce.THEME_ID, e) : localStorage.removeItem(ce.THEME_ID), localStorage.setItem(ce.EDIT_MODE, String(t)), n ? localStorage.setItem(ce.EDIT_THEME_TOKEN, n) : localStorage.removeItem(ce.EDIT_THEME_TOKEN), localStorage.setItem(ce.PREVIEW_MODE, String(!!r)), i ? localStorage.setItem(ce.APP_ID, i) : localStorage.removeItem(ce.APP_ID), a ? localStorage.setItem(ce.SCOPE, a) : localStorage.removeItem(ce.SCOPE);
  } catch (l) {
    console.error("Failed to save theme params to localStorage:", l);
  }
}, Yi = () => {
  try {
    return {
      themeId: localStorage.getItem(ce.THEME_ID),
      editMode: localStorage.getItem(ce.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(ce.EDIT_THEME_TOKEN),
      previewMode: localStorage.getItem(ce.PREVIEW_MODE) === "true",
      appId: localStorage.getItem(ce.APP_ID),
      scope: localStorage.getItem(ce.SCOPE)
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null,
      previewMode: !1,
      appId: null,
      scope: null
    };
  }
}, wt = () => {
  try {
    localStorage.removeItem(ce.THEME_ID), localStorage.removeItem(ce.EDIT_MODE), localStorage.removeItem(ce.EDIT_THEME_TOKEN), localStorage.removeItem(ce.PREVIEW_MODE), localStorage.removeItem(ce.APP_ID), localStorage.removeItem(ce.SCOPE);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Qi = () => {
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("themeId"), n = e.get("editMode") === "true", r = e.get("editThemeToken"), i = e.get("previewMode") === "true", a = e.get("appId"), l = e.get("scope");
    (t || a && l) && $i(t, n, r, i, a, l), Ji();
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, Xi = /* @__PURE__ */ new Set(["off", "shim", "consume"]), Ji = () => {
  try {
    if (typeof window > "u") return;
    const t = new URLSearchParams(window.location.search).get("brandapp-v2");
    t && Xi.has(t) && !window.localStorage.getItem("brandapp-v2") && window.localStorage.setItem("brandapp-v2", t);
  } catch (e) {
    console.error("Failed to persist brandapp-v2 URL flag:", e);
  }
}, St = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), e.searchParams.delete("previewMode"), e.searchParams.delete("origin"), e.searchParams.delete("appId"), e.searchParams.delete("scope"), e.searchParams.delete("brandapp-v2"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, Ms = (e, t, n) => {
  try {
    const r = new URL(window.location.href);
    e ? (r.searchParams.set("themeId", e), r.searchParams.set("editMode", String(t)), n ? r.searchParams.set("editThemeToken", n) : r.searchParams.delete("editThemeToken")) : (r.searchParams.delete("themeId"), r.searchParams.delete("editMode"), r.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", r.toString());
  } catch (r) {
    console.error("Failed to update URL params:", r);
  }
}, bo = () => {
  const e = new URLSearchParams(window.location.search), t = e.get("themeId"), n = e.get("editMode"), r = e.get("editThemeToken"), i = e.get("origin"), a = e.get("previewMode"), l = e.get("appId"), d = e.get("scope"), p = Yi(), h = a === "true" || a === null && p.previewMode;
  return {
    themeId: t || p.themeId,
    editMode: !h && (n === "true" || n === null && p.editMode),
    editThemeToken: r || p.editThemeToken,
    origin: i,
    previewMode: h,
    appId: l || p.appId,
    scope: d || p.scope
  };
}, Je = () => {
  const [e, t] = j(bo);
  return X(() => {
    const n = setTimeout(() => {
      const r = bo();
      t((i) => i.themeId !== r.themeId || i.editMode !== r.editMode || i.editThemeToken !== r.editThemeToken || i.origin !== r.origin || i.previewMode !== r.previewMode || i.appId !== r.appId || i.scope !== r.scope ? r : i);
    }, 0);
    return () => clearTimeout(n);
  }, []), e;
}, Zt = () => Je().editMode, Vt = ur(!1), Ui = ({ children: e }) => /* @__PURE__ */ o(Vt.Provider, { value: !0, children: e }), Es = ({ children: e }) => /* @__PURE__ */ o(Vt.Provider, { value: !1, children: e }), _i = () => hr(Vt), Zi = "/bc-checkout-shop-app/bc-checkout-shop-app.js";
function Vi(e) {
  return typeof e == "string" && e.toLowerCase().endsWith(".myshopify.com");
}
function qi(e) {
  return typeof e == "string" && e.toLowerCase().endsWith(".shopifypreview.com");
}
function Ki(e) {
  if (!e)
    return !1;
  try {
    const t = new URL(e);
    return t.pathname.endsWith(Zi) && t.searchParams.has("id");
  } catch {
    return !1;
  }
}
const ea = () => {
  const t = Array.from(document.getElementsByTagName("script")).find((r) => Ki(r.src));
  if (t != null && t.src)
    return new URL(t.src).origin;
  const n = window.location.hostname;
  if (Vi(n) || qi(n))
    throw new Error(
      "[brandclub] Could not resolve host domain for an embedded Shopify storefront. Ensure the checkout bundle is loaded from /bc-checkout-shop-app/bc-checkout-shop-app.js?id=<slug>."
    );
  return window.location.origin;
}, jn = ea(), Ce = `${jn}/api-rewards`;
jn.replace(/^https?:\/\//, "");
const Gn = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // UI colors
  borderColor: "#DCDCDC",
  buttonText: "#ffffff",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, ta = Object.keys(Gn), gt = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, fo = (e) => {
  const t = gt(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, xo = (e) => {
  const t = gt(e || "#000000");
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, Co = ({
  themeColors: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  isAddingColor: i,
  setIsAddingColor: a,
  newColorKey: l,
  setNewColorKey: d,
  newColorValue: p,
  setNewColorValue: h,
  onAddColor: g,
  onUpdateColor: b,
  onRenameColor: B,
  onDeleteColor: z,
  studioLockedColorKeys: C
}) => {
  const [x, f] = j(null), S = le({}), [F, m] = j({
    top: 0,
    left: 0,
    openAbove: !1
  }), [H, y] = j(null), [I, v] = j(null), [k, T] = j(null), A = le({}), [P, W] = j({
    top: 0,
    left: 0
  }), w = 300;
  X(() => {
    if (x && S.current[x]) {
      const N = S.current[x].getBoundingClientRect(), G = window.innerHeight - N.bottom, K = N.top, Q = G < w && K > G;
      m({
        top: Q ? N.top - 8 : N.bottom + 8,
        left: N.left + N.width / 2,
        openAbove: Q
      });
    }
  }, [x]), X(() => {
    if (!x) return;
    const N = (Y) => {
      const G = Y.target;
      !G.closest(".bc-theme-color-popover") && !G.closest(".bc-theme-color-swatch") && f(null);
    };
    return document.addEventListener("mousedown", N), () => {
      document.removeEventListener("mousedown", N);
    };
  }, [x]), X(() => {
    if (k && A.current[k]) {
      const N = A.current[k].getBoundingClientRect();
      W({
        top: N.bottom + 4,
        left: N.right
      });
    }
  }, [k]), X(() => {
    if (!k) return;
    const N = (Y) => {
      const G = Y.target;
      !G.closest(".bc-theme-color-dropdown") && !G.closest(".bc-theme-color-menu-btn") && T(null);
    };
    return document.addEventListener("mousedown", N), () => {
      document.removeEventListener("mousedown", N);
    };
  }, [k]);
  const M = (N, Y) => {
    y(N), v({ name: N, value: gt(Y) }), T(null), f(null);
  }, O = () => {
    y(null), v(null), f(null);
  }, J = async (N) => {
    if (!I) return;
    const { name: Y, value: G } = I, K = fo(G);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(K))
      return;
    Y.trim() && Y.trim() !== N && B && await B(N, Y.trim());
    const _ = fo(e[N]);
    if (K !== _) {
      const re = Y.trim() || N;
      await b(re, K);
    }
    y(null), v(null), f(null);
  }, L = (N) => {
    I && v({ ...I, value: N });
  }, R = (N) => {
    I && v({ ...I, name: N });
  }, D = (N, Y, G, K) => {
    const Q = x === N, _ = gt(Y), re = K && !r;
    return /* @__PURE__ */ u($, { children: [
      re ? /* @__PURE__ */ o(
        "button",
        {
          ref: (V) => {
            S.current[N] = V;
          },
          type: "button",
          onClick: () => f(Q ? null : N),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${c.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: c.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ o(
            Rt,
            {
              color: _,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${c.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: c.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ o(
            Rt,
            {
              color: _,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      Q && re && je.createPortal(
        /* @__PURE__ */ o(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: F.top,
              left: F.left,
              transform: F.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: c.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${c.shadow_medium}, 0 0 0 1px ${c.border_glass}`
            },
            onClick: (V) => V.stopPropagation(),
            children: /* @__PURE__ */ o(Nn, { value: _, onChange: G })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ o("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${c.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${c.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ o(
        ht,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: r && Object.keys(e).length === 0 ? /* @__PURE__ */ o("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([N, Y]) => {
        const G = H === N, K = ta.includes(N), Q = (C == null ? void 0 : C.has(N)) ?? !1, _ = k === N, re = G && I ? I.name : N, V = xo(G && I ? I.value : Y), ne = G && I ? I.value : Y;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ o(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: re,
                onChange: (ee) => G && R(ee.target.value),
                readOnly: !G,
                disabled: r,
                style: { cursor: G ? "text" : "default" }
              }
            ),
            D(
              N,
              ne,
              L,
              G
              // only editable when in edit mode
            ),
            G ? /* @__PURE__ */ o(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: V,
                onChange: (ee) => {
                  const fe = ee.target.value;
                  I && v({ ...I, value: fe });
                },
                disabled: r,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ o(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: V
              }
            ),
            Q && !G && /* @__PURE__ */ o(
              "span",
              {
                title: "Edit this color from Concierge Studio",
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  color: c.blue,
                  padding: "4px",
                  cursor: "help"
                },
                children: /* @__PURE__ */ o(Jt, { size: 14 })
              }
            ),
            !G && !Q && /* @__PURE__ */ o(
              "button",
              {
                ref: (ee) => {
                  A.current[N] = ee;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => T(_ ? null : N),
                disabled: r,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: c.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ o(Mr, { size: 16 })
              }
            ),
            _ && je.createPortal(
              /* @__PURE__ */ u(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: P.top,
                    left: P.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: c.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${c.shadow_medium}, 0 0 0 1px ${c.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (ee) => ee.stopPropagation(),
                  children: [
                    /* @__PURE__ */ o(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => M(N, Y),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: c.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => ee.currentTarget.style.background = c.gray_light,
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ o(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          T(null), z(N);
                        },
                        disabled: K,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: K ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: K ? c.gray_medium : c.red,
                          opacity: K ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => {
                          K || (ee.currentTarget.style.background = c.gray_light);
                        },
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          G && /* @__PURE__ */ u(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ o(nt, { size: 12 }),
                    onClick: () => J(N),
                    disabled: r,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: O,
                    disabled: r,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, N);
      }),
      i ? /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: l,
            onChange: (N) => d(N.target.value),
            disabled: r,
            autoFocus: !0
          }
        ),
        D(
          "__new_color__",
          p,
          h,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ o(nt, { size: 12 }),
            onClick: g,
            disabled: r || !l.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              a(!1), d(""), h("#000000ff");
            },
            disabled: r,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ o(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ o(Ut, { size: 12 }),
          onClick: () => a(!0),
          disabled: r,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, Te = () => {
  if (typeof window > "u") return null;
  try {
    const e = new URLSearchParams(window.location.search), t = e.get("appId"), n = e.get("scope"), r = e.get("editThemeToken");
    return !t || !n || !r ? null : { appId: t, scope: n, editThemeToken: r };
  } catch {
    return null;
  }
}, $n = (e) => `${Ce}/brandapp-v2/themes/${encodeURIComponent(e.appId)}/scopes/${encodeURIComponent(e.scope)}/draft`, Yn = async (e) => {
  const t = await fetch($n(e), {
    headers: { "x-edit-theme-token": e.editThemeToken }
  });
  if (!t.ok)
    throw new Error(`Failed to fetch V2 draft: ${t.status} ${t.statusText}`);
  const n = await t.json();
  return n ? {
    scope: n.scope ?? e.scope,
    version: n.version ?? "draft",
    data: n.data ?? {}
  } : { scope: e.scope, version: "draft", data: {} };
}, oa = async (e, t) => {
  const n = await fetch($n(e), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-edit-theme-token": e.editThemeToken
    },
    body: JSON.stringify({ themeData: t })
  });
  if (!n.ok)
    throw new Error(`Failed to save V2 draft: ${n.status} ${n.statusText}`);
  return n.json();
}, na = async (e, t) => {
  const n = `${Ce}/brandapp-v2/themes/${encodeURIComponent(e.appId)}/scopes/${encodeURIComponent(e.scope)}/asset-upload-url`, r = await fetch(n, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-edit-theme-token": e.editThemeToken
    },
    body: JSON.stringify(t)
  });
  if (!r.ok)
    throw new Error(`Failed to generate V2 asset upload URL: ${r.status} ${r.statusText}`);
  return r.json();
}, We = async (e, t) => {
  const { data: n } = await Yn(e), r = { ...n };
  return r.colors = { ...n.colors ?? {} }, r.fonts = { ...n.fonts ?? {} }, r.icons = { ...n.icons ?? {} }, r.widgetConfig = { ...n.widgetConfig ?? {} }, t(r), await oa(e, r), r;
}, Me = () => {
  var e;
  try {
    return typeof window > "u" ? !1 : !!((e = window.localStorage) != null && e.getItem("brandapp-v2"));
  } catch {
    return !1;
  }
}, ra = (e) => {
  const t = {};
  let n = !1;
  for (const [r, i] of Object.entries(e))
    typeof i == "string" && i.startsWith("#") ? (t[r] = { type: "custom", value: i }, n = !0) : t[r] = i;
  return { migrated: t, needsMigration: n };
}, ia = (e) => {
  const t = {};
  for (const [n, r] of Object.entries(Gn))
    n in e || (t[n] = r);
  return t;
}, Ze = {
  shadow: /* @__PURE__ */ new Set(["8px 8px 14px 0px rgba(0, 0, 0, 0.03)", "8px 8px 14px 0 rgba(0, 0, 0, 0.03)", "8px 8px 6px 0px rgba(0, 0, 0, 0.02)"]),
  borderColor: /* @__PURE__ */ new Set(["*"])
}, Qn = {
  "concierge-sidebar": {
    logoIconSize: /* @__PURE__ */ new Set([20, 22, 32]),
    avatarSize: /* @__PURE__ */ new Set([20, 22]),
    composeIconSize: /* @__PURE__ */ new Set([18]),
    sidebarIconSize: /* @__PURE__ */ new Set([20, 28]),
    avatarFontSize: /* @__PURE__ */ new Set([8]),
    chatHistoryTitleFontSize: /* @__PURE__ */ new Set([14, 16]),
    labelFontSize: /* @__PURE__ */ new Set([14, 16]),
    collapsedWidth: /* @__PURE__ */ new Set([40])
  },
  "concierge-home-greeting": {
    greetingFontSize: /* @__PURE__ */ new Set([28]),
    greetingFontFamily: /* @__PURE__ */ new Set(["*"]),
    greetingMarginBottom: /* @__PURE__ */ new Set([8, 24])
  },
  "concierge-home-subtitle": {
    fontSize: /* @__PURE__ */ new Set([32]),
    fontFamily: /* @__PURE__ */ new Set(["*"])
  },
  "product-card-carousel": {
    titleLineClamp: /* @__PURE__ */ new Set([2]),
    titleFontSize: /* @__PURE__ */ new Set([18]),
    titleLineHeight: /* @__PURE__ */ new Set([1.333]),
    showRetailers: /* @__PURE__ */ new Set([!1])
  },
  "concierge-chat-input": Ze,
  "concierge-panel-chat-input": Ze,
  "concierge-conversation-chat-input": Ze,
  "concierge-panel-conversation-chat-input": Ze,
  "chat-input": Ze
}, aa = (e, t) => {
  const n = Qn[e];
  if (!n) return { migrated: t, needsMigration: !1 };
  const r = { ...t };
  let i = !1;
  for (const [a, l] of Object.entries(n))
    a in r && (l.has("*") || l.has(r[a])) && (delete r[a], i = !0);
  return { migrated: r, needsMigration: i };
}, pt = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let t = !1;
  const n = { ...e };
  n.config || (n.config = {});
  const r = n.config.colors || {}, i = ia(r);
  if (Object.keys(i).length > 0 && (n.config.colors = { ...r, ...i }, t = !0), n.config.widgetConfig) {
    const a = {};
    for (const [l, d] of Object.entries(
      n.config.widgetConfig
    )) {
      let p = d;
      const { migrated: h, needsMigration: g } = ra(p);
      if (p = h, g && (t = !0), l in Qn) {
        const { migrated: b, needsMigration: B } = aa(l, p);
        p = b, B && (t = !0);
      }
      a[l] = p;
    }
    n.config.widgetConfig = a;
  }
  return { processedTheme: n, needsUpdate: t };
}, Xn = async (e, t) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (n) {
    console.error(`Failed to migrate theme ${e}:`, n);
  }
}, la = async (e) => {
  const t = await fetch(
    `${Ce}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch widget theme");
  const n = await t.json(), { processedTheme: r, needsUpdate: i } = pt(n);
  return i && Xn(e, r.config), r;
}, sa = async (e) => {
  if (Me()) {
    const a = Te();
    if (a)
      try {
        const { data: g } = await Yn(a);
        if (g && Object.keys(g).length > 0) {
          const b = { config: g }, { processedTheme: B } = pt(b);
          return B;
        }
      } catch {
      }
    const l = await fetch(
      `${Ce}/brandapp-v2/get-theme-by-scope?scope=widget`
    );
    if (!l.ok)
      throw new Error("Failed to fetch published widget theme");
    const d = await l.json();
    if (!(d != null && d.data)) return null;
    const p = { config: d.data }, { processedTheme: h } = pt(p);
    return h;
  }
  const t = await fetch(
    `${Ce}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!t.ok)
    throw new Error("Failed to fetch published widget theme");
  const n = await t.json(), { processedTheme: r, needsUpdate: i } = pt(n);
  return i && (r != null && r.appThemeId) && Xn(
    r.appThemeId,
    r.config
  ), r;
}, ca = async ({
  themeId: e,
  editThemeToken: t
}) => {
  try {
    const n = await fetch(
      `${Ce}/brand-app-widget-theme/validate-edit-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          appThemeId: e,
          editThemeToken: t
        })
      }
    );
    return n.ok ? (await n.json()).valid === !0 : !1;
  } catch {
    return !1;
  }
}, Jn = async ({
  themeId: e,
  widgetId: t,
  widgetState: n,
  editThemeToken: r
}) => {
  const i = Te();
  if (i && Me())
    return { config: await We(i, (d) => {
      const p = d.widgetConfig[t] ?? {};
      d.widgetConfig[t] = { ...p, ...n };
    }) };
  const a = await fetch(
    `${Ce}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: t,
        widgetState: n,
        editThemeToken: r
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to update widget config";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, ko = async ({
  themeId: e,
  colorKey: t,
  colorValue: n,
  editThemeToken: r
}) => {
  const i = Te();
  if (i && Me())
    return { config: await We(i, (d) => {
      d.colors[t] = n;
    }) };
  const a = await fetch(
    `${Ce}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        colorValue: n,
        editThemeToken: r
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme color";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, da = async ({
  themeId: e,
  colorKey: t,
  editThemeToken: n
}) => {
  const r = Te();
  if (r && Me())
    return { config: await We(r, (l) => {
      delete l.colors[t];
    }) };
  const i = await fetch(
    `${Ce}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: t,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to delete theme color";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, pa = async ({
  themeId: e,
  oldColorKey: t,
  newColorKey: n,
  editThemeToken: r
}) => {
  const i = Te();
  if (i && Me())
    return { config: await We(i, (d) => {
      t in d.colors && (d.colors[n] = d.colors[t], delete d.colors[t]);
    }) };
  const a = await fetch(
    `${Ce}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: t,
        newColorKey: n,
        editThemeToken: r
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to rename theme color";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, vo = async ({
  themeId: e,
  fileName: t,
  contentType: n,
  assetType: r,
  editThemeToken: i
}) => {
  const a = Te();
  if (a && Me())
    return na(a, { fileName: t, contentType: n, assetType: r });
  const l = await fetch(
    `${Ce}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: t,
        contentType: n,
        assetType: r,
        editThemeToken: i
      })
    }
  );
  if (!l.ok) {
    let p = "Failed to generate upload URL";
    try {
      const h = await l.json();
      p = h.errorMessage || h.message || p;
    } catch {
    }
    throw new Error(p);
  }
  const d = await l.json();
  if (d.status === "failed")
    throw new Error(d.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: d.signedUploadUrl,
    objectPublicUrl: d.objectPublicUrl
  };
}, wo = async ({
  file: e,
  signedUploadUrl: t
}) => {
  if (!(await fetch(t, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, ga = async ({
  themeId: e,
  fontKey: t,
  fontValue: n,
  editThemeToken: r
}) => {
  const i = Te();
  if (i && Me())
    return { config: await We(i, (d) => {
      d.fonts[t] = n;
    }) };
  const a = await fetch(
    `${Ce}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        fontValue: n,
        editThemeToken: r
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme font";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, ma = async ({
  themeId: e,
  fontKey: t,
  editThemeToken: n
}) => {
  const r = Te();
  if (r && Me())
    return { config: await We(r, (l) => {
      delete l.fonts[t];
    }) };
  const i = await fetch(
    `${Ce}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: t,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to delete theme font";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, ua = async ({
  themeId: e,
  iconKey: t,
  iconValue: n,
  editThemeToken: r
}) => {
  const i = Te();
  if (i && Me())
    return { config: await We(i, (d) => {
      d.icons[t] = n;
    }) };
  const a = await fetch(
    `${Ce}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        iconValue: n,
        editThemeToken: r
      })
    }
  );
  if (!a.ok) {
    let l = "Failed to set theme icon";
    try {
      l = (await a.json()).message || l;
    } catch {
    }
    throw new Error(l);
  }
  return a.json();
}, ha = async ({
  themeId: e,
  iconKey: t,
  editThemeToken: n
}) => {
  const r = Te();
  if (r && Me())
    return { config: await We(r, (l) => {
      delete l.icons[t];
    }) };
  const i = await fetch(
    `${Ce}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: t,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let a = "Failed to delete theme icon";
    try {
      a = (await i.json()).message || a;
    } catch {
    }
    throw new Error(a);
  }
  return i.json();
}, Oe = ["bc-widget-theme"], Un = "bc-theme-updated";
let Bt = null, So = !1;
const ya = (e) => {
  Bt = e, X(() => {
    if (So) return;
    So = !0;
    const t = (n) => {
      var i;
      if (n.origin !== window.location.origin || ((i = n.data) == null ? void 0 : i.type) !== Un || !Bt) return;
      const { themeId: r } = n.data.payload;
      Bt.refetchQueries({
        queryKey: [...Oe, r]
      });
    };
    window.addEventListener("message", t);
  }, []);
}, Se = () => {
  const e = Je(), t = Xt();
  return ya(t), yr({
    queryKey: [...Oe, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return la(e.themeId);
      const n = window.location.hostname;
      return sa(n);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, qt = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = Se();
  return {
    themeColors: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.colors) || {},
    isLoading: t,
    refreshThemeColors: async () => {
      await n();
    }
  };
}, _n = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = Se();
  return {
    themeFonts: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.fonts) || {},
    isLoading: t,
    refreshThemeFonts: async () => {
      await n();
    }
  };
}, Zn = () => {
  var r;
  const { data: e, isLoading: t, refetch: n } = Se();
  return {
    themeIcons: ((r = e == null ? void 0 : e.config) == null ? void 0 : r.icons) || {},
    isLoading: t,
    refreshThemeIcons: async () => {
      await n();
    }
  };
}, ba = (e, t) => {
  var a, l;
  const { data: n, isLoading: r } = Se(), i = e ? (l = (a = n == null ? void 0 : n.config) == null ? void 0 : a.widgetConfig) == null ? void 0 : l[e] : void 0;
  return {
    ...t,
    ...i,
    isLoading: r,
    savedKeys: new Set(i ? Object.keys(i) : [])
  };
}, Dt = (e) => {
  const t = Xt(), n = Je();
  return { updateWidgetConfig: (l, d) => {
    e && t.setQueryData(
      [...Oe, n.themeId],
      (p) => {
        var h, g, b;
        return p ? {
          ...p,
          config: {
            ...p == null ? void 0 : p.config,
            widgetConfig: {
              ...(h = p == null ? void 0 : p.config) == null ? void 0 : h.widgetConfig,
              [e]: {
                ...(b = (g = p == null ? void 0 : p.config) == null ? void 0 : g.widgetConfig) == null ? void 0 : b[e],
                [l]: d
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [l]: d
              }
            }
          }
        };
      }
    );
  }, removeWidgetConfigKey: (l) => {
    e && t.setQueryData(
      [...Oe, n.themeId],
      (d) => {
        var g, b;
        if (!((b = (g = d == null ? void 0 : d.config) == null ? void 0 : g.widgetConfig) != null && b[e])) return d;
        const { [l]: p, ...h } = d.config.widgetConfig[e];
        return {
          ...d,
          config: {
            ...d.config,
            widgetConfig: {
              ...d.config.widgetConfig,
              [e]: h
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var d, p;
    if (!e) return;
    const l = t.getQueryData([
      ...Oe,
      n.themeId
    ]);
    return (p = (d = l == null ? void 0 : l.config) == null ? void 0 : d.widgetConfig) == null ? void 0 : p[e];
  } };
}, As = () => {
  const { data: e } = Se();
  return e == null ? void 0 : e.studioAvailability;
}, Hs = () => {
  const { data: e } = Se();
  return e == null ? void 0 : e.studioAgentName;
}, Ls = () => {
  const { data: e } = Se();
  return e == null ? void 0 : e.studioAgreement;
}, Fe = {
  softBackgroundHex: "#ECFDF5",
  // emerald-50
  borderHex: "#A7F3D0",
  // emerald-200
  accentDotHex: "#10B981",
  // emerald-500
  textHex: "#047857",
  // emerald-700
  teamLabel: "Support Team",
  pausedFooterCopy: "You're chatting with support team. Concierge is paused.",
  takeoverPlaceholder: "Message {firstName}…",
  deliveredCopy: "Delivered to Support Team",
  teamAvatarUrl: ""
}, Rs = () => {
  var n, r, i, a;
  const { data: e } = Se(), t = e == null ? void 0 : e.studioSupportBranding;
  return t ? {
    softBackgroundHex: t.softBackgroundHex || Fe.softBackgroundHex,
    borderHex: t.borderHex || Fe.borderHex,
    accentDotHex: t.accentDotHex || Fe.accentDotHex,
    textHex: t.textHex || Fe.textHex,
    teamLabel: ((n = t.teamLabel) == null ? void 0 : n.trim()) || Fe.teamLabel,
    pausedFooterCopy: ((r = t.pausedFooterCopy) == null ? void 0 : r.trim()) || Fe.pausedFooterCopy,
    takeoverPlaceholder: ((i = t.takeoverPlaceholder) == null ? void 0 : i.trim()) || Fe.takeoverPlaceholder,
    deliveredCopy: ((a = t.deliveredCopy) == null ? void 0 : a.trim()) || Fe.deliveredCopy,
    teamAvatarUrl: t.teamAvatarUrl ?? Fe.teamAvatarUrl
  } : Fe;
}, fa = (e, t = 32, n = 4) => {
  const r = window.innerWidth, i = window.innerHeight, a = r < 768, l = e.left, d = r - e.right, p = e.top, h = i - e.bottom, g = t + n, b = l >= g, B = d >= g, z = p >= g, C = h >= g;
  let x = "top-left", f = {};
  return a ? B && z ? (x = "top-right", f = {
    top: e.top - n,
    left: e.right - t + n
  }) : B && C ? (x = "bottom-right", f = {
    top: e.bottom - t + n,
    left: e.right - t + n
  }) : b && z ? (x = "top-left", f = {
    top: e.top - n,
    left: e.left - n
  }) : b && C ? (x = "bottom-left", f = {
    top: e.bottom - t + n,
    left: e.left - n
  }) : (x = "top-right", f = {
    top: e.top + n,
    left: e.right - t - n
  }) : b && z ? (x = "top-left", f = {
    top: e.top - n,
    left: e.left - n
  }) : B && z ? (x = "top-right", f = {
    top: e.top - n,
    left: e.right - t + n
  }) : b && C ? (x = "bottom-left", f = {
    top: e.bottom - t + n,
    left: e.left - n
  }) : B && C ? (x = "bottom-right", f = {
    top: e.bottom - t + n,
    left: e.right - t + n
  }) : (x = "top-left", f = {
    top: e.top + n,
    left: e.left + n
  }), { position: x, style: f };
}, U = ({
  children: e,
  widgetId: t,
  displayName: n,
  editFields: r,
  editValues: i,
  onEditChange: a,
  onSave: l,
  isSaving: d = !1,
  savedKeys: p,
  studioLockedKeys: h,
  onResetField: g,
  themeColors: b = {},
  themeFonts: B = {},
  themeIcons: z = {},
  triggerMode: C = "hover",
  triggerIcon: x = "pencil",
  triggerPosition: f = "bottom-right",
  triggerLabel: S,
  wrapperStyle: F,
  containerClassName: m,
  iconOffset: H
}) => {
  const { data: y } = Se(), I = /* @__PURE__ */ new Set(), [v, k] = j(!1), [T, A] = j({ x: 0, y: 0 }), [P, W] = j(null), [w, M] = j(!1), [O, J] = j(null), [L, R] = j(!1), [D, N] = j(!1), Y = le(null), G = le(null), K = le(null), Q = Zt(), _ = _i(), re = (C === "persistent" || L || D) && !v, V = me(() => {
    if (K.current) {
      const Z = K.current.getBoundingClientRect();
      if (C === "persistent") {
        const ke = S ? 160 : 28, ae = {};
        f.includes("top") ? ae.top = Z.top + 12 : ae.top = Z.bottom - 32 - 12, f.includes("right") ? ae.left = Z.right - ke - 12 : ae.left = Z.left + 12, J(ae);
      } else {
        const { style: ue } = fa(Z);
        H && (H.top && (ue.top = (ue.top ?? 0) + H.top), H.left && (ue.left = (ue.left ?? 0) + H.left)), J(ue);
      }
    }
  }, [C, f, H]);
  X(() => {
    if (!Q || !re) {
      J(null);
      return;
    }
    V();
    const Z = () => V();
    return window.addEventListener("scroll", Z, !0), window.addEventListener("resize", Z), () => {
      window.removeEventListener("scroll", Z, !0), window.removeEventListener("resize", Z);
    };
  }, [Q, re, V]);
  const ne = me(() => P ? JSON.stringify(i) !== JSON.stringify(P) : !1, [i, P]);
  if (X(() => t ? Dn((ue) => {
    ue !== t && v && (ne() ? M(!0) : k(!1));
  }) : void 0, [t, v, ne]), X(() => () => {
    Y.current && clearTimeout(Y.current);
  }, []), !Q || _)
    return /* @__PURE__ */ o($, { children: e });
  const ee = () => {
    if (G.current) {
      const Z = G.current.getBoundingClientRect(), ue = window.innerWidth, Be = window.innerHeight, ke = 620, ae = 450, he = 10, $e = Be - Z.bottom, Ue = Z.top, _e = ue - Z.left, xt = Z.right;
      let Ee;
      $e >= ae + he ? Ee = Z.bottom + he : Ue >= ae + he ? Ee = Z.top - ae - he : $e >= Ue ? Ee = Math.max(he, Be - ae - he) : Ee = Math.max(he, Z.top - ae - he);
      let ve;
      _e >= ke ? ve = Z.left : xt >= ke ? ve = Z.right - ke : ve = Math.max(he, Math.min(ue - ke - he, Z.left)), ve = Math.max(he, Math.min(ve, ue - ke - he)), Ee = Math.max(he, Math.min(Ee, Be - ae - he)), A({ x: ve, y: Ee });
    }
    (!P || JSON.stringify(i) === JSON.stringify(P)) && W({ ...i }), k(!0), t && Wn(t);
  }, fe = () => {
    P && Object.keys(P).forEach((Z) => {
      a(Z, P[Z]);
    });
  }, De = () => {
    l && l(), W({ ...i });
  }, xe = () => {
    fe(), M(!1), k(!1);
  }, ze = () => {
    De(), M(!1), k(!1);
  }, we = () => {
    M(!1), k(!1);
  }, Ae = () => {
    if (!O) return null;
    const Z = C === "persistent", ue = x === "gear" ? Tt : Pn, ke = Z && S ? (
      // Labeled button for persistent mode (more discoverable)
      /* @__PURE__ */ u(
        "button",
        {
          ref: G,
          style: {
            position: "fixed",
            top: O.top,
            left: O.left,
            height: 32,
            background: D ? c.blue_light : "rgba(255, 255, 255, 0.92)",
            border: `1px solid ${D ? c.blue : "rgba(0,0,0,0.12)"}`,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 12px 0 8px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            transition: "all 0.2s ease",
            transform: D ? "scale(1.03)" : "scale(1)",
            opacity: D ? 1 : 0.85,
            zIndex: 999998,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap"
          },
          onMouseDown: (ae) => ae.stopPropagation(),
          onClick: (ae) => {
            ae.stopPropagation(), ae.preventDefault(), ee();
          },
          onMouseEnter: () => {
            Y.current && (clearTimeout(Y.current), Y.current = null), N(!0);
          },
          onMouseLeave: () => N(!1),
          "aria-label": S,
          children: [
            /* @__PURE__ */ o(ue, { size: 14, color: D ? c.blue : c.gray_dark }),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: "11px",
                  fontWeight: 600,
                  color: D ? c.blue : c.gray_dark,
                  letterSpacing: "0.2px"
                },
                children: S
              }
            )
          ]
        }
      )
    ) : (
      // Icon-only button (standard for hover mode, compact for persistent without label)
      /* @__PURE__ */ o(
        "button",
        {
          ref: G,
          style: {
            position: "fixed",
            top: O.top,
            left: O.left,
            width: Z ? 28 : 32,
            height: Z ? 28 : 32,
            background: D ? c.blue_light : Z ? "rgba(255, 255, 255, 0.85)" : c.white,
            border: `1px solid ${D ? c.blue : Z ? "rgba(0,0,0,0.1)" : c.gray_border}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: Z ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "background 0.2s, border-color 0.2s, transform 0.2s, opacity 0.2s",
            transform: D ? "scale(1.05)" : "scale(1)",
            opacity: Z && !D ? 0.7 : 1,
            zIndex: 999998,
            padding: 0,
            minWidth: 0
          },
          onMouseDown: (ae) => ae.stopPropagation(),
          onClick: (ae) => {
            ae.stopPropagation(), ae.preventDefault(), ee();
          },
          onMouseEnter: () => {
            Y.current && (clearTimeout(Y.current), Y.current = null), N(!0);
          },
          onMouseLeave: () => N(!1),
          "aria-label": x === "gear" ? "Edit layout" : "Edit widget",
          children: /* @__PURE__ */ o(ue, { size: Z ? 14 : 16, color: c.gray_dark })
        }
      )
    );
    return je.createPortal(ke, document.body);
  };
  return /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        
        }

        .widget-wrapper.widget-fill-container,
        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${c.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${c.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        ref: K,
        className: `widget-wrapper${C === "persistent" ? " widget-fill-container" : ""}${m ? ` ${m}` : ""}${v ? " widget-editing" : re ? " widget-hovered" : ""}`,
        style: F,
        onMouseEnter: () => {
          Y.current && (clearTimeout(Y.current), Y.current = null), R(!0);
        },
        onMouseLeave: () => {
          Y.current = setTimeout(() => {
            R(!1);
          }, 200);
        },
        children: [
          e,
          v && /* @__PURE__ */ o(
            On,
            {
              widgetId: t,
              displayName: n,
              fields: r,
              values: i,
              initialValues: P || void 0,
              onChange: a,
              onClose: () => k(!1),
              onReset: fe,
              screenPosition: T,
              onSave: De,
              isSaving: d,
              savedKeys: p,
              studioLockedKeys: I,
              onResetField: g,
              themeColors: b,
              themeFonts: B,
              themeIcons: z
            }
          ),
          w && /* @__PURE__ */ o(
            rt,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: ze,
              onCancel: xe,
              onDismiss: we,
              isLoading: d
            }
          )
        ]
      }
    ),
    re && Ae()
  ] });
}, Vn = (e, t, n = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : t[e.value] ?? n : n, xa = (e) => (t, n = "#000000") => Vn(t, e, n), Ns = () => {
  const { themeColors: e } = qt();
  return me(
    (n, r = "#000000") => Vn(n, e, r),
    [e]
  );
};
function te(e, t, n) {
  const { isLoading: r, savedKeys: i, ...a } = ba(e, t), l = a, [d, p] = j(!1), { themeColors: h } = qt(), { themeFonts: g } = _n(), { themeIcons: b } = Zn(), B = pe(() => xa(h), [h]), { data: z } = Se(), C = /* @__PURE__ */ new Set(), x = Je(), { updateWidgetConfig: f, removeWidgetConfigKey: S, getWidgetState: F } = Dt(e), m = me(
    (T) => {
      S(T);
    },
    [S]
  ), H = pe(() => {
    const T = {};
    return n.forEach((A) => {
      T[A.key] = A.type, A.responsive && (T[`mobile_${A.key}`] = A.type);
    }), T;
  }, [n]), y = me(
    (T, A) => {
      if (C.has(T)) return;
      const P = H[T];
      let W = A;
      switch (P) {
        case "toggle":
          typeof A == "string" && (W = A === "true");
          break;
        case "number":
          if (typeof A == "string" && A !== "") {
            const w = parseFloat(A);
            isNaN(w) || (W = w);
          }
          break;
        case "options":
          typeof A == "string" && (A === "true" ? W = !0 : A === "false" ? W = !1 : /^\d+$/.test(A) && (W = parseInt(A, 10)));
          break;
      }
      f(T, W);
    },
    [H, f]
  ), I = !!(x.themeId && x.editThemeToken && e), v = me(async () => {
    if (!x.themeId || !x.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    p(!0);
    try {
      const T = F() || l;
      await Jn({
        themeId: x.themeId,
        widgetId: e,
        widgetState: T,
        editThemeToken: x.editThemeToken
      });
    } catch (T) {
      console.error("Failed to save widget config:", T), alert(`Failed to save: ${T.message}`);
    } finally {
      p(!1);
    }
  }, [x, e, F, l]), k = me(() => {
    const T = { ...l };
    return n.forEach((A) => {
      const P = T[A.key];
      A.type === "options" && (typeof P == "boolean" ? T[A.key] = P ? "true" : "false" : typeof P == "number" && (T[A.key] = String(P)));
    }), T;
  }, [l, n]);
  return {
    state: l,
    isLoading: r,
    isSaving: d,
    handleEditChange: y,
    handleSave: v,
    resetField: m,
    savedKeys: i,
    studioLockedKeys: C,
    themeColors: h,
    themeFonts: g,
    themeIcons: b,
    resolveColor: B,
    canSave: I,
    getEditValues: k
  };
}
const at = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], ge = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
at.slice(
  0,
  4
);
at.slice(1, 4);
const Ca = at.slice(0, 3), ka = {
  expanded: {
    fontSize: 16,
    iconSize: 24,
    iconGap: 12,
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: q("#DCDDDC"),
    borderColorFocus: s("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 28,
    borderWidth: 1,
    paddingX: 16,
    paddingY: 16,
    minHeight: 138,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 14,
    mobile_paddingY: 14,
    mobile_minHeight: 116,
    mobile_iconGap: 4,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20,
    mobile_borderRadiusSingleLine: 26,
    mobile_borderRadiusMultiLine: 26
  },
  compact: {
    fontSize: 16,
    iconSize: 24,
    iconGap: 12,
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: q("#DCDDDC"),
    borderColorFocus: s("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 28,
    borderWidth: 1,
    paddingX: 16,
    paddingY: 16,
    minHeight: 56,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 14,
    mobile_paddingY: 14,
    mobile_minHeight: 46,
    mobile_iconGap: 4,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20,
    mobile_borderRadiusSingleLine: 26,
    mobile_borderRadiusMultiLine: 26
  }
}, Ws = {
  expanded: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 6,
    backgroundColor: s("background"),
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: q("#DCDDDC"),
    borderColorFocus: q("#DCDDDC"),
    borderRadiusSingleLine: 20,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 18,
    paddingY: 18,
    minHeight: 116,
    mobile_paddingX: 16,
    mobile_paddingY: 16,
    mobile_minHeight: 116
  },
  compact: {
    fontSize: 14,
    iconSize: 20,
    iconGap: 6,
    backgroundColor: s("background"),
    shadowEnabled: !0,
    shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
    borderColor: q("#DCDDDC"),
    borderColorFocus: q("#DCDDDC"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 18,
    paddingY: 18,
    minHeight: 42,
    submitButtonSize: 24,
    mobile_fontSize: 14,
    mobile_paddingX: 16,
    mobile_paddingY: 16,
    mobile_minHeight: 42,
    mobile_iconGap: 6,
    mobile_iconSize: 20,
    mobile_submitButtonSize: 20
  }
}, va = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ve = {
  preset: "expanded",
  // Background
  backgroundColor: s("background"),
  shadowEnabled: !0,
  shadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
  // Border styling
  borderColor: q("#DCDDDC"),
  borderColorFocus: s("borderColor"),
  borderRadiusSingleLine: 28,
  borderRadiusMultiLine: 28,
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: s("textPrimary"),
  submitButtonBgColorHover: s("textPrimary"),
  submitButtonIconColor: s("background"),
  submitButtonSize: 24,
  submitButtonBorderRadius: 12,
  // Action icons (attachment, mic)
  iconColor: s("textPrimary"),
  iconColorHover: s("tertiary"),
  iconSize: 24,
  iconGap: 12,
  micActiveColor: s("error"),
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 16,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: s("textPrimary"),
  placeholderColor: s("textTertiary"),
  // Layout — 24px horizontal padding, 56px min-height per design spec
  paddingX: 24,
  paddingY: 12,
  maxWidth: 768,
  minHeight: 56,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0,
  // Mobile overrides
  mobile_fontSize: 14,
  mobile_paddingX: 12,
  mobile_paddingY: 12,
  mobile_minHeight: 46,
  mobile_iconGap: 4,
  mobile_iconSize: 20,
  mobile_submitButtonSize: 20,
  mobile_borderRadiusSingleLine: 26,
  mobile_borderRadiusMultiLine: 26
}, Bo = [
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: [
      { label: "Expanded", value: "expanded" },
      { label: "Compact", value: "compact" },
      { label: "Custom", value: "custom" }
    ]
  },
  // Background
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "shadowEnabled", label: "Shadow", type: "toggle" },
  { key: "shadow", label: "Shadow Value (CSS)", type: "text" },
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1,
    responsive: !0
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1,
    responsive: !0
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "iconGap",
    label: "Icon Gap",
    type: "number",
    min: 4,
    max: 32,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ge
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 300,
    step: 10,
    responsive: !0
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], Ds = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  presets: r,
  children: i
}) => {
  const a = r ?? ka, {
    state: l,
    isLoading: d,
    isSaving: p,
    handleEditChange: h,
    handleSave: g,
    resetField: b,
    savedKeys: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    resolveColor: f,
    canSave: S,
    getEditValues: F
  } = te(t, { ...Ve, ...e }, Bo), m = me(
    (w, M) => {
      if (w === "preset" && M !== "custom") {
        const J = a[M];
        if (J) {
          h("preset", M), Object.entries(J).forEach(([L, R]) => {
            h(L, R);
          });
          return;
        }
      }
      w !== "preset" && h("preset", "custom"), h(w, M);
    },
    [h]
  ), H = l.fontFamily, y = H && H !== "inherit" ? C[H] : null, I = y && y.format === "google" ? y.url : null;
  if (X(() => {
    I && va(I);
  }, [I]), X(() => {
    !d && !B.has("iconGap") && (B.has("iconSize") && l.iconSize !== Ve.iconSize && m("iconSize", Ve.iconSize), B.has("submitButtonSize") && l.submitButtonSize !== Ve.submitButtonSize && m("submitButtonSize", Ve.submitButtonSize));
  }, [d]), d)
    return /* @__PURE__ */ o($, {});
  const v = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", k = y && y.format !== "system" && y.format !== "google", T = `chat-input-${t || "default"}`, A = `
    ${k ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
    ${v !== "inherit" ? `.${T} { font-family: ${v} !important; }` : ""}
  `.trim(), P = {
    ...l,
    fontFamilyCss: v
  }, W = /* @__PURE__ */ u($, { children: [
    A && /* @__PURE__ */ o("style", { children: A }),
    i(P, x, f)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Bo,
      editValues: F(),
      onEditChange: m,
      onSave: S ? g : void 0,
      isSaving: p,
      savedKeys: B,
      onResetField: b,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: W
    }
  );
}, Io = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, wa = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: s("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: s("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: s("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: s("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: s("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: s("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: {
    fontWeight: "600",
    backgroundColor: s("primary"),
    color: s("primaryForeground")
  },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: s("primaryForeground")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: s("textPrimary")
  }
}, Sa = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: s("background"),
  // blueWhite-like for user
  textColor: s("textPrimary"),
  // Border radius
  borderRadius: 23,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Single-line height
  singleLineHeight: 46,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Streaming cursor (pulsating dot) — defaults to textPrimary
  streamingCursorColor: s("textPrimary"),
  // Element styles with defaults
  elementStyles: wa
}, qe = (e, t, n) => {
  const r = `elementStyles.${e}`, i = [
    {
      key: `${r}.fontFamily`,
      label: `${t} Font`,
      type: "font"
    },
    {
      key: `${r}.fontSize`,
      label: `${t} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${r}.fontWeight`,
      label: `${t} Font Weight`,
      type: "options",
      options: at
    },
    {
      key: `${r}.color`,
      label: `${t} Color`,
      type: "color"
    }
  ];
  return n != null && n.includeBackgroundColor && i.push({
    key: `${r}.backgroundColor`,
    label: `${t} Background`,
    type: "color"
  }), i.push(
    {
      key: `${r}.lineHeight`,
      label: `${t} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${r}.marginTop`,
      label: `${t} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${r}.marginBottom`,
      label: `${t} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ), i;
}, Ke = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, qn = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "streamingCursorColor", label: "Streaming Cursor Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: Ca
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "singleLineHeight",
    label: "Single Line Height (px)",
    type: "number",
    min: 0,
    max: 80,
    step: 1
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], Ba = ["h1", "h2", "h3"], Ia = ["p", "blockquote"], Pa = ["li"], za = ["th", "td"], Fa = ["thead"], Ta = [
  ...Ba.flatMap(
    (e) => qe(e, Ke[e])
  ),
  ...Ia.flatMap(
    (e) => qe(e, Ke[e])
  ),
  ...Pa.flatMap(
    (e) => qe(e, Ke[e])
  ),
  ...Fa.flatMap(
    (e) => qe(e, Ke[e], {
      includeBackgroundColor: !0
    })
  ),
  ...za.flatMap(
    (e) => qe(e, Ke[e])
  )
], Ma = [...qn, ...Ta], Ea = (e, t, n, r) => {
  if (!t) return "";
  const i = [], a = [], l = /* @__PURE__ */ new Set();
  for (const [d, p] of Object.entries(t)) {
    if (!p) continue;
    const h = [];
    if (p.fontSize !== void 0 && h.push(`font-size: ${p.fontSize}px`), p.fontWeight !== void 0 && h.push(`font-weight: ${p.fontWeight}`), p.color && p.color !== "inherit") {
      const g = r(p.color);
      h.push(`color: ${g}`);
    }
    if (p.backgroundColor && p.backgroundColor !== "inherit" && p.backgroundColor !== "transparent") {
      const g = r(p.backgroundColor);
      h.push(`background-color: ${g}`);
    }
    if (p.lineHeight !== void 0 && h.push(`line-height: ${p.lineHeight}`), p.marginTop !== void 0 && h.push(`margin-top: ${p.marginTop}px`), p.marginBottom !== void 0 && h.push(`margin-bottom: ${p.marginBottom}px`), p.fontFamily && p.fontFamily !== "inherit") {
      const g = n[p.fontFamily];
      g && (g.format === "system" ? h.push(`font-family: ${g.url}`) : (h.push(`font-family: "${g.name}", sans-serif`), g.format !== "google" && !l.has(g.name) && (a.push(`
              @font-face {
                font-family: "${g.name}";
                src: url("${g.url}") format("${g.format}");
                font-display: swap;
              }
            `), l.add(g.name))));
    }
    h.length > 0 && i.push(`#concierge-mount .${e} .message-content ${d},
#concierge-mount .${e} .message-content .message-markdown ${d},
.${e} .message-content ${d},
.${e} .message-content .message-markdown ${d} {
  ${h.join(`;
  `)};
}`);
  }
  return [...a, ...i].join(`

`);
}, Aa = (e, t, n) => {
  const r = t.split("."), i = { ...e };
  let a = i;
  for (let l = 0; l < r.length - 1; l++) {
    const d = r[l];
    a[d] = { ...a[d] }, a = a[d];
  }
  return a[r[r.length - 1]] = n, i;
}, Ha = (e) => {
  const t = {};
  for (const [n, r] of Object.entries(e))
    if (n === "elementStyles" && typeof r == "object" && r !== null) {
      for (const [i, a] of Object.entries(
        r
      ))
        if (a && typeof a == "object")
          for (const [l, d] of Object.entries(a))
            t[`elementStyles.${i}.${l}`] = d;
    } else
      t[n] = r;
  return t;
}, Os = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...Sa, ...e },
    qn
    // Only use base fields for type transformations
  ), z = (P, W) => {
    if (P.includes(".")) {
      const w = Aa(i, P, W), M = P.split(".")[0];
      d(M, w[M]);
    } else
      d(P, W);
  }, C = pe(() => Ha(i), [i]), x = i.fontFamily, f = x && x !== "inherit" ? g[x] : null, S = f && f.format === "google" ? f.url : null, F = pe(() => {
    const P = [];
    if (i.elementStyles) {
      for (const W of Object.values(i.elementStyles))
        if (W != null && W.fontFamily && W.fontFamily !== "inherit") {
          const w = g[W.fontFamily];
          (w == null ? void 0 : w.format) === "google" && w.url && !P.includes(w.url) && P.push(w.url);
        }
    }
    return P;
  }, [i.elementStyles, g]);
  X(() => {
    S && Io(S);
    for (const P of F)
      Io(P);
  }, [S, F]);
  const m = `message-bubble-${t || "default"}`, H = pe(
    () => Ea(
      m,
      i.elementStyles,
      g,
      b
    ),
    [m, i.elementStyles, g, b]
  );
  if (a)
    return /* @__PURE__ */ o($, {});
  const y = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", k = [`
    ${f && f.format !== "system" && f.format !== "google" ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${m} { font-family: ${y} !important; }` : ""}
  `.trim(), H].filter(Boolean).join(`

`), T = {
    ...i,
    fontFamilyCss: y
  }, A = /* @__PURE__ */ u("div", { className: m, children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(T, b)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Ma,
      editValues: C,
      onEditChange: z,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: A
    }
  );
}, js = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, La = {
  // Container
  containerBgColor: s("background"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: s("textPrimary"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: s("textPrimary"),
  statusFontSize: 12,
  statusMarginTop: 8
}, Po = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], Gs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    resolveColor: g,
    canSave: b
  } = te(
    t,
    { ...La, ...e },
    Po
  );
  if (a)
    return /* @__PURE__ */ o($, {});
  const B = r(i, g);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Po,
      editValues: i,
      onEditChange: d,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: h,
      children: B
    }
  );
}, zo = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, st = ({ width: e }) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Ra = {
  // Preset
  preset: "inline",
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 20,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: s("textPrimary"),
  // Title icon & behavior
  showSparkleIcon: !0,
  collapsible: !1,
  // Container
  containerGap: 16,
  containerMarginTop: 16,
  containerMarginBottom: 16,
  containerBgColor: s("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Suggestion pills
  pillPaddingX: 12,
  pillPaddingY: 4,
  pillBorderRadius: 50,
  pillBorderColor: s("primary"),
  pillBorderWidth: 1.5,
  pillBgColor: s("background"),
  pillBgColorHover: s("background"),
  pillTextColor: s("textPrimary"),
  pillFontSize: 16,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Na = {
  inline: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: s("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: s("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: s("background"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  highlighted: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: s("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: s("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: s("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: s("background"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  accordion: {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: s("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: s("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: s("background"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  "accordion-highlighted": {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: s("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: s("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: s("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: s("background"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  }
}, Wa = [
  { label: "Inline Pills (V1)", value: "inline" },
  { label: "Highlighted (V2)", value: "highlighted" },
  { label: "Accordion (V3)", value: "accordion" },
  { label: "Accordion Highlighted (V4)", value: "accordion-highlighted" },
  { label: "Custom", value: "custom" }
], Fo = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Wa
  },
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "showSparkleIcon", label: "Show Sparkle Icon", type: "toggle" },
  { key: "collapsible", label: "Collapsible (Accordion)", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ge]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 2,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ge]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Kn = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Da = ({
  color: e = "currentColor"
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ o(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), Oa = ({
  expanded: e,
  color: t = "currentColor"
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      flexShrink: 0,
      transition: "transform 0.2s ease",
      transform: e ? "rotate(180deg)" : "rotate(0deg)"
    },
    children: /* @__PURE__ */ o("polyline", { points: "6 9 12 15 18 9" })
  }
), ja = ({ question: e, onClick: t, state: n, resolveColor: r }) => {
  const [i, a] = j(!1);
  return /* @__PURE__ */ o(
    "button",
    {
      onClick: t,
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      style: {
        padding: `${n.pillPaddingY}px ${n.pillPaddingX}px`,
        borderRadius: `${n.pillBorderRadius}px`,
        border: `${n.pillBorderWidth}px solid ${r(n.pillBorderColor)}`,
        backgroundColor: r(i ? n.pillBgColorHover : n.pillBgColor),
        color: r(n.pillTextColor),
        fontSize: `${n.pillFontSize}px`,
        fontWeight: Kn[n.pillFontWeight] || 500,
        fontFamily: n.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: "32px"
      },
      children: e
    }
  );
}, $s = ({
  widgetId: e = "conversation-starters",
  displayName: t = "Conversation Starters",
  initialState: n = {},
  questions: r,
  isLoading: i = !1,
  onQuestionClick: a
}) => {
  const {
    state: l,
    isLoading: d,
    isSaving: p,
    handleEditChange: h,
    handleSave: g,
    themeColors: b,
    themeFonts: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ...Ra, ...n },
    Fo
  ), [x, f] = j(!1), S = (D, N) => {
    if (D === "preset" && N !== "custom") {
      const G = Na[N];
      if (G) {
        h("preset", N), Object.entries(G).forEach(([K, Q]) => {
          h(K, Q);
        });
        return;
      }
    }
    h(D, N);
  }, F = l.pillFontFamily, m = F && F !== "inherit" ? B[F] : null, H = l.titleFontFamily, y = H && H !== "inherit" ? B[H] : null, I = m && m.format === "google" ? m.url : null, v = y && y.format === "google" ? y.url : null;
  if (X(() => {
    I && zo(I);
  }, [I]), X(() => {
    v && zo(v);
  }, [v]), d || !i && r.length === 0)
    return null;
  const k = m ? m.format === "system" ? m.url : `"${m.name}", sans-serif` : "inherit", T = y ? y.format === "system" ? y.url : `"${y.name}", sans-serif` : "inherit", A = m && m.format !== "system" && m.format !== "google", P = y && y.format !== "system" && y.format !== "google", W = `conversation-starters-${e || "default"}`, w = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${A ? `
      @font-face {
        font-family: "${m.name}";
        src: url("${m.url}") format("${m.format}");
        font-display: swap;
      }
    ` : ""}
    ${P ? `
      @font-face {
        font-family: "${y.name}";
        src: url("${y.url}") format("${y.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), M = {
    ...l,
    pillFontFamilyCss: k,
    titleFontFamilyCss: T
  }, O = l.collapsible ? x : !0, J = z(l.containerBgColor), L = J && J !== "transparent" && J !== "", R = /* @__PURE__ */ u($, { children: [
    w && /* @__PURE__ */ o("style", { children: w }),
    /* @__PURE__ */ u(
      "div",
      {
        className: W,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: O ? `${l.containerGap}px` : "0px",
          marginTop: `${l.containerMarginTop}px`,
          marginBottom: `${l.containerMarginBottom}px`,
          backgroundColor: L ? J : void 0,
          padding: L || l.containerPaddingX || l.containerPaddingY ? `${l.containerPaddingY}px ${l.containerPaddingX}px` : void 0,
          borderRadius: l.containerBorderRadius > 0 ? `${l.containerBorderRadius}px` : void 0
        },
        children: [
          l.showTitle && /* @__PURE__ */ u(
            "h3",
            {
              onClick: l.collapsible ? () => f((D) => !D) : void 0,
              style: {
                fontSize: `${l.titleFontSize}px`,
                fontWeight: Kn[l.titleFontWeight] || 600,
                fontFamily: T,
                color: z(l.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: l.collapsible ? "pointer" : void 0,
                userSelect: l.collapsible ? "none" : void 0
              },
              children: [
                l.showSparkleIcon && /* @__PURE__ */ o(Da, { color: z(l.titleColor) }),
                /* @__PURE__ */ o("span", { style: { flex: 1 }, children: l.titleText }),
                l.collapsible && /* @__PURE__ */ o(
                  Oa,
                  {
                    expanded: x,
                    color: z(l.titleColor)
                  }
                )
              ]
            }
          ),
          O && /* @__PURE__ */ o($, { children: i ? /* @__PURE__ */ u(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ o(st, { width: 180 }),
                /* @__PURE__ */ o(st, { width: 140 }),
                /* @__PURE__ */ o(st, { width: 200 }),
                /* @__PURE__ */ o(st, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: r.map((D, N) => /* @__PURE__ */ o(
                ja,
                {
                  question: D,
                  onClick: () => a(D),
                  state: M,
                  resolveColor: z
                },
                N
              ))
            }
          ) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Fo,
      editValues: l,
      onEditChange: S,
      onSave: C ? g : void 0,
      isSaving: p,
      themeColors: b,
      themeFonts: B,
      children: R
    }
  );
}, tt = 60, To = 420, Mo = ({
  showSettings: e,
  viewMode: t,
  editorMode: n = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${tt}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${c.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${c.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${c.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${c.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${c.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${c.primary};
    background: ${c.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${c.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${c.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${c.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${tt}px;
    left: 0;
    right: ${e ? To : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${t === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${t === "desktop" ? "100%" : "375px"};
    height: ${t === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${t === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${tt}px;
    right: 0;
    bottom: 0;
    width: ${To}px;
    background: #fff;
    border-left: 1px solid ${c.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${c.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${c.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${c.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${c.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${c.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${c.gray_light};
    color: ${c.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${c.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${c.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${c.white};
    border-radius: 12px;
    border: 1px solid ${c.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${c.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${c.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${c.gray_medium};
    background: ${c.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${c.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${c.overlay_light};
    border-radius: 12px;
    border: 1px solid ${c.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${c.white};
    box-shadow: 0 2px 8px ${c.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${c.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${c.white};
    color: ${c.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${c.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${c.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${c.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${c.gray_medium};
    width: 85px;
    text-align: right;
    background: ${c.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${c.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${c.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${c.gray_light};
    color: ${c.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${c.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${c.blue};
    border: 2px dashed ${c.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${c.blue_light};
    border-color: ${c.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${c.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${c.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${c.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${c.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${c.gray_medium};
    background: ${c.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${c.overlay_light};
    border: 1px solid ${c.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${c.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${c.white};
    border-color: ${c.blue};
    color: ${c.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${c.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${c.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${n === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${tt}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, Eo = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Ga = [
  { label: "Classic", value: "magnifying-glass" },
  { label: "Alternate", value: "magnifying-glass-alt" },
  { label: "Bold", value: "magnifying-glass-bold" },
  { label: "Slim", value: "magnifying-glass-slim" },
  { label: "Dot", value: "magnifying-glass-dot" }
], It = ({
  variant: e = "magnifying-glass",
  size: t,
  color: n,
  strokeWidth: r = 2,
  style: i
}) => {
  const a = {
    xmlns: "http://www.w3.org/2000/svg",
    width: t,
    height: t,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: n,
    strokeWidth: r,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, ...i }
  };
  switch (e) {
    case "magnifying-glass-alt":
      return /* @__PURE__ */ u("svg", { ...a, children: [
        /* @__PURE__ */ o("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }),
        /* @__PURE__ */ o("path", { d: "M21 21l-6-6" })
      ] });
    case "magnifying-glass-bold":
      return /* @__PURE__ */ u("svg", { ...a, strokeWidth: r + 0.75, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "7" }),
        /* @__PURE__ */ o("line", { x1: "16.5", y1: "16.5", x2: "21", y2: "21" })
      ] });
    case "magnifying-glass-slim":
      return /* @__PURE__ */ u("svg", { ...a, strokeWidth: Math.max(1, r - 0.5), children: [
        /* @__PURE__ */ o("circle", { cx: "10.5", cy: "10.5", r: "8.5" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "17", y2: "17" })
      ] });
    case "magnifying-glass-dot":
      return /* @__PURE__ */ u("svg", { ...a, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }),
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "1.5", fill: n, stroke: "none" })
      ] });
    case "magnifying-glass":
    default:
      return /* @__PURE__ */ u("svg", { ...a, children: [
        /* @__PURE__ */ o("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ o("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
      ] });
  }
}, $a = ({
  size: e,
  color: t
}) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, cursor: "pointer" },
    children: [
      /* @__PURE__ */ o("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      /* @__PURE__ */ o("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
    ]
  }
), Xe = {
  // Trigger icon
  triggerIconStyle: "magnifying-glass",
  triggerIconThemeIcon: "default",
  triggerIconSize: 20,
  triggerIconColor: s("textPrimary"),
  triggerIconStrokeWidth: 2,
  // Panel
  panelBgColor: s("background"),
  // Search bar
  searchBarBgColor: s("background"),
  searchBarBorderRadius: 30,
  searchBarMaxWidth: 800,
  searchBarHeight: 56,
  searchBarHeightMobile: 40,
  searchBarPlaceholder: "Search or ask concierge",
  searchBarFontSize: 14,
  searchBarFontSizeMobile: 12,
  searchBarTextColor: s("textPrimary"),
  searchBarPlaceholderColor: s("textPrimary"),
  searchBarIconSize: 24,
  searchBarIconSizeMobile: 16,
  // Ask concierge button
  askButtonBgColor: s("textPrimary"),
  askButtonTextColor: s("secondary"),
  askButtonBorderRadius: 100,
  askButtonFontSize: 14,
  askButtonFontSizeMobile: 10,
  askButtonText: "Ask concierge",
  askButtonPaddingX: 16,
  askButtonPaddingY: 4,
  // Close button
  closeIconSize: 24,
  closeIconSizeMobile: 20,
  closeIconColor: s("textPrimary"),
  // Section headers
  sectionHeaderFontSize: 16,
  sectionHeaderFontSizeMobile: 14,
  sectionHeaderFontWeight: "semibold",
  sectionHeaderColor: s("textPrimary"),
  // Body / question text
  bodyFontSize: 14,
  bodyColor: s("textPrimary"),
  bodyLineHeight: 24,
  // Products
  productImageSize: 72,
  productImageSizeMobile: 56,
  productNameFontSize: 14,
  productPriceFontSize: 14,
  productPriceFontWeight: "semibold",
  productColumns: 2,
  // Trending searches
  trendingFontSize: 14,
  trendingColor: s("textPrimary"),
  trendingLineHeight: 24,
  // Empty state
  noResultsText: "No search results found. Please try again.",
  noResultsWithSuggestionsText: "No search results found . Here's some ideas to get you started.",
  noSuggestionsText: "No suggestions found",
  noProductsText: "No products found",
  noSearchesText: "No searches found",
  // Spacing
  sectionGap: 32,
  contentPaddingX: 43,
  contentPaddingXMobile: 20,
  contentPaddingTop: 24,
  // Mobile dividers
  showMobileDividers: !0,
  dividerColor: s("background"),
  // Font
  fontFamily: "inherit"
}, er = [
  {
    key: "triggerIconThemeIcon",
    label: "Custom Icon",
    type: "icon",
    group: "Trigger Icon"
  },
  {
    key: "triggerIconStyle",
    label: "Built-in Style",
    type: "options",
    options: Ga,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 48,
    step: 2,
    group: "Trigger Icon"
  },
  {
    key: "triggerIconColor",
    label: "Icon Color",
    type: "color",
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconStrokeWidth",
    label: "Stroke Width",
    type: "number",
    min: 1,
    max: 4,
    step: 0.5,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  }
], tr = [
  {
    key: "searchBarBgColor",
    label: "Background",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2,
    group: "Search Bar"
  },
  {
    key: "searchBarMaxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Search Bar"
  },
  {
    key: "searchBarHeight",
    label: "Height (Desktop)",
    type: "number",
    min: 36,
    max: 72,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarHeightMobile",
    label: "Height (Mobile)",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholder",
    label: "Placeholder Text",
    type: "text",
    group: "Search Bar"
  },
  {
    key: "searchBarFontSize",
    label: "Font Size (Desktop)",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Search Bar"
  },
  {
    key: "searchBarTextColor",
    label: "Text Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholderColor",
    label: "Placeholder Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "askButtonBgColor",
    label: "Button Background",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonBorderRadius",
    label: "Button Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4,
    group: "Ask Button"
  },
  {
    key: "askButtonText",
    label: "Button Text",
    type: "text",
    group: "Ask Button"
  },
  {
    key: "closeIconSize",
    label: "Close Icon Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Close Button"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Close Button"
  }
], Ot = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderFontWeight",
    label: "Header Font Weight",
    type: "options",
    options: [...ge],
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "bodyFontSize",
    label: "Body Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Body Text"
  },
  { key: "bodyColor", label: "Body Color", type: "color", group: "Body Text" }
], jt = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "productImageSize",
    label: "Image Size (Desktop)",
    type: "number",
    min: 48,
    max: 96,
    step: 8,
    group: "Products"
  },
  {
    key: "productImageSizeMobile",
    label: "Image Size (Mobile)",
    type: "number",
    min: 40,
    max: 72,
    step: 8,
    group: "Products"
  },
  {
    key: "productColumns",
    label: "Columns (Desktop)",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Products"
  },
  {
    key: "productNameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...ge],
    group: "Products"
  }
], Gt = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "trendingFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Trending"
  },
  { key: "trendingColor", label: "Color", type: "color", group: "Trending" }
], or = [
  {
    key: "panelBgColor",
    label: "Panel Background",
    type: "color",
    group: "Panel"
  },
  { key: "fontFamily", label: "Font Family", type: "font", group: "Panel" },
  {
    key: "sectionGap",
    label: "Section Gap",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingX",
    label: "Padding X (Desktop)",
    type: "number",
    min: 16,
    max: 80,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingXMobile",
    label: "Padding X (Mobile)",
    type: "number",
    min: 12,
    max: 40,
    step: 4,
    group: "Spacing"
  },
  {
    key: "noResultsText",
    label: "No Results Text",
    type: "text",
    group: "Empty States"
  },
  {
    key: "noResultsWithSuggestionsText",
    label: "No Results (with suggestions)",
    type: "text",
    group: "Empty States"
  },
  {
    key: "showMobileDividers",
    label: "Show Mobile Dividers",
    type: "toggle",
    group: "Dividers"
  },
  {
    key: "dividerColor",
    label: "Divider Color",
    type: "color",
    group: "Dividers"
  }
], Ya = [
  ...er,
  ...tr,
  ...Ot,
  ...jt,
  ...Gt,
  ...or
], Ne = ({ width: e }) => /* @__PURE__ */ o(
  "div",
  {
    style: {
      width: e,
      height: "18px",
      borderRadius: "3px",
      backgroundColor: "#e5e7eb",
      animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), Pt = ({ imageSize: e }) => /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [
  /* @__PURE__ */ o(
    "div",
    {
      style: {
        width: e,
        height: e,
        borderRadius: "8px",
        backgroundColor: "#e5e7eb",
        flexShrink: 0,
        animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      }
    }
  ),
  /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ o(Ne, { width: "140px" }),
    /* @__PURE__ */ o(Ne, { width: "60px" })
  ] })
] }), Ao = ({
  product: e,
  imageSize: t,
  nameSize: n,
  priceSize: r,
  priceWeight: i,
  textColor: a,
  nameMaxWidth: l,
  onClick: d
}) => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: d ? "pointer" : void 0
    },
    onClick: d,
    children: [
      /* @__PURE__ */ o(
        "img",
        {
          src: e.imageUrl,
          alt: e.name,
          style: {
            width: t,
            height: t,
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: "4px"
          }
        }
      ),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            minWidth: 0,
            maxWidth: l
          },
          children: [
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: `${n}px`,
                  fontWeight: 400,
                  lineHeight: "20px",
                  color: a,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                },
                children: e.name
              }
            ),
            /* @__PURE__ */ o(
              "span",
              {
                style: {
                  fontSize: `${r}px`,
                  fontWeight: i,
                  lineHeight: "20px",
                  color: a
                },
                children: e.price
              }
            )
          ]
        }
      )
    ]
  }
), Ys = ({
  widgetId: e = "search-panel",
  displayName: t = "Search Panel",
  initialState: n = {},
  conciergeQuestions: r,
  popularProducts: i,
  trendingSearches: a,
  isOpen: l,
  searchQuery: d,
  isLoading: p = !1,
  hasSearched: h = !1,
  onOpen: g,
  onClose: b,
  onSearchChange: B,
  onSearchSubmit: z,
  onAskConcierge: C,
  onQuestionClick: x,
  onProductClick: f,
  onTrendingClick: S,
  brandLogo: F
}) => {
  var no;
  const {
    state: m,
    isLoading: H,
    isSaving: y,
    handleEditChange: I,
    handleSave: v,
    themeColors: k,
    themeFonts: T,
    themeIcons: A,
    resolveColor: P,
    canSave: W
  } = te(
    e,
    { ...Xe, ...n },
    Ya
  ), w = le(null), [M, O] = j(!1), J = Zt();
  X(() => {
    const ie = () => O(window.innerWidth < 768);
    return ie(), window.addEventListener("resize", ie), () => window.removeEventListener("resize", ie);
  }, []), X(() => {
    if (l && w.current) {
      const ie = setTimeout(() => {
        var Ie;
        return (Ie = w.current) == null ? void 0 : Ie.focus();
      }, 100);
      return () => clearTimeout(ie);
    }
  }, [l]), X(() => {
    if (!l) return;
    const ie = (Ie) => {
      Ie.key === "Escape" && b();
    };
    return document.addEventListener("keydown", ie), () => document.removeEventListener("keydown", ie);
  }, [l, b]);
  const L = me(
    (ie) => {
      ie.key === "Enter" && z(d);
    },
    [d, z]
  );
  if (H && !l)
    return /* @__PURE__ */ o(
      "div",
      {
        onClick: g,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: /* @__PURE__ */ o(
          It,
          {
            variant: Xe.triggerIconStyle,
            size: Xe.triggerIconSize,
            color: typeof Xe.triggerIconColor == "string" ? Xe.triggerIconColor : "#4f4b47",
            strokeWidth: Xe.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
  if (H) return null;
  const R = P(m.triggerIconColor), D = m.triggerIconThemeIcon, N = D && D !== "default" ? (no = A[D]) == null ? void 0 : no.url : void 0;
  if (!l) {
    const ie = /* @__PURE__ */ o(
      "div",
      {
        onClick: g,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: N ? /* @__PURE__ */ o(
          "img",
          {
            src: N,
            alt: "Search",
            style: {
              width: m.triggerIconSize,
              height: m.triggerIconSize,
              objectFit: "contain",
              cursor: "pointer",
              flexShrink: 0
            }
          }
        ) : /* @__PURE__ */ o(
          It,
          {
            variant: m.triggerIconStyle,
            size: m.triggerIconSize,
            color: R,
            strokeWidth: m.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
    return /* @__PURE__ */ o(
      U,
      {
        widgetId: e,
        displayName: "Search Icon",
        editFields: er,
        editValues: m,
        onEditChange: I,
        onSave: W ? v : void 0,
        isSaving: y,
        themeColors: k,
        themeFonts: T,
        themeIcons: A,
        wrapperStyle: { display: "inline-flex", width: "auto" },
        iconOffset: { top: -16, left: 24 },
        children: ie
      }
    );
  }
  const Y = P(m.panelBgColor), G = P(m.searchBarBgColor), K = P(m.searchBarTextColor);
  P(m.searchBarPlaceholderColor);
  const Q = P(m.askButtonBgColor), _ = P(m.askButtonTextColor), re = P(m.closeIconColor), V = P(m.sectionHeaderColor), ne = P(m.bodyColor), ee = P(m.trendingColor), fe = P(m.dividerColor), De = Eo[m.sectionHeaderFontWeight] || 600, xe = Eo[m.productPriceFontWeight] || 600, ze = M ? m.searchBarHeightMobile : m.searchBarHeight, we = M ? m.searchBarFontSizeMobile : m.searchBarFontSize, Ae = M ? m.searchBarIconSizeMobile : m.searchBarIconSize, Z = M ? m.closeIconSizeMobile : m.closeIconSize, ue = M ? m.sectionHeaderFontSizeMobile : m.sectionHeaderFontSize, Be = M ? m.productImageSizeMobile : m.productImageSize, ke = M ? m.contentPaddingXMobile : m.contentPaddingX, ae = M ? m.askButtonFontSizeMobile : m.askButtonFontSize, he = r.length > 0, $e = i.length > 0, Ue = a.length > 0, _e = he || $e || Ue, xt = h && !p, Ee = !h || _e, ve = (ie) => /* @__PURE__ */ o(
    "h3",
    {
      style: {
        margin: 0,
        fontSize: `${ue}px`,
        fontWeight: De,
        lineHeight: M ? "24px" : "32px",
        color: V
      },
      children: ie
    }
  ), Kt = () => p ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ve("Ask Concierge"),
    /* @__PURE__ */ o(Ne, { width: "80%" }),
    /* @__PURE__ */ o(Ne, { width: "70%" }),
    /* @__PURE__ */ o(Ne, { width: "60%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: [
    ve("Ask Concierge"),
    he ? r.map((ie, Ie) => /* @__PURE__ */ o(
      "p",
      {
        onClick: () => x(ie),
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.bodyLineHeight}px`,
          color: ne,
          cursor: "pointer"
        },
        children: ie
      },
      Ie
    )) : /* @__PURE__ */ o(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.bodyLineHeight}px`,
          color: ne,
          opacity: 0.7
        },
        children: m.noSuggestionsText
      }
    )
  ] }), eo = () => {
    if (p)
      return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
        ve("Popular products"),
        /* @__PURE__ */ o(Pt, { imageSize: Be }),
        /* @__PURE__ */ o(Pt, { imageSize: Be }),
        /* @__PURE__ */ o(Pt, { imageSize: Be })
      ] });
    const ie = M ? 1 : m.productColumns, Ie = [];
    if ($e) {
      const He = Math.ceil(i.length / ie);
      for (let Le = 0; Le < ie; Le++)
        Ie.push(
          i.slice(Le * He, (Le + 1) * He)
        );
    }
    return /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
      ve("Popular products"),
      $e ? /* @__PURE__ */ o(
        "div",
        {
          style: {
            display: M ? "flex" : "grid",
            gridTemplateColumns: M ? void 0 : `repeat(${ie}, 1fr)`,
            flexDirection: M ? "column" : void 0,
            gap: M ? "16px" : "24px"
          },
          children: M ? i.map((He, Le) => /* @__PURE__ */ o(
            Ao,
            {
              product: He,
              imageSize: Be,
              nameSize: m.productNameFontSize,
              priceSize: m.productPriceFontSize,
              priceWeight: xe,
              textColor: ne,
              onClick: He.onClick ?? (() => f(He))
            },
            Le
          )) : Ie.map((He, Le) => /* @__PURE__ */ o(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px"
              },
              children: He.map((kt, gr) => /* @__PURE__ */ o(
                Ao,
                {
                  product: kt,
                  imageSize: Be,
                  nameSize: m.productNameFontSize,
                  priceSize: m.productPriceFontSize,
                  priceWeight: xe,
                  textColor: ne,
                  nameMaxWidth: 250,
                  onClick: kt.onClick ?? (() => f(kt))
                },
                gr
              ))
            },
            Le
          ))
        }
      ) : /* @__PURE__ */ o(
        "p",
        {
          style: {
            margin: 0,
            fontSize: `${m.bodyFontSize}px`,
            fontWeight: 400,
            color: ne,
            opacity: 0.7
          },
          children: m.noProductsText
        }
      )
    ] });
  }, to = () => p ? /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    ve("Trending searches"),
    /* @__PURE__ */ o(Ne, { width: "75%" }),
    /* @__PURE__ */ o(Ne, { width: "65%" }),
    /* @__PURE__ */ o(Ne, { width: "80%" })
  ] }) : /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "8px" }, children: [
    ve("Trending searches"),
    Ue ? a.map((ie, Ie) => /* @__PURE__ */ o(
      "p",
      {
        onClick: () => S(ie),
        style: {
          margin: 0,
          fontSize: `${m.trendingFontSize}px`,
          fontWeight: 400,
          lineHeight: `${m.trendingLineHeight}px`,
          color: ee,
          cursor: "pointer"
        },
        children: ie
      },
      Ie
    )) : /* @__PURE__ */ o(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${m.bodyFontSize}px`,
          fontWeight: 400,
          color: ne,
          opacity: 0.7
        },
        children: m.noSearchesText
      }
    )
  ] }), oo = () => !M || !m.showMobileDividers ? null : /* @__PURE__ */ o(
    "div",
    {
      style: {
        height: "1px",
        backgroundColor: fe,
        margin: `${m.sectionGap / 2}px 0`
      }
    }
  ), Ct = J ? tt : 0, pr = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        @keyframes searchPanelPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes searchPanelSlideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes searchPanelFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      ` }),
    /* @__PURE__ */ o(
      "div",
      {
        onClick: b,
        style: {
          position: "fixed",
          top: Ct,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2147483645,
          backgroundColor: M ? "transparent" : "rgba(0, 0, 0, 0.15)",
          animation: "searchPanelFadeIn 0.25s ease-out"
        }
      }
    ),
    /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: Ct,
          left: 0,
          right: 0,
          ...M ? { bottom: 0 } : {},
          zIndex: 2147483646,
          backgroundColor: Y,
          display: "flex",
          flexDirection: "column",
          overflow: M ? "auto" : "visible",
          fontFamily: m.fontFamilyCss || "inherit",
          animation: "searchPanelSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          ...M ? {} : {
            maxHeight: `calc(100vh - ${Ct}px)`,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)"
          }
        },
        children: [
          /* @__PURE__ */ o(
            U,
            {
              widgetId: e ? `${e}__search-bar` : void 0,
              displayName: "Search Bar",
              editFields: tr,
              editValues: m,
              onEditChange: I,
              onSave: W ? v : void 0,
              isSaving: y,
              themeColors: k,
              themeFonts: T,
              wrapperStyle: { display: "flex", width: "100%" },
              children: /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: M ? "12px" : "24px",
                    padding: M ? "24px 20px 0 20px" : `36px ${ke}px 0 ${ke}px`,
                    flexShrink: 0,
                    width: "100%"
                  },
                  children: [
                    !M && F && /* @__PURE__ */ o("div", { style: { flexShrink: 0 }, children: F }),
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: G,
                          borderRadius: `${m.searchBarBorderRadius}px`,
                          maxWidth: `${m.searchBarMaxWidth}px`,
                          margin: "0 auto",
                          height: `${ze}px`,
                          padding: M ? "0 8px 0 12px" : "0 12px 0 16px",
                          gap: M ? "8px" : "12px"
                        },
                        children: [
                          N ? /* @__PURE__ */ o(
                            "img",
                            {
                              src: N,
                              alt: "Search",
                              style: {
                                width: Ae,
                                height: Ae,
                                objectFit: "contain",
                                flexShrink: 0
                              }
                            }
                          ) : /* @__PURE__ */ o(
                            It,
                            {
                              variant: m.triggerIconStyle,
                              size: Ae,
                              color: K
                            }
                          ),
                          /* @__PURE__ */ o(
                            "input",
                            {
                              ref: w,
                              type: "text",
                              value: d,
                              onChange: (ie) => B(ie.target.value),
                              onKeyDown: L,
                              placeholder: m.searchBarPlaceholder,
                              style: {
                                flex: 1,
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                fontSize: `${we}px`,
                                fontWeight: 400,
                                lineHeight: M ? "16px" : "24px",
                                color: K,
                                fontFamily: "inherit"
                              }
                            }
                          ),
                          /* @__PURE__ */ o(
                            "button",
                            {
                              onClick: () => C(d),
                              style: {
                                flexShrink: 0,
                                backgroundColor: Q,
                                color: _,
                                border: "none",
                                borderRadius: `${m.askButtonBorderRadius}px`,
                                padding: M ? "6px 8px" : `${m.askButtonPaddingY}px ${m.askButtonPaddingX}px`,
                                fontSize: `${ae}px`,
                                fontWeight: 500,
                                lineHeight: M ? "16px" : "32px",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                fontFamily: "inherit"
                              },
                              children: m.askButtonText
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ o(
                      "div",
                      {
                        onClick: b,
                        style: { flexShrink: 0, cursor: "pointer", padding: "4px" },
                        role: "button",
                        "aria-label": "Close search panel",
                        children: /* @__PURE__ */ o($a, { size: Z, color: re })
                      }
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ u(
            "div",
            {
              style: {
                ...M ? { flex: 1 } : {},
                padding: `${m.contentPaddingTop}px ${ke}px ${ke}px`,
                overflow: "auto"
              },
              children: [
                xt && /* @__PURE__ */ o(
                  "p",
                  {
                    style: {
                      margin: `0 0 ${m.sectionGap}px`,
                      fontSize: `${m.sectionHeaderFontSize}px`,
                      fontWeight: De,
                      lineHeight: "32px",
                      color: V,
                      textAlign: _e ? "center" : void 0
                    },
                    children: _e ? m.noResultsWithSuggestionsText : m.noResultsText
                  }
                ),
                Ee && /* @__PURE__ */ o($, { children: M ? (
                  /* ---- Mobile: stacked single column ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: `${m.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Ot,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: Kt()
                          }
                        ),
                        oo(),
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: jt,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: eo()
                          }
                        ),
                        oo(),
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Gt,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: to()
                          }
                        )
                      ]
                    }
                  )
                ) : (
                  /* ---- Desktop: 3-column layout ---- */
                  /* @__PURE__ */ u(
                    "div",
                    {
                      style: {
                        display: "grid",
                        gridTemplateColumns: "minmax(200px, 1fr) minmax(350px, 2fr) minmax(200px, 1fr)",
                        gap: `${m.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Ot,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: Kt()
                          }
                        ),
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: jt,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: eo()
                          }
                        ),
                        /* @__PURE__ */ o(
                          U,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Gt,
                            editValues: m,
                            onEditChange: I,
                            onSave: W ? v : void 0,
                            isSaving: y,
                            themeColors: k,
                            themeFonts: T,
                            children: to()
                          }
                        )
                      ]
                    }
                  )
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: or,
      editValues: m,
      onEditChange: I,
      onSave: W ? v : void 0,
      isSaving: y,
      themeColors: k,
      themeFonts: T,
      children: pr
    }
  );
}, Qa = {
  // Pill styling (matching Figma design)
  pillBgColor: s("background"),
  pillBgColorHover: s("primary"),
  pillTextColor: s("textPrimary"),
  pillTextColorHover: s("background"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: s("primary"),
  pillBorderColorHover: s("primary"),
  // Selected state styling
  pillBgColorSelected: s("primary"),
  pillTextColorSelected: s("secondary"),
  pillBorderColorSelected: s("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Ho = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillTextColorHover", label: "Pill Hover Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  { key: "pillBorderColorHover", label: "Border Hover Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: at
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], Qs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const { state: i, isLoading: a, isSaving: l, handleEditChange: d, handleSave: p, themeColors: h, resolveColor: g, canSave: b } = te(t, { ...Qa, ...e }, Ho);
  if (a)
    return /* @__PURE__ */ o($, {});
  const B = r(i, g);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Ho,
      editValues: i,
      onEditChange: d,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: h,
      children: B
    }
  );
}, Xa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ja = {
  // Background
  backgroundColor: s("transparent"),
  // Title styling
  titleColor: s("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: s("textPrimary"),
  iconColorHover: s("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: s("background"),
  // Badge styling (cart count)
  badgeBgColor: s("primary"),
  badgeTextColor: s("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, Lo = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ge],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], Xs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...Ja, ...e },
    Lo
  ), z = i.titleFontFamily, C = z && z !== "inherit" ? g[z] : null, x = C && C.format === "google" ? C.url : null;
  if (X(() => {
    x && Xa(x);
  }, [x]), a)
    return /* @__PURE__ */ o($, {});
  const f = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", S = C && C.format !== "system" && C.format !== "google", F = `header-${t || "default"}`, m = `
    ${S ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${F} [data-title-text] { font-family: ${f} !important; }` : ""}
  `.trim(), H = {
    ...i,
    titleFontFamilyCss: f
  }, y = /* @__PURE__ */ u($, { children: [
    m && /* @__PURE__ */ o("style", { children: m }),
    r(H, b)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Lo,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: y
    }
  );
}, Ua = ({ className: e }) => /* @__PURE__ */ u(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ o("g", { clipPath: "url(#clip0_concierge_close)", children: /* @__PURE__ */ o(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.23815 8.00015L14.7435 2.49459C15.0855 2.15283 15.0855 1.5983 14.7435 1.25654C14.4014 0.914486 13.8475 0.914486 13.5055 1.25654L8.00015 6.7621L2.49453 1.25654C2.15249 0.914486 1.59858 0.914486 1.25653 1.25654C0.914489 1.5983 0.914489 2.15283 1.25653 2.49459L6.76215 8.00015L1.25653 13.5057C0.914489 13.8475 0.914489 14.402 1.25653 14.7438C1.42755 14.9145 1.65168 15 1.87553 15C2.09938 15 2.32351 14.9145 2.49453 14.7435L8.00015 9.2379L13.5055 14.7435C13.6765 14.9145 13.9006 15 14.1245 15C14.3483 15 14.5725 14.9145 14.7435 14.7435C15.0855 14.4017 15.0855 13.8472 14.7435 13.5054L9.23815 8.00015Z",
          fill: "currentColor",
          stroke: "currentColor",
          strokeWidth: "0.5"
        }
      ) }),
      /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ o("clipPath", { id: "clip0_concierge_close", children: /* @__PURE__ */ o("rect", { width: "16", height: "16", fill: "white" }) }) })
    ]
  }
), _a = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ro = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 16,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: s("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: s("textPrimary"),
  maximizeButtonColor: s("textPrimary"),
  historyButtonColor: s("textPrimary")
}, No = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  {
    key: "maximizeButtonColor",
    label: "Maximize Button Color",
    type: "color"
  },
  {
    key: "historyButtonColor",
    label: "History Button Color",
    type: "color"
  }
], Za = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, Js = ({
  showMaximize: e = !0,
  isMaximized: t = !1,
  onMaximize: n,
  onMinimize: r,
  onClose: i,
  onHistoryClick: a,
  onNewConversationClick: l,
  showNewConversation: d = !0,
  newConversationIcon: p,
  title: h = "CONCIERGE",
  widgetId: g = "concierge-widget-header",
  displayName: b = "Concierge Header",
  initialState: B = {},
  // mobileBrandLogoUrl,
  // showMobileLogo = false,
  bottomContent: z
}) => {
  const {
    state: C,
    isLoading: x,
    isSaving: f,
    handleEditChange: S,
    handleSave: F,
    themeColors: m,
    themeFonts: H,
    resolveColor: y,
    canSave: I
  } = te(
    g,
    {
      ...Ro,
      titleContent: (h == null ? void 0 : h.toUpperCase()) || Ro.titleContent,
      ...B
    },
    No
  ), v = C.titleFontFamily, k = v && v !== "inherit" ? H[v] : null, T = k && k.format === "google" ? k.url : null;
  if (X(() => {
    T && _a(T);
  }, [T]), x)
    return /* @__PURE__ */ o(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4",
        "data-concierge-header": !0
      }
    );
  const A = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", P = k && k.format !== "system" && k.format !== "google", W = `concierge-header-${g || "default"}`, w = (O) => {
    if (O.startsWith("#")) {
      const J = O.slice(1), L = J.length === 3 ? parseInt(J[0] + J[0], 16) : parseInt(J.slice(0, 2), 16), R = J.length === 3 ? parseInt(J[1] + J[1], 16) : parseInt(J.slice(2, 4), 16), D = J.length === 3 ? parseInt(J[2] + J[2], 16) : parseInt(J.slice(4, 6), 16);
      return `rgba(${L}, ${R}, ${D}, 0.7)`;
    }
    return O.startsWith("rgba") ? O.replace(/,\s*[\d.]+\)$/, ", 0.7)") : O.startsWith("rgb") ? O.replace("rgb", "rgba").replace(")", ", 0.7)") : O;
  }, M = /* @__PURE__ */ u(
    "div",
    {
      style: {
        borderBottom: "1px solid #F3F3F3",
        boxShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ o("style", { children: `
        ${P ? `
          @font-face {
            font-family: "${k.name}";
            src: url("${k.url}") format("${k.format}");
            font-display: swap;
          }
        ` : ""}
        ${A !== "inherit" ? `.${W} [data-title-text] { font-family: ${A} !important; }` : ""}
        .${W} .concierge-maximize-icon {
          color: ${y(C.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-maximize-icon:hover {
          color: ${w(y(C.maximizeButtonColor))};
        }
        .${W} .concierge-close-icon {
          color: ${y(C.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-close-icon:hover {
          color: ${w(y(C.closeButtonColor))};
        }
        .${W} .concierge-history-icon {
          color: ${y(C.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-history-icon:hover {
          color: ${w(y(C.historyButtonColor))};
        }
        .${W} .concierge-new-conversation-icon {
          color: ${y(C.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${W} .concierge-new-conversation-icon:hover {
          color: ${w(y(C.historyButtonColor))};
        }
      ` }),
        /* @__PURE__ */ u(
          "div",
          {
            className: `tw:flex tw:items-center tw:justify-between tw:min-h-[44px] ${W}`,
            style: { padding: 16 },
            "data-concierge-header": !0,
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-0 tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: [
                    t && r && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: r,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Minimize to widget",
                        children: /* @__PURE__ */ o($r, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    !t && e && n && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: n,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Expand to full view",
                        children: /* @__PURE__ */ o(Dr, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-maximize-icon" })
                      }
                    ),
                    d && l && /* @__PURE__ */ o(
                      "button",
                      {
                        onClick: l,
                        className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                        style: { padding: 8 },
                        "aria-label": "Create new conversation",
                        children: /* @__PURE__ */ o("span", { className: "tw:flex tw:items-center tw:justify-center tw:w-4 tw:h-4 concierge-new-conversation-icon [&>svg]:tw:block", children: p ?? /* @__PURE__ */ o(jr, { className: "tw:w-4 tw:h-4 tw:shrink-0" }) })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ o(
                "span",
                {
                  "data-title-text": !0,
                  className: "tw:flex tw:items-center tw:justify-center",
                  style: {
                    fontSize: `${C.titleFontSize}px`,
                    fontWeight: Za(C.titleFontWeight),
                    fontFamily: A !== "inherit" ? A : void 0,
                    color: y(C.titleColor),
                    letterSpacing: `${C.titleLetterSpacing}px`,
                    textTransform: C.titleTextTransform,
                    textAlign: "center",
                    lineHeight: 1,
                    flex: 1
                  },
                  children: C.titleContent
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1 tw:justify-end tw:flex-shrink-0",
                  style: { minWidth: "80px" },
                  children: /* @__PURE__ */ o(
                    "button",
                    {
                      onClick: i,
                      className: "tw:flex tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group tw:w-8 tw:h-8",
                      style: { padding: 8 },
                      "aria-label": "Close",
                      children: /* @__PURE__ */ o(Ua, { className: "tw:w-4 tw:h-4 tw:shrink-0 concierge-close-icon" })
                    }
                  )
                }
              )
            ]
          }
        ),
        z
      ]
    }
  );
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: g,
      displayName: b,
      editFields: No,
      editValues: C,
      onEditChange: S,
      onSave: I ? F : void 0,
      isSaving: f,
      themeColors: m,
      themeFonts: H,
      children: M
    }
  );
}, nr = `
@keyframes bc-skel-pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

/* Responsive concierge shell skeleton:
   - Desktop: left sidebar + content
   - Mobile: top header (hamburger) + content
*/
.bc-concierge-skel-shell{ position:relative; display:flex; flex-direction:row; height:100dvh; max-height:100dvh; min-height:-webkit-fill-available; overflow:hidden; background:#fff; box-sizing:border-box; }
.bc-concierge-skel-desktopSidebar{ display:flex; }
.bc-concierge-skel-mobileHeader{ display:none; }
.bc-concierge-skel-desktopContent{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-mobileContent{ display:none; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentShell{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentDesktopOnly{ display:flex; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-contentMobileOnly{ display:none; flex:1; min-width:0; min-height:0; flex-direction:column; overflow:hidden; }
.bc-concierge-skel-footerHint{ position:absolute; bottom:24px; left:0; right:0; display:flex; justify-content:center; pointer-events:none; }

@media (max-width: 767px){
  .bc-concierge-skel-shell{ flex-direction:column; }
  .bc-concierge-skel-desktopSidebar{ display:none; }
  .bc-concierge-skel-mobileHeader{ display:flex; }
  .bc-concierge-skel-desktopContent{ display:none; }
  .bc-concierge-skel-mobileContent{ display:flex; }
  .bc-concierge-skel-contentDesktopOnly{ display:none; }
  .bc-concierge-skel-contentMobileOnly{ display:flex; }
  .bc-concierge-skel-footerHint{ display:none; }
}
`, Va = "bc-skel-pulse 2.8s cubic-bezier(0.4, 0, 0.2, 1) infinite", de = (e, t, n, r = "0s", i = "#f0f0f0") => ({
  width: e,
  height: t,
  backgroundColor: i,
  borderRadius: n,
  animation: Va,
  animationDelay: r
}), qa = "#ffffff", Ka = "#ffffff", el = "#f8f8f8", zt = (e, t = "0s") => /* @__PURE__ */ o("div", { style: de(e, 40, 20, t) }), rr = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden"
    },
    children: [
      /* @__PURE__ */ o("div", { style: { flex: "1 1 0", minHeight: 0 } }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
            padding: 24,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ o("div", { style: de(40, 40, 20) }),
            /* @__PURE__ */ o("div", { style: de(140, 18, 9, "0.05s") }),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ o("div", { style: de(320, 24, 12, "0.1s") }),
              /* @__PURE__ */ o("div", { style: de(260, 24, 12, "0.15s") })
            ] }),
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  ...de("100%", 100, 16, "0.2s"),
                  maxWidth: 560,
                  backgroundColor: "#f8f8f8",
                  marginTop: 8
                }
              }
            ),
            /* @__PURE__ */ o("div", { style: { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginTop: 4 }, children: [180, 220, 160, 200].map((e, t) => /* @__PURE__ */ o("div", { style: de(e, 40, 20, `${0.25 + 0.05 * t}s`) }, t)) })
          ]
        }
      ),
      /* @__PURE__ */ o("div", { style: { flex: "1 1 0", minHeight: 0 } })
    ]
  }
), tl = () => /* @__PURE__ */ u("div", { className: "bc-concierge-skel-contentShell", children: [
  /* @__PURE__ */ o("style", { children: nr }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-contentDesktopOnly", children: /* @__PURE__ */ o(rr, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-contentMobileOnly", children: /* @__PURE__ */ o(ar, {}) })
] }), ir = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      width: 48,
      flexShrink: 0,
      borderRight: "1px solid #e8e8ed",
      alignSelf: "stretch",
      minHeight: 0,
      boxSizing: "content-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: 24,
      gap: 16
    },
    children: [
      /* @__PURE__ */ o("div", { style: de(24, 24, 12) }),
      /* @__PURE__ */ o("div", { style: { height: 8 } }),
      /* @__PURE__ */ o("div", { style: de(24, 24, 6, "0.1s") }),
      /* @__PURE__ */ o("div", { style: de(24, 24, 6, "0.2s") })
    ]
  }
), ol = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      height: 80,
      // mirrors ConciergeHomeMobileNavWidget default navHeight
      flexShrink: 0,
      boxSizing: "border-box",
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "24px 24px",
      // mirrors default navPaddingY/X
      backgroundColor: Ka
    },
    children: [
      /* @__PURE__ */ o("div", { style: de(20, 20, 6) }),
      /* @__PURE__ */ o("div", { style: { flex: 1, minWidth: 0, display: "flex", justifyContent: "center", padding: "0 8px" }, children: /* @__PURE__ */ o("div", { style: de(79, 18, 6, "0.08s") }) }),
      /* @__PURE__ */ o("div", { style: de(20, 20, 6, "0.14s") })
    ]
  }
), ar = () => /* @__PURE__ */ u(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      flex: 1,
      minHeight: 0,
      boxSizing: "border-box",
      overflow: "hidden",
      position: "relative",
      backgroundColor: qa
    },
    children: [
      /* @__PURE__ */ o("div", { style: { flex: 1 } }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            padding: "16px 16px",
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ o("div", { style: de(24, 24, 12) }),
            /* @__PURE__ */ o("div", { style: { height: 14 } }),
            /* @__PURE__ */ o("div", { style: de(52, 16, 8, "0.05s") }),
            /* @__PURE__ */ o("div", { style: { height: 10 } }),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ o("div", { style: de("min(84vw, 360px)", 22, 11, "0.1s") }),
              /* @__PURE__ */ o("div", { style: de("min(76vw, 300px)", 22, 11, "0.15s") })
            ] })
          ]
        }
      ),
      /* @__PURE__ */ o("div", { style: { flex: 1 } }),
      /* @__PURE__ */ o("div", { style: { flexShrink: 0, padding: "0 8px 0 8px" }, children: /* @__PURE__ */ u("div", { style: { display: "flex", gap: 10, overflow: "hidden", padding: "0 8px" }, children: [
        zt(244, "0.22s"),
        zt(198, "0.28s"),
        zt(186, "0.34s")
      ] }) }),
      /* @__PURE__ */ o(
        "div",
        {
          style: {
            flexShrink: 0,
            paddingTop: 16,
            paddingLeft: 8,
            paddingRight: 8,
            paddingBottom: "max(24px, env(safe-area-inset-bottom))"
          },
          children: /* @__PURE__ */ u(
            "div",
            {
              style: {
                width: "100%",
                height: 100,
                maxWidth: 900,
                padding: "14px 14px 12px 14px",
                borderRadius: 18,
                backgroundColor: el,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              },
              children: [
                /* @__PURE__ */ o("div", { style: de(98, 12, 6, "0.18s") }),
                /* @__PURE__ */ u("div", { style: { display: "flex", justifyContent: "flex-end", gap: 8 }, children: [
                  /* @__PURE__ */ o("div", { style: de(18, 18, 9, "0.22s") }),
                  /* @__PURE__ */ o("div", { style: de(18, 18, 9, "0.26s") }),
                  /* @__PURE__ */ o("div", { style: de(20, 20, 10, "0.3s") })
                ] })
              ]
            }
          )
        }
      )
    ]
  }
), Us = () => /* @__PURE__ */ u("div", { className: "bc-concierge-skel-shell", children: [
  /* @__PURE__ */ o("style", { children: nr }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-mobileHeader", children: /* @__PURE__ */ o(ol, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-desktopSidebar", children: /* @__PURE__ */ o(ir, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-desktopContent", children: /* @__PURE__ */ o(rr, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-mobileContent", children: /* @__PURE__ */ o(ar, {}) }),
  /* @__PURE__ */ o("div", { className: "bc-concierge-skel-footerHint", children: /* @__PURE__ */ o("div", { style: de(120, 20, 6, "0.4s") }) })
] }), nl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, rl = {
  // Logo / Brand Icon
  logoIcon: "default",
  logoIconSize: 24,
  // Brand Link
  brandLinkText: "example.com",
  brandLinkPrefix: "Visit ",
  brandLinkFontSize: 14,
  brandLinkColor: s("textPrimary"),
  // Layout
  expandedWidth: 248,
  collapsedWidth: 48,
  expandedBgColor: s("background"),
  collapsedBgColor: s("secondary"),
  borderColor: s("borderColor"),
  // Navigation Icons
  sidebarIconSize: 24,
  sidebarIconColor: s("textPrimary"),
  composeIconSize: 20,
  composeIconColor: s("textPrimary"),
  closeIconColor: s("textPrimary"),
  chatsIconSize: 20,
  chatsIconColor: s("textPrimary"),
  // Labels
  openSidebarLabel: "Open sidebar",
  closeSidebarLabel: "Close sidebar",
  newChatLabel: "New chat",
  chatsLabel: "Chats",
  signOutLabel: "Sign out",
  labelFontSize: 14,
  labelFontWeight: "medium",
  labelColor: s("textPrimary"),
  // Tooltips
  tooltipBgColor: s("textPrimary"),
  tooltipTextColor: s("secondary"),
  tooltipFontSize: 12,
  tooltipBorderRadius: 8,
  // Chat History
  chatHistoryTitle: "Chat history",
  chatHistoryTitleFontSize: 14,
  chatHistoryTitleFontWeight: "medium",
  chatHistoryTitleColor: s("textPrimary"),
  chatItemFontSize: 14,
  chatItemFontWeight: "medium",
  chatItemColor: s("textPrimary"),
  chatItemActiveBgColor: s("background"),
  chatItemHoverBgColor: s("background"),
  chatItemPaddingX: 8,
  chatItemPaddingY: 4,
  chatItemBorderRadius: 5,
  chatItemLineClamp: 1,
  // Typography
  fontFamily: "inherit",
  // Avatar
  avatarSize: 32,
  avatarBgColor: s("textPrimary"),
  avatarTextColor: s("secondary"),
  avatarFontSize: 12.8,
  avatarFontWeight: "semibold"
}, ct = ge.slice(0, 4), Wo = [
  // ── Logo / Brand Icon ──────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  {
    key: "logoIconSize",
    label: "Icon Size",
    type: "number",
    min: 0,
    max: 100,
    step: 1,
    group: "Logo"
  },
  // ── Brand Link ─────────────────────────────────────────────────────────
  {
    key: "brandLinkPrefix",
    label: "Prefix Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Brand Link"
  },
  {
    key: "brandLinkColor",
    label: "Color",
    type: "color",
    group: "Brand Link"
  },
  // ── Layout ─────────────────────────────────────────────────────────────
  {
    key: "expandedWidth",
    label: "Expanded Width",
    type: "number",
    min: 200,
    max: 320,
    step: 4,
    group: "Layout"
  },
  {
    key: "collapsedWidth",
    label: "Collapsed Width",
    type: "number",
    min: 36,
    max: 56,
    step: 2,
    group: "Layout"
  },
  {
    key: "expandedBgColor",
    label: "Expanded Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "collapsedBgColor",
    label: "Collapsed Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "borderColor",
    label: "Border Color",
    type: "color",
    group: "Layout"
  },
  // ── Navigation Icons ───────────────────────────────────────────────────
  {
    key: "sidebarIconSize",
    label: "Sidebar Icon Size",
    type: "number",
    min: 16,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "sidebarIconColor",
    label: "Sidebar Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "composeIconSize",
    label: "Compose Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "composeIconColor",
    label: "Compose Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "chatsIconSize",
    label: "Chats Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "chatsIconColor",
    label: "Chats Icon Color",
    type: "color",
    group: "Icons"
  },
  // ── Labels ─────────────────────────────────────────────────────────────
  {
    key: "openSidebarLabel",
    label: "Open Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "closeSidebarLabel",
    label: "Close Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "newChatLabel",
    label: "New Chat Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "chatsLabel",
    label: "Chats Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "signOutLabel",
    label: "Sign Out Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "labelFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Labels"
  },
  {
    key: "labelFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ct],
    group: "Labels"
  },
  { key: "labelColor", label: "Color", type: "color", group: "Labels" },
  // ── Tooltips ───────────────────────────────────────────────────────────
  {
    key: "tooltipBgColor",
    label: "Background",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipTextColor",
    label: "Text Color",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Tooltips"
  },
  {
    key: "tooltipBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Tooltips"
  },
  // ── Chat History ───────────────────────────────────────────────────────
  {
    key: "chatHistoryTitle",
    label: "Section Title",
    type: "text",
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ct],
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemFontSize",
    label: "Item Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemFontWeight",
    label: "Item Font Weight",
    type: "options",
    options: [...ct],
    group: "Chat History"
  },
  {
    key: "chatItemColor",
    label: "Item Text Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemActiveBgColor",
    label: "Active Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemBorderRadius",
    label: "Item Border Radius",
    type: "number",
    min: 0,
    max: 12,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemLineClamp",
    label: "Item Max Lines",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Chat History"
  },
  // ── Typography ─────────────────────────────────────────────────────────
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // ── Avatar ─────────────────────────────────────────────────────────────
  {
    key: "avatarSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Avatar"
  },
  {
    key: "avatarBgColor",
    label: "Background",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarTextColor",
    label: "Text Color",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarFontSize",
    label: "Font Size",
    type: "number",
    min: 6,
    max: 14,
    step: 1,
    group: "Avatar"
  },
  {
    key: "avatarFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ct],
    group: "Avatar"
  }
], _s = ({
  widgetId: e = "concierge-sidebar",
  displayName: t = "Concierge Sidebar",
  initialState: n = {},
  wrapperStyle: r,
  children: i
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: h,
    themeColors: g,
    themeFonts: b,
    themeIcons: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ...rl, ...n },
    Wo
  ), x = a.logoIcon && a.logoIcon !== "default" ? B[a.logoIcon] : null, f = {
    logoIconUrl: x ? x.url : null
  }, S = a.fontFamily, F = S && S !== "inherit" ? b[S] : null, m = F && F.format === "google" ? F.url : null;
  if (X(() => {
    m && nl(m);
  }, [m]), l)
    return /* @__PURE__ */ o(ir, {});
  const H = F ? F.format === "system" ? F.url : `"${F.name}", sans-serif` : "inherit", I = F && F.format !== "system" && F.format !== "google" ? `@font-face {
        font-family: "${F.name}";
        src: url("${F.url}") format("${F.format}");
        font-display: swap;
      }` : "", v = {
    ...a,
    fontFamilyCss: H
  }, k = /* @__PURE__ */ u($, { children: [
    I && /* @__PURE__ */ o("style", { children: I }),
    i(v, f, z)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Wo,
      editValues: a,
      onEditChange: p,
      onSave: C ? h : void 0,
      isSaving: d,
      themeColors: g,
      themeFonts: b,
      themeIcons: B,
      wrapperStyle: r,
      children: k
    }
  );
}, il = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, al = {
  pageTitle: "Chat History",
  pageTitleFontSize: 24,
  pageTitleFontWeight: "semibold",
  pageTitleColor: s("textPrimary"),
  searchPlaceholder: "Search your chats",
  searchBgColor: s("background"),
  searchBorderColor: s("borderColor"),
  searchTextColor: s("textPrimary"),
  searchIconColor: s("textSecondary"),
  searchBorderRadius: 100,
  chatItemBgColor: s("background"),
  chatItemHoverBgColor: s("secondary"),
  chatItemSelectedBgColor: s("secondary"),
  chatItemTitleColor: s("textPrimary"),
  chatItemPreviewColor: s("textSecondary"),
  chatItemTimestampColor: s("textPrimary"),
  chatItemTitleFontSize: 14,
  chatItemPreviewFontSize: 12,
  chatItemBorderRadius: 10,
  chatItemPaddingX: 24,
  chatItemPaddingY: 16,
  groupHeaderColor: s("textSecondary"),
  groupHeaderFontSize: 14,
  groupHeaderFontWeight: "medium",
  selectionCheckboxColor: s("primary"),
  bulkActionBarBgColor: s("background"),
  bulkActionBarTextColor: s("textPrimary"),
  deleteButtonColor: s("error"),
  deleteButtonHoverColor: s("error"),
  pageBgColor: s("background"),
  newChatButtonBgColor: s("primary"),
  newChatButtonTextColor: s("buttonText"),
  newChatButtonBorderRadius: 100,
  fontFamily: "inherit"
}, Do = ge.slice(0, 4), Oo = [
  // ── Page Header
  { key: "pageTitle", label: "Page Title", type: "text", group: "Header" },
  {
    key: "pageTitleFontSize",
    label: "Title Size",
    type: "number",
    min: 18,
    max: 40,
    step: 1,
    group: "Header"
  },
  {
    key: "pageTitleFontWeight",
    label: "Title Weight",
    type: "options",
    options: [...Do],
    group: "Header"
  },
  {
    key: "pageTitleColor",
    label: "Title Color",
    type: "color",
    group: "Header"
  },
  // ── Search Bar
  {
    key: "searchPlaceholder",
    label: "Placeholder",
    type: "text",
    group: "Search"
  },
  {
    key: "searchBgColor",
    label: "Background",
    type: "color",
    group: "Search"
  },
  {
    key: "searchBorderColor",
    label: "Border Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchTextColor",
    label: "Text Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchIconColor",
    label: "Icon Color",
    type: "color",
    group: "Search"
  },
  {
    key: "searchBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Search"
  },
  // ── Chat Items
  {
    key: "chatItemBgColor",
    label: "Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemSelectedBgColor",
    label: "Selected Background",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemPreviewColor",
    label: "Preview Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTimestampColor",
    label: "Timestamp Color",
    type: "color",
    group: "Chat Items"
  },
  {
    key: "chatItemTitleFontSize",
    label: "Title Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Chat Items"
  },
  {
    key: "chatItemPreviewFontSize",
    label: "Preview Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Chat Items"
  },
  {
    key: "chatItemBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat Items"
  },
  {
    key: "chatItemPaddingX",
    label: "Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Chat Items"
  },
  {
    key: "chatItemPaddingY",
    label: "Padding Y",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Chat Items"
  },
  // ── Group Headers
  {
    key: "groupHeaderColor",
    label: "Color",
    type: "color",
    group: "Group Headers"
  },
  {
    key: "groupHeaderFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Group Headers"
  },
  {
    key: "groupHeaderFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...Do],
    group: "Group Headers"
  },
  // ── Selection / Bulk Actions
  {
    key: "selectionCheckboxColor",
    label: "Checkbox Color",
    type: "color",
    group: "Selection"
  },
  {
    key: "bulkActionBarBgColor",
    label: "Action Bar BG",
    type: "color",
    group: "Selection"
  },
  {
    key: "bulkActionBarTextColor",
    label: "Action Bar Text",
    type: "color",
    group: "Selection"
  },
  {
    key: "deleteButtonColor",
    label: "Delete Button",
    type: "color",
    group: "Selection"
  },
  // ── Page Background
  { key: "pageBgColor", label: "Page BG", type: "color", group: "Layout" },
  // ── New Chat Button
  {
    key: "newChatButtonBgColor",
    label: "Background",
    type: "color",
    group: "New Chat Button"
  },
  {
    key: "newChatButtonTextColor",
    label: "Text Color",
    type: "color",
    group: "New Chat Button"
  },
  {
    key: "newChatButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "New Chat Button"
  },
  // ── Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  }
], Zs = ({
  widgetId: e = "chat-history",
  displayName: t = "Chat History",
  initialState: n = {},
  wrapperStyle: r,
  children: i
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: h,
    themeColors: g,
    themeFonts: b,
    themeIcons: B,
    resolveColor: z,
    canSave: C
  } = te(
    e,
    { ...al, ...n },
    Oo
  ), x = a.fontFamily, f = x && x !== "inherit" ? b[x] : null, S = f ? null : b.body || Object.values(b)[0] || null, F = f || S, m = F && F.format === "google" ? F.url : null;
  if (X(() => {
    m && il(m);
  }, [m]), l)
    return /* @__PURE__ */ o($, {});
  const H = F ? F.format === "system" ? F.url : `"${F.name}", sans-serif` : "inherit", I = F && F.format !== "system" && F.format !== "google" ? `@font-face {
        font-family: "${F.name}";
        src: url("${F.url}") format("${F.format}");
        font-display: swap;
      }` : "", v = {
    ...a,
    fontFamilyCss: H
  }, k = /* @__PURE__ */ u($, { children: [
    I && /* @__PURE__ */ o("style", { children: I }),
    i(v, z)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Oo,
      editValues: a,
      onEditChange: p,
      onSave: C ? h : void 0,
      isSaving: d,
      themeColors: g,
      themeFonts: b,
      themeIcons: B,
      wrapperStyle: r,
      children: k
    }
  );
}, ll = {
  filled: {
    backgroundColor: s("primary"),
    backgroundColorHover: s("primary"),
    iconColor: s("secondary"),
    borderWidth: 0,
    borderColor: s("transparent"),
    shadowOpacity: 0.25,
    shadowBlur: 50,
    shadowSpread: -12,
    shadowOffsetY: 25
  },
  light: {
    backgroundColor: s("background"),
    backgroundColorHover: s("background"),
    iconColor: s("primary"),
    borderWidth: 0,
    borderColor: s("transparent"),
    shadowOpacity: 0.12,
    shadowBlur: 24,
    shadowSpread: -4,
    shadowOffsetY: 8
  },
  outlined: {
    backgroundColor: s("background"),
    backgroundColorHover: s("background"),
    iconColor: s("primary"),
    borderWidth: 1.5,
    borderColor: s("textPrimary"),
    shadowOpacity: 0,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetY: 0
  }
}, sl = {
  "rounded-square": { borderRadius: 25 },
  circle: { borderRadius: 50 }
}, cl = {
  // Preset selectors
  buttonShape: "circle",
  buttonStyle: "filled",
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors) — derived from "filled" style
  backgroundColor: s("primary"),
  backgroundColorHover: s("primary"),
  iconColor: s("secondary"),
  // Border — derived from "filled" style
  borderWidth: 0,
  borderColor: s("transparent"),
  // Shape — derived from "circle" shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow — derived from "filled" style
  shadowColor: s("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconStyle: "chat-ai",
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11,
  // Feature Prompt Pill
  featurePromptBgColor: s("primary"),
  featurePromptTextColor: s("secondary"),
  featurePromptBorderRadius: 12,
  featurePromptFontSize: 14,
  featurePromptFontWeight: 500
}, jo = [
  // --- Preset selectors ---
  {
    key: "iconStyle",
    label: "Icon",
    type: "options",
    options: [
      { label: "Chat AI", value: "chat-ai" },
      { label: "Search Sparkle", value: "search-sparkle" },
      { label: "Three Sparkles", value: "three-sparkles" },
      { label: "Diamond Sparkles", value: "diamond-sparkles" },
      { label: "Search Star", value: "search-star" },
      { label: "Search Sparkle Alt", value: "search-sparkle-alt" }
    ]
  },
  {
    key: "buttonShape",
    label: "Shape",
    type: "options",
    options: [
      { label: "Circle", value: "circle" },
      { label: "Rounded Square", value: "rounded-square" }
    ]
  },
  {
    key: "buttonStyle",
    label: "Style",
    type: "options",
    options: [
      { label: "Filled", value: "filled" },
      { label: "Light", value: "light" },
      { label: "Outlined", value: "outlined" }
    ]
  },
  // --- Size & Position ---
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Size & Position"
  },
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ],
    group: "Size & Position"
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  // --- Colors ---
  { key: "backgroundColor", label: "Background Color", type: "color", group: "Colors" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color", group: "Colors" },
  { key: "iconColor", label: "Icon Color", type: "color", group: "Colors" },
  // --- Shape ---
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shape"
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 4,
    step: 0.5,
    group: "Shape"
  },
  { key: "borderColor", label: "Border Color", type: "color", group: "Shape" },
  // --- Shadow ---
  { key: "shadowColor", label: "Shadow Color", type: "color", group: "Shadow" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05,
    group: "Shadow"
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5,
    group: "Shadow"
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2,
    group: "Shadow"
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shadow"
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  },
  // Feature Prompt Pill
  {
    key: "featurePromptBgColor",
    label: "Prompt Pill Background",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptTextColor",
    label: "Prompt Pill Text Color",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptBorderRadius",
    label: "Prompt Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontSize",
    label: "Prompt Pill Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1,
    group: "Feature Prompt"
  },
  {
    key: "featurePromptFontWeight",
    label: "Prompt Pill Font Weight",
    type: "number",
    min: 300,
    max: 700,
    step: 100,
    group: "Feature Prompt"
  }
], dl = (e) => {
  const { position: t, horizontalOffset: n, verticalOffset: r, size: i } = e, a = {
    position: "fixed",
    zIndex: 2147483647,
    // Max z-index to ensure it's on top
    minWidth: 0,
    minHeight: 0
  };
  return t.startsWith("bottom") ? a.bottom = r + i - 8 : a.top = r - 8, t.endsWith("left") ? a.left = n + i - 8 : a.right = n - 8, a;
}, Vs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const [i, a] = j(!1), [l, d] = j({ x: 0, y: 0 }), [p, h] = j(null), [g, b] = j(!1), [B, z] = j(!1), C = le(null), x = Zt(), {
    state: f,
    isLoading: S,
    isSaving: F,
    handleEditChange: m,
    handleSave: H,
    themeColors: y,
    resolveColor: I,
    canSave: v,
    studioLockedKeys: k
  } = te(t, { ...cl, ...e }, jo), T = me(
    (L, R) => {
      if (m(L, R), L === "buttonStyle") {
        const D = ll[R];
        D && Object.entries(D).forEach(([N, Y]) => {
          m(N, Y);
        });
      }
      if (L === "buttonShape") {
        const D = sl[R];
        D && m("borderRadius", D.borderRadius);
      }
    },
    [m]
  ), A = me(() => p ? JSON.stringify(f) !== JSON.stringify(p) : !1, [f, p]);
  if (X(() => t ? Dn((R) => {
    R !== t && i && (A() ? b(!0) : a(!1));
  }) : void 0, [t, i, A]), S)
    return /* @__PURE__ */ o($, {});
  const P = r(f, I);
  if (!x)
    return /* @__PURE__ */ o($, { children: P });
  const W = () => {
    if (C.current) {
      const L = C.current.getBoundingClientRect(), R = window.innerWidth, D = window.innerHeight, N = 620, Y = 450, G = 10, K = D - L.bottom, Q = L.top, _ = R - L.left, re = L.right;
      let V;
      K >= Y + G ? V = L.bottom + G : Q >= Y + G ? V = L.top - Y - G : K >= Q ? V = Math.max(G, D - Y - G) : V = Math.max(G, L.top - Y - G);
      let ne;
      _ >= N ? ne = L.left : re >= N ? ne = L.right - N : ne = Math.max(G, Math.min(R - N - G, L.left)), ne = Math.max(G, Math.min(ne, R - N - G)), V = Math.max(G, Math.min(V, D - Y - G)), d({ x: ne, y: V });
    }
    h({ ...f }), a(!0), t && Wn(t);
  }, w = () => {
    p && Object.keys(p).forEach((L) => {
      T(L, p[L]);
    });
  }, M = () => {
    H && v && H(), h({ ...f });
  }, O = () => {
    b(!1), a(!1);
  }, J = () => {
    M(), b(!1), a(!1);
  };
  return /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${c.white};
          border: 1px solid ${c.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${c.blue_light};
          border-color: ${c.blue};
        }
      ` }),
    /* @__PURE__ */ u(
      "div",
      {
        onMouseEnter: () => z(!0),
        onMouseLeave: () => z(!1),
        style: { display: "contents" },
        children: [
          P,
          /* @__PURE__ */ o(
            "button",
            {
              ref: C,
              className: `floating-button-edit-icon ${B || i ? "visible" : ""}`,
              style: dl(f),
              onMouseDown: (L) => {
                L.stopPropagation();
              },
              onClick: (L) => {
                L.stopPropagation(), L.preventDefault(), W();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ o(Pn, { size: 16, color: c.gray_dark })
            }
          )
        ]
      }
    ),
    i && /* @__PURE__ */ o(
      On,
      {
        widgetId: t,
        displayName: n,
        fields: jo,
        values: f,
        initialValues: p || void 0,
        onChange: T,
        onClose: () => a(!1),
        onReset: w,
        screenPosition: l,
        onSave: M,
        isSaving: F,
        themeColors: y,
        studioLockedKeys: k
      }
    ),
    g && /* @__PURE__ */ o(
      rt,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: J,
        onCancel: O,
        isLoading: F
      }
    )
  ] });
}, pl = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: s("background"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: s("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: s("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: s("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: s("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: s("background"),
  suggestionPillBgColor: s("transparent"),
  suggestionPillBgColorHover: s("background"),
  suggestionPillTextColor: s("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Go = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ge]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], qs = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    resolveColor: g,
    canSave: b
  } = te(
    t,
    { ...pl, ...e },
    Go
  );
  if (a)
    return /* @__PURE__ */ o($, {});
  const B = r(i, g);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Go,
      editValues: i,
      onEditChange: d,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: h,
      children: B
    }
  );
}, gl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, ml = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: s("secondary"),
  pillBorderColor: s("secondary"),
  pillTextColor: s("textPrimary"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: s("secondary"),
  arrowBorderColor: s("secondary"),
  arrowIconColor: s("textPrimary"),
  // Title
  titleColor: s("textPrimary"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, $o = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], Ks = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B,
    getEditValues: z
  } = te(
    t,
    { ...ml, ...e },
    $o
  ), C = i.titleFontFamily, x = C && C !== "inherit" ? g[C] : null, f = x && x.format === "google" ? x.url : null;
  if (X(() => {
    f && gl(f);
  }, [f]), a)
    return /* @__PURE__ */ o($, {});
  const S = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", F = x && x.format !== "system" && x.format !== "google", m = `trending-card-${t || "default"}`, H = `
    ${F ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${m} [data-title-text] { font-family: ${S} !important; }` : ""}
  `.trim(), y = {
    ...i,
    titleFontFamilyCss: S
  }, I = /* @__PURE__ */ u($, { children: [
    H && /* @__PURE__ */ o("style", { children: H }),
    r(y, b)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: $o,
      editValues: z(),
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: I
    }
  );
}, ul = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, hl = {
  // Preset
  preset: "plain",
  // Layout direction
  layout: "vertical",
  // Container
  containerGap: 8,
  containerBgColor: s("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Icon
  showIcon: !1,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: s("borderColor"),
  pillBorderWidth: 1,
  pillBgColor: s("secondary"),
  pillBgColorHover: s("background"),
  pillTextColor: s("textPrimary"),
  pillShadowEnabled: !1,
  pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, yl = {
  // --- Base: transparent bg, thin light border ---
  plain: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "plain-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Highlighted: container bg, no pill border ---
  highlighted: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("transparent"),
    pillBorderWidth: 0,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "highlighted-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("transparent"),
    pillBorderWidth: 0,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Container bg with thin border on pills ---
  "container-bg": {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "container-bg-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: s("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Extras: stronger border treatment ---
  bordered: {
    showIcon: !1,
    containerGap: 6,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-icon": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: s("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-highlighted": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: s("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: s("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: s("secondary"),
    pillBgColorHover: s("background"),
    pillTextColor: s("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  }
}, bl = [
  { label: "Plain", value: "plain" },
  { label: "Plain + Icon", value: "plain-icon" },
  { label: "Highlighted", value: "highlighted" },
  { label: "Highlighted + Icon", value: "highlighted-icon" },
  { label: "Container BG", value: "container-bg" },
  { label: "Container BG + Icon", value: "container-bg-icon" },
  { label: "Bordered", value: "bordered" },
  { label: "Bordered + Icon", value: "bordered-icon" },
  { label: "Bordered Highlighted", value: "bordered-highlighted" },
  { label: "Custom", value: "custom" }
], Yo = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: bl
  },
  // Layout direction
  {
    key: "layout",
    label: "Layout",
    type: "options",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  // Icon toggle
  { key: "showIcon", label: "Show Arrow Icon", type: "toggle" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Shadow Value (CSS)", type: "text" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ge]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" },
  // Shadow
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Pill Shadow CSS", type: "text" }
], ec = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...hl, ...e },
    Yo
  ), z = (T, A) => {
    if (T === "preset" && A !== "custom") {
      const W = yl[A];
      if (W) {
        d("preset", A), Object.entries(W).forEach(([w, M]) => {
          d(w, M);
        });
        return;
      }
    }
    d(T, A);
  }, C = i.pillFontFamily, x = C && C !== "inherit" ? g[C] : null, f = x && x.format === "google" ? x.url : null;
  if (X(() => {
    f && ul(f);
  }, [f]), a)
    return /* @__PURE__ */ o($, {});
  const S = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", F = x && x.format !== "system" && x.format !== "google", m = `suggestion-list-${t || "default"}`, H = `
    ${F ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${S !== "inherit" ? `.${m} { font-family: ${S} !important; }` : ""}
  `.trim(), y = {
    ...i,
    pillFontFamilyCss: S
  }, I = b(i.containerBgColor), v = I && I !== "transparent" && I !== "", k = /* @__PURE__ */ u($, { children: [
    H && /* @__PURE__ */ o("style", { children: H }),
    /* @__PURE__ */ o(
      "div",
      {
        className: m,
        style: {
          backgroundColor: v ? I : void 0,
          padding: v || i.containerPaddingX || i.containerPaddingY ? `${i.containerPaddingY}px ${i.containerPaddingX}px` : void 0,
          borderRadius: i.containerBorderRadius > 0 ? `${i.containerBorderRadius}px` : void 0
        },
        children: r(y, b)
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Yo,
      editValues: i,
      onEditChange: z,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: k
    }
  );
}, Qo = {
  "vertical-compact": {
    panel: {
      mainBgColor: s("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillTextColor: s("textPrimary"),
      pillContainerBgColor: s("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: q("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: s("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillBorderRadius: 8,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillBgColorHover: s("background"),
      pillTextColor: s("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: q("#F3F3F3"),
      borderColorFocus: s("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "vertical-expanded": {
    panel: {
      mainBgColor: s("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: q("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
      pillBgColor: s("secondary"),
      pillTextColor: s("textPrimary"),
      pillContainerBgColor: s("transparent"),
      pillContainerBorderRadius: 12,
      inputBorderColor: q("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: s("transparent"),
      containerPaddingX: 12,
      containerPaddingY: 12,
      containerBorderRadius: 12,
      pillBorderRadius: 100,
      pillBorderColor: q("#F3F3F3"),
      pillBorderWidth: 1,
      pillShadowEnabled: !0,
      pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
      pillBgColor: s("secondary"),
      pillBgColorHover: s("background"),
      pillTextColor: s("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: q("#F3F3F3"),
      borderColorFocus: s("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  },
  "horizontal-compact": {
    panel: {
      mainBgColor: s("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillTextColor: s("textPrimary"),
      pillContainerBgColor: s("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: q("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 56
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: s("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillBgColorHover: s("background"),
      pillTextColor: s("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: q("#F3F3F3"),
      borderColorFocus: s("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 56
    }
  },
  "horizontal-expanded": {
    panel: {
      mainBgColor: s("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillTextColor: s("textPrimary"),
      pillContainerBgColor: s("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: q("#F3F3F3"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 116
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: s("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: s("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: s("secondary"),
      pillBgColorHover: s("background"),
      pillTextColor: s("textPrimary")
    },
    chatInput: {
      fontSize: 14,
      iconSize: 20,
      iconGap: 6,
      paddingX: 12,
      paddingY: 12,
      borderColor: q("#F3F3F3"),
      borderColorFocus: s("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 116
    }
  }
}, fl = [
  { label: "Vertical + Compact Input", value: "vertical-compact" },
  { label: "Vertical + Expanded Input", value: "vertical-expanded" },
  { label: "Horizontal + Compact Input", value: "horizontal-compact" },
  { label: "Horizontal + Expanded Input", value: "horizontal-expanded" },
  { label: "Custom", value: "custom" }
], Xo = [
  // --- General ---
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: fl
  },
  { key: "mainBgColor", label: "Background", type: "color" },
  // --- Suggestion Pills group ---
  {
    key: "pillLayout",
    label: "Layout",
    type: "options",
    group: "Suggestion Pills",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  {
    key: "pillShowIcon",
    label: "Show Icon",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderColor",
    label: "Border Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5,
    group: "Suggestion Pills"
  },
  {
    key: "pillBgColor",
    label: "Background",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillTextColor",
    label: "Text Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Suggestion Pills"
  },
  // --- Input Box group ---
  {
    key: "inputBorderColor",
    label: "Border Color",
    type: "color",
    group: "Input Box"
  },
  {
    key: "inputBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 0.5,
    group: "Input Box"
  },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Input Box"
  },
  {
    key: "inputMinHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10,
    group: "Input Box"
  },
  {
    key: "inputShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Input Box"
  },
  {
    key: "inputShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Input Box"
  }
], xl = {
  preset: "vertical-expanded",
  mainBgColor: s("transparent"),
  // Pill defaults (vertical-expanded) — border 1px #F3F3F3, radius 100px, shadow per mock
  pillLayout: "vertical",
  pillShowIcon: !1,
  pillBorderRadius: 100,
  pillBorderColor: q("#F3F3F3"),
  pillBorderWidth: 1,
  pillBgColor: s("secondary"),
  pillTextColor: s("textPrimary"),
  pillShadowEnabled: !0,
  pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)",
  pillContainerBgColor: s("transparent"),
  pillContainerBorderRadius: 12,
  // Input defaults (vertical-expanded: taller input 116px, rounded rect)
  inputBorderColor: q("#F3F3F3"),
  inputBorderWidth: 1,
  inputBorderRadius: 20,
  inputMinHeight: 116,
  inputShadowEnabled: !1,
  inputShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)"
}, tc = ({
  widgetId: e = "concierge-panel",
  displayName: t = "Concierge Panel",
  initialState: n = {},
  suggestionListWidgetId: r = "concierge-suggestion-list",
  chatInputWidgetId: i = "concierge-chat-input",
  suppressChildEdits: a = !0,
  children: l
}) => {
  const {
    state: d,
    isLoading: p,
    isSaving: h,
    handleEditChange: g,
    handleSave: b,
    themeColors: B,
    themeFonts: z,
    resolveColor: C,
    canSave: x
  } = te(
    e,
    { ...xl, ...n },
    Xo
  ), { updateWidgetConfig: f, getWidgetState: S } = Dt(
    r
  ), { updateWidgetConfig: F, getWidgetState: m } = Dt(i), H = le(!1);
  X(() => {
    if (p || d.preset === "custom" || H.current) return;
    const A = Qo[d.preset];
    if (A) {
      H.current = !0;
      const P = S() || {};
      Object.entries(A.suggestionList).forEach(([w, M]) => {
        w in P || f(w, M);
      });
      const W = m() || {};
      Object.entries(A.chatInput).forEach(([w, M]) => {
        w in W || F(w, M);
      });
    }
  }, [p, d.preset, f, F, S, m]);
  const y = {
    pillLayout: "layout",
    pillShowIcon: "showIcon",
    pillBorderRadius: "pillBorderRadius",
    pillBorderColor: "pillBorderColor",
    pillBorderWidth: "pillBorderWidth",
    pillBgColor: "pillBgColor",
    pillTextColor: "pillTextColor",
    pillShadowEnabled: "pillShadowEnabled",
    pillShadow: "pillShadow",
    pillContainerBgColor: "containerBgColor",
    pillContainerBorderRadius: "containerBorderRadius"
  }, I = {
    inputBorderColor: "borderColor",
    inputBorderWidth: "borderWidth",
    inputBorderRadius: "borderRadiusSingleLine",
    inputMinHeight: "minHeight",
    inputShadowEnabled: "shadowEnabled",
    inputShadow: "shadow"
  }, v = me(
    (A, P) => {
      if (A === "preset" && P !== "custom") {
        const w = Qo[P];
        if (w) {
          g("preset", P), w.panel && Object.entries(w.panel).forEach(([M, O]) => {
            g(M, O);
          }), Object.entries(w.suggestionList).forEach(([M, O]) => {
            f(M, O);
          }), Object.entries(w.chatInput).forEach(([M, O]) => {
            F(M, O);
          });
          return;
        }
      }
      if (A in y) {
        g("preset", "custom"), g(A, P), f(y[A], P);
        return;
      }
      if (A in I) {
        g("preset", "custom"), g(A, P), F(I[A], P);
        return;
      }
      g(A, P);
    },
    [g, f, F]
  );
  if (p)
    return /* @__PURE__ */ o($, {});
  const k = l(d, C);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Xo,
      editValues: d,
      onEditChange: v,
      onSave: x ? b : void 0,
      isSaving: h,
      themeColors: B,
      themeFonts: z,
      containerClassName: "widget-fill-height",
      children: a ? /* @__PURE__ */ o(Ui, { children: k }) : k
    }
  );
}, Jo = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Cl = {
  // Card/Pill container
  borderColor: s("borderColor"),
  borderColorSelected: s("primary"),
  backgroundColor: s("secondary"),
  backgroundColorHover: s("background"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: s("primary"),
  checkmarkIconColor: s("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: s("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: s("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: s("background"),
  dividerColorSelected: s("primary")
}, Uo = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...ge]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...ge]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], oc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...Cl, ...e },
    Uo
  ), z = i.priceFontFamily, C = z && z !== "inherit" ? g[z] : null, x = i.nameFontFamily, f = x && x !== "inherit" ? g[x] : null, S = C && C.format === "google" ? C.url : null, F = f && f.format === "google" ? f.url : null;
  if (X(() => {
    S && Jo(S);
  }, [S]), X(() => {
    F && Jo(F);
  }, [F]), a)
    return /* @__PURE__ */ o($, {});
  const m = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", H = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", y = C && C.format !== "system" && C.format !== "google", I = f && f.format !== "system" && f.format !== "google", v = `variant-picker-${t || "default"}`, k = `
    ${y ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${v} [data-price-text] { font-family: ${m} !important; }` : ""}
    ${H !== "inherit" ? `.${v} [data-name-text] { font-family: ${H} !important; }` : ""}
  `.trim(), T = {
    ...i,
    priceFontFamilyCss: m,
    nameFontFamilyCss: H
  }, A = /* @__PURE__ */ u($, { children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(T, b)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Uo,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: A
    }
  );
}, kl = {
  overlayBgColor: q("rgba(0, 0, 0, 0.45)"),
  dialogBgColor: s("secondary"),
  dialogBorderRadius: 12,
  titleColor: s("textPrimary"),
  messageColor: s("textPrimary"),
  cancelButtonBgColor: s("secondary"),
  cancelButtonBorderColor: s("borderColor"),
  cancelButtonTextColor: s("textPrimary"),
  confirmButtonBgColor: s("primary"),
  confirmButtonTextColor: s("primaryForeground")
}, _o = [
  { key: "overlayBgColor", label: "Overlay Background", type: "color" },
  { key: "dialogBgColor", label: "Dialog Background", type: "color" },
  {
    key: "dialogBorderRadius",
    label: "Dialog Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  { key: "messageColor", label: "Message Color", type: "color" },
  {
    key: "cancelButtonBgColor",
    label: "Cancel Button Background",
    type: "color"
  },
  {
    key: "cancelButtonBorderColor",
    label: "Cancel Button Border",
    type: "color"
  },
  {
    key: "cancelButtonTextColor",
    label: "Cancel Button Text",
    type: "color"
  },
  {
    key: "confirmButtonBgColor",
    label: "Confirm Button Background",
    type: "color"
  },
  {
    key: "confirmButtonTextColor",
    label: "Confirm Button Text",
    type: "color"
  }
], nc = ({ initialState: e = {}, widgetId: t, displayName: n, overlay: r, children: i }) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: h,
    themeColors: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...kl, ...e },
    _o
  );
  if (l)
    return /* @__PURE__ */ o($, {});
  const z = r ? r(a, b) : null, C = i(a, b);
  return /* @__PURE__ */ u($, { children: [
    z,
    /* @__PURE__ */ o(
      U,
      {
        widgetId: t,
        displayName: n,
        editFields: _o,
        editValues: a,
        onEditChange: p,
        onSave: B ? h : void 0,
        isSaving: d,
        themeColors: g,
        triggerMode: "persistent",
        triggerPosition: "top-right",
        wrapperStyle: { width: "100%", maxWidth: "28rem" },
        children: C
      }
    )
  ] });
}, vl = {
  dialogBgColor: s("secondary"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  titleFontSize: 24,
  titleColor: s("textPrimary"),
  descriptionFontSize: 16,
  descriptionColor: s("textPrimary"),
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: q("#f5f5f5"),
  primaryButtonBgColor: s("textPrimary"),
  primaryButtonTextColor: s("secondary"),
  primaryButtonBorderRadius: 999,
  cancelTextColor: s("textPrimary")
}, Zo = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  { key: "logoContainerSize", label: "Icon Size", type: "number", min: 32, max: 96, step: 4, group: "Logo" },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  { key: "titleFontSize", label: "Font Size", type: "number", min: 16, max: 32, step: 1, group: "Title" },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Description ───────────────────────────────────────────────────────
  { key: "descriptionFontSize", label: "Font Size", type: "number", min: 12, max: 20, step: 1, group: "Description" },
  { key: "descriptionColor", label: "Color", type: "color", group: "Description" },
  // ── Button ────────────────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background", type: "color", group: "Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Button"
  },
  { key: "cancelTextColor", label: "Cancel Text Color", type: "color", group: "Button" }
], rc = ({ initialState: e = {}, widgetId: t, displayName: n, children: r }) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeIcons: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...vl, ...e },
    Zo
  ), z = i.logoIcon && i.logoIcon !== "default" ? g[i.logoIcon] : null, C = z ? z.url : null;
  return a ? /* @__PURE__ */ o($, {}) : /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: Zo,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeIcons: g,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%", maxWidth: "28rem" },
      children: r(i, b, C)
    }
  );
}, wl = {
  // Dialog container
  dialogBgColor: q("#ffffff"),
  dialogBorderRadius: 16,
  dialogPadding: 40,
  // Logo circle
  logoIcon: "default",
  logoContainerSize: 64,
  logoContainerBgColor: s("primary"),
  // Title
  titleFontSize: 24,
  titleColor: s("textPrimary"),
  // Subtitle
  subtitleFontSize: 16,
  subtitleColor: s("textPrimary"),
  // Input field
  inputBorderRadius: 6,
  inputBorderColor: q("#dcdddc"),
  // Continue (primary) button
  primaryButtonBgColor: s("textPrimary"),
  primaryButtonDisabledBgColor: q("#DCDCDC"),
  primaryButtonTextColor: q("#ffffff"),
  primaryButtonBorderRadius: 999,
  // Resend (secondary/outlined) button
  secondaryButtonBorderColor: s("textPrimary"),
  secondaryButtonDisabledBorderColor: q("#DCDCDC"),
  secondaryButtonTextColor: s("textPrimary"),
  secondaryButtonBorderRadius: 999,
  // Back / cancel text
  cancelTextColor: s("textPrimary")
}, Vo = [
  // ── Dialog ────────────────────────────────────────────────────────────
  { key: "dialogBgColor", label: "Background", type: "color", group: "Dialog" },
  {
    key: "dialogBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 1,
    group: "Dialog"
  },
  {
    key: "dialogPadding",
    label: "Padding",
    type: "number",
    min: 16,
    max: 60,
    step: 4,
    group: "Dialog"
  },
  // ── Logo ──────────────────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Image", type: "icon", group: "Logo" },
  {
    key: "logoContainerSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 96,
    step: 4,
    group: "Logo"
  },
  { key: "logoContainerBgColor", label: "Background", type: "color", group: "Logo" },
  // ── Title ─────────────────────────────────────────────────────────────
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Title"
  },
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  // ── Subtitle ──────────────────────────────────────────────────────────
  {
    key: "subtitleFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Subtitle"
  },
  { key: "subtitleColor", label: "Color", type: "color", group: "Subtitle" },
  // ── Input ─────────────────────────────────────────────────────────────
  { key: "inputBorderColor", label: "Border Color", type: "color", group: "Input" },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1,
    group: "Input"
  },
  // ── Continue Button ───────────────────────────────────────────────────
  { key: "primaryButtonBgColor", label: "Background (Active)", type: "color", group: "Continue Button" },
  { key: "primaryButtonDisabledBgColor", label: "Background (Disabled)", type: "color", group: "Continue Button" },
  { key: "primaryButtonTextColor", label: "Text Color", type: "color", group: "Continue Button" },
  {
    key: "primaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Continue Button"
  },
  // ── Resend Button ─────────────────────────────────────────────────────
  { key: "secondaryButtonBorderColor", label: "Border (Active)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonDisabledBorderColor", label: "Border (Disabled)", type: "color", group: "Resend Button" },
  { key: "secondaryButtonTextColor", label: "Text Color", type: "color", group: "Resend Button" },
  {
    key: "secondaryButtonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 999,
    step: 1,
    group: "Resend Button"
  },
  // ── Cancel ────────────────────────────────────────────────────────────
  { key: "cancelTextColor", label: "Back Text Color", type: "color", group: "Cancel" }
], ic = ({
  widgetId: e,
  displayName: t,
  initialState: n = {},
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeIcons: g,
    resolveColor: b,
    canSave: B
  } = te(
    e,
    { ...wl, ...n },
    Vo
  ), z = i.logoIcon && i.logoIcon !== "default" ? g[i.logoIcon] : null, C = z ? z.url : null;
  return a ? /* @__PURE__ */ o($, {}) : /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: Vo,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeIcons: g,
      triggerMode: "persistent",
      triggerPosition: "top-right",
      wrapperStyle: { width: "100%" },
      children: r(i, b, C)
    }
  );
}, Sl = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: s("textPrimary"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: s("textPrimary"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: s("textPrimary"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: s("textPrimary"),
  thinkingTextFontSize: 14,
  thinkingBgColor: s("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: s("background"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, qo = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: ge
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], ac = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    themeIcons: b,
    resolveColor: B,
    canSave: z
  } = te(
    t,
    { ...Sl, ...e },
    qo
  );
  if (a)
    return /* @__PURE__ */ o($, {});
  const C = r(i, B);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: qo,
      editValues: i,
      onEditChange: d,
      onSave: z ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      themeIcons: b,
      children: C
    }
  );
}, Bl = {
  // Container styling
  containerBgColor: s("secondary"),
  containerBorderRadius: 16,
  containerPaddingX: 24,
  containerPaddingY: 24,
  containerBorderWidth: 1,
  containerBorderColor: s("background"),
  // Icon styling
  iconBgColor: s("primary"),
  iconColor: s("secondary"),
  iconSize: 40,
  // Title styling
  titleColor: s("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "700",
  // Description styling
  descriptionColor: s("textPrimary"),
  descriptionFontSize: 14,
  // Button styling
  buttonBgColor: s("primary"),
  buttonTextColor: s("buttonText"),
  buttonFontSize: 14,
  buttonFontWeight: "600",
  buttonBorderRadius: 10,
  buttonPaddingX: 20,
  buttonPaddingY: 10
}, Ko = [
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24
  },
  {
    key: "containerBorderWidth",
    label: "Container Border Width",
    type: "number",
    min: 0,
    max: 4
  },
  { key: "containerBorderColor", label: "Container Border Color", type: "color" },
  { key: "iconBgColor", label: "Icon Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 24
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 10,
    max: 20
  },
  { key: "buttonBgColor", label: "Button Background", type: "color" },
  { key: "buttonTextColor", label: "Button Text Color", type: "color" },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius",
    type: "number",
    min: 0,
    max: 24
  }
], Il = ({ size: e, color: t }) => /* @__PURE__ */ u(
  "svg",
  {
    width: e * 0.5,
    height: e * 0.5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ o("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
      /* @__PURE__ */ o("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
    ]
  }
), lc = ({
  widgetId: e,
  title: t,
  description: n,
  buttonText: r,
  onSignIn: i,
  disabled: a = !1,
  initialState: l
}) => {
  const {
    state: d,
    handleEditChange: p,
    handleSave: h,
    isSaving: g,
    getEditValues: b,
    resolveColor: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x
  } = te(
    e,
    { ...Bl, ...l },
    Ko
  );
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: "Prompt Login",
      editFields: Ko,
      editValues: b(),
      onEditChange: p,
      onSave: h,
      isSaving: g,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: /* @__PURE__ */ u(
        "div",
        {
          style: {
            backgroundColor: B(d.containerBgColor),
            borderRadius: `${d.containerBorderRadius}px`,
            padding: `${d.containerPaddingY}px ${d.containerPaddingX}px`,
            border: `${d.containerBorderWidth}px solid ${B(d.containerBorderColor)}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)"
          },
          children: [
            /* @__PURE__ */ o(
              "div",
              {
                style: {
                  width: `${d.iconSize}px`,
                  height: `${d.iconSize}px`,
                  borderRadius: "50%",
                  backgroundColor: B(d.iconBgColor),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ o(
                  Il,
                  {
                    size: d.iconSize,
                    color: B(d.iconColor)
                  }
                )
              }
            ),
            /* @__PURE__ */ u("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    color: B(d.titleColor),
                    fontSize: `${d.titleFontSize}px`,
                    fontWeight: d.titleFontWeight,
                    lineHeight: 1.4
                  },
                  children: t
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    color: B(d.descriptionColor),
                    fontSize: `${d.descriptionFontSize}px`,
                    lineHeight: 1.5
                  },
                  children: n
                }
              )
            ] }),
            i && /* @__PURE__ */ o(
              "button",
              {
                onClick: a ? void 0 : i,
                style: {
                  backgroundColor: B(d.buttonBgColor),
                  color: B(d.buttonTextColor),
                  fontSize: `${d.buttonFontSize}px`,
                  fontWeight: d.buttonFontWeight,
                  borderRadius: `${d.buttonBorderRadius}px`,
                  padding: `${d.buttonPaddingY}px ${d.buttonPaddingX}px`,
                  border: "none",
                  cursor: a ? "default" : "pointer",
                  transition: "opacity 0.15s ease",
                  opacity: a ? 0.5 : 1,
                  width: "100%",
                  maxWidth: "200px",
                  letterSpacing: "0.01em",
                  pointerEvents: a ? "none" : "auto",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                onMouseEnter: (f) => {
                  a || (f.currentTarget.style.opacity = "0.88");
                },
                onMouseLeave: (f) => {
                  a || (f.currentTarget.style.opacity = "1");
                },
                children: a ? "Loading ..." : r
              }
            )
          ]
        }
      )
    }
  );
}, en = [
  "concierge-home-greeting",
  "concierge-home-subtitle",
  "concierge-home-starters",
  "concierge-home-logo",
  "concierge-home-brand-label",
  "concierge-chat-input"
], Pe = {
  "concierge-home-greeting": {
    greetingFontWeight: "semibold"
  },
  "concierge-home-subtitle": {
    fontWeight: "semibold"
  },
  "concierge-chat-input": {
    fontSize: 16,
    mobile_fontSize: 12,
    iconSize: 24,
    submitButtonSize: 24,
    iconGap: 12
  }
}, et = {
  preset: "expanded",
  shadowEnabled: !0,
  shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
  borderColor: s("borderColor"),
  borderColorFocus: s("borderColor"),
  borderRadiusSingleLine: 28,
  borderRadiusMultiLine: 28,
  borderWidth: 1,
  paddingX: 16,
  paddingY: 16,
  minHeight: 138,
  fontSize: 16,
  mobile_fontSize: 14,
  iconSize: 24,
  submitButtonSize: 24,
  iconGap: 12,
  mobile_minHeight: 116,
  mobile_paddingX: 14,
  mobile_paddingY: 14,
  mobile_borderRadiusSingleLine: 26,
  mobile_borderRadiusMultiLine: 26
}, Pl = {
  // =========================================================================
  // A-Series: Minimal / brand-focused layouts
  // =========================================================================
  /** A1 - Minimal: Logo only + search bar */
  A1: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe
    }
  },
  /** A2 - Logo + Subtitle: Logo with assistant intro text */
  A2: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-hero-logo",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-subtitle": {
        fontSize: 24,
        fontWeight: "semibold",
        mobile_fontSize: 18
      },
      "concierge-home-logo": {
        marginBottom: 32,
        mobile_marginBottom: 20
      }
    }
  },
  /** A3 - Branded Logo: "CONCIERGE BY" label above logo */
  A3: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "above-hero-logo",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 48,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-brand-label": {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 16,
        mobile_fontSize: 12,
        mobile_marginBottom: 8
      }
    }
  },
  /** A4 - Subtitle + Pills: Subtitle text with pill starters, logo in footer */
  A4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A5 - Greeting + Pills: Personalized greeting with pill starters */
  A5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      }
    }
  },
  /** A6 - Inline Icon Greeting + Pills: Greeting with inline icon before text and pill starters */
  A6: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "inline",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16,
        mobile_greetingMarginBottom: 8
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        marginBottom: 0
      },
      "concierge-home-starters": {
        containerMarginTop: 24
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        preset: "expanded",
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: s("borderColor"),
        borderColorFocus: s("borderColor"),
        borderRadiusSingleLine: 28,
        borderRadiusMultiLine: 28,
        borderWidth: 1,
        paddingX: 16,
        paddingY: 16,
        minHeight: 138,
        fontSize: 16,
        mobile_fontSize: 14,
        iconSize: 24,
        submitButtonSize: 24,
        iconGap: 12,
        mobile_minHeight: 116,
        mobile_paddingX: 14,
        mobile_paddingY: 14,
        mobile_borderRadiusSingleLine: 26,
        mobile_borderRadiusMultiLine: 26
      }
    }
  },
  /** A7 - Icon Above Greeting + Pills: Greeting with icon above text and pill starters */
  A7: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "above",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      "concierge-home-greeting": {
        greetingFontWeight: "semibold",
        greetingMarginBottom: 16
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        lineHeight: 1.2,
        letterSpacing: 0.08,
        maxWidth: 830,
        marginBottom: 0
      },
      "concierge-home-starters": {
        pillPaddingX: 24,
        pillPaddingY: 12,
        pillBgColor: s("secondary"),
        pillFontWeight: "medium",
        pillShadowEnabled: !0,
        pillShadow: "0 4px 16px 0 rgba(0, 0, 0, 0.05)"
      },
      "concierge-home-logo": {
        logoWidth: 160,
        marginBottom: 64
      },
      "concierge-chat-input": {
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: s("borderColor"),
        borderColorFocus: s("borderColor"),
        borderRadiusSingleLine: 28,
        borderRadiusMultiLine: 28,
        submitButtonIconColor: s("background"),
        submitButtonSize: 24,
        iconSize: 24,
        iconGap: 12,
        fontSize: 16,
        mobile_fontSize: 14,
        paddingX: 16,
        paddingY: 16,
        minHeight: 138,
        mobile_minHeight: 116,
        mobile_paddingX: 14,
        mobile_paddingY: 14,
        mobile_borderRadiusSingleLine: 26,
        mobile_borderRadiusMultiLine: 26
      }
    }
  },
  // =========================================================================
  // B-Series: Greeting + conversation starters focused
  // =========================================================================
  /** B1 - Card Starters Row: Greeting with 4 cards in a horizontal row */
  B1: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-row",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "cards-grid"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": et
    }
  },
  /** B2 - Icon Pills: Greeting with 3 icon-pill starters, logo after content */
  B2: {
    layout: {
      logoPosition: "after-content",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 56,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-chat-input": et
    }
  },
  /** B3 - Icon Pills + Branded Footer: 3 icon-pill starters with "CONCIERGE BY" footer */
  B3: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": et
    }
  },
  /** B4 - Card Grid: Greeting with 2x2 inline-icon card grid */
  B4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-grid",
      maxStarters: 4,
      cardLayoutDirection: "inline",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "pills-icons-list"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": et
    }
  },
  /** B5 - Pills + Branded Footer: Greeting with pills and "EMBER BY" footer */
  B5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 0,
      searchInputGap: 32,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...Pe,
      "concierge-home-greeting": { greetingMarginBottom: 16 },
      "concierge-home-logo": { marginBottom: 64 },
      "concierge-chat-input": et
    }
  }
}, zl = {
  A1: "A1 - Minimal (Logo only)",
  A2: "A2 - Logo + Subtitle",
  A3: "A3 - Branded Logo",
  A4: "A4 - Subtitle + Pills",
  A5: "A5 - Greeting + Pills",
  A6: "A6 - Inline Icon Greeting + Pills",
  A7: "A7 - Icon Above Greeting + Pills",
  B1: "B1 - Card Starters (Row)",
  B2: "B2 - Icon Pills",
  B3: "B3 - Icon Pills + Branded Footer",
  B4: "B4 - Card Starters (Grid)",
  B5: "B5 - Pills + Branded Footer",
  custom: "Custom"
}, Fl = {
  layoutPreset: "A1",
  backgroundStyle: "colored",
  backgroundColor: s("background"),
  elementStyle: "default",
  logoPosition: "hero",
  brandLabelPosition: "hidden",
  showGreeting: !1,
  showGreetingIcon: !1,
  greetingIconPosition: "above",
  subtitlePosition: "hidden",
  startersMode: "hidden",
  maxStarters: 4,
  cardLayoutDirection: "stacked",
  footerGap: 8,
  footerPaddingBottom: 0,
  searchInputGap: 32,
  mobile_logoPosition: "hero",
  mobile_startersMode: "inherit"
}, Tl = Object.entries(zl).map(([e, t]) => ({
  label: t,
  value: e
})), tn = [
  // Preset
  {
    key: "layoutPreset",
    label: "Layout Preset",
    type: "options",
    options: Tl,
    group: "Preset"
  },
  // Background
  {
    key: "backgroundStyle",
    label: "Background",
    type: "options",
    options: [
      { label: "Colored", value: "colored" },
      { label: "White", value: "white" }
    ],
    group: "Background"
  },
  {
    key: "backgroundColor",
    label: "Background Color",
    type: "color",
    group: "Background",
    condition: { field: "backgroundStyle", value: "colored" }
  },
  {
    key: "elementStyle",
    label: "Element Style",
    type: "options",
    options: [
      { label: "Default", value: "default" },
      { label: "Grey Fill", value: "grey-fill" },
      { label: "Grey Fill + Stroke", value: "grey-fill-stroke" }
    ],
    group: "Background"
  },
  // Sections
  {
    key: "logoPosition",
    label: "Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "After Content", value: "after-content" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "brandLabelPosition",
    label: "Brand Label",
    type: "options",
    options: [
      { label: "Above Hero Logo", value: "above-hero-logo" },
      { label: "Above Footer Logo", value: "above-footer-logo" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "showGreeting",
    label: "Show Greeting",
    type: "toggle",
    group: "Sections"
  },
  {
    key: "showGreetingIcon",
    label: "Show Greeting Icon",
    type: "toggle",
    group: "Sections",
    condition: "showGreeting"
  },
  {
    key: "greetingIconPosition",
    label: "Icon Position",
    type: "options",
    options: [
      { label: "Above Greeting", value: "above" },
      { label: "Inline (before text)", value: "inline" }
    ],
    group: "Sections",
    condition: "showGreetingIcon"
  },
  {
    key: "subtitlePosition",
    label: "Subtitle Position",
    type: "options",
    options: [
      { label: "Under Hero Logo", value: "under-hero-logo" },
      { label: "Under Greeting", value: "under-greeting" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "startersMode",
    label: "Starters Layout",
    type: "options",
    options: [
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Sections"
  },
  {
    key: "maxStarters",
    label: "Max Starters",
    type: "number",
    min: 1,
    max: 6,
    step: 1,
    group: "Sections",
    condition: { field: "startersMode", value: "hidden", operator: "not_equals" }
  },
  {
    key: "cardLayoutDirection",
    label: "Card Layout",
    type: "options",
    options: [
      { label: "Stacked (icon above text)", value: "stacked" },
      { label: "Inline (icon beside text)", value: "inline" }
    ],
    group: "Sections",
    condition: { field: "startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "footerGap",
    label: "Footer / After-Content Gap",
    type: "number",
    min: 0,
    max: 80,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: ["footer", "after-content"], operator: "includes" }
  },
  {
    key: "footerPaddingBottom",
    label: "Footer Bottom Padding",
    type: "number",
    min: 0,
    max: 120,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: "footer" }
  },
  {
    key: "searchInputGap",
    label: "Search Input Gap",
    type: "number",
    min: 0,
    max: 64,
    step: 4,
    group: "Sections"
  },
  // Mobile overrides (responsive)
  {
    key: "mobile_logoPosition",
    label: "Mobile Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Header (top bar)", value: "header" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "Hidden", value: "hidden" },
      { label: "Inherit from Desktop", value: "inherit" }
    ],
    group: "Mobile"
  },
  {
    key: "mobile_startersMode",
    label: "Mobile Starters Layout",
    type: "options",
    options: [
      { label: "Inherit from Desktop", value: "inherit" },
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Mobile"
  }
], sc = ({
  widgetId: e = "concierge-home-layout",
  displayName: t = "Home Layout",
  initialState: n = {},
  children: r
}) => {
  const i = Xt(), a = Je(), l = le(/* @__PURE__ */ new Set()), {
    state: d,
    isLoading: p,
    isSaving: h,
    handleEditChange: g,
    handleSave: b,
    resetField: B,
    savedKeys: z,
    themeColors: C,
    resolveColor: x,
    canSave: f
  } = te(e, { ...Fl, ...n }, tn), S = me(
    (y) => {
      const I = y.childWidgets ?? {};
      en.forEach((v) => l.current.add(v)), i.setQueryData([...Oe, a.themeId], (v) => {
        var T;
        if (!v) return v;
        const k = {
          ...(T = v == null ? void 0 : v.config) == null ? void 0 : T.widgetConfig
        };
        for (const A of en)
          A in I ? k[A] = {
            ...I[A]
          } : delete k[A];
        return {
          ...v,
          config: {
            ...v == null ? void 0 : v.config,
            widgetConfig: k
          }
        };
      });
    },
    [i, a.themeId]
  ), F = me(async () => {
    if (await b(), l.current.size > 0 && a.themeId && a.editThemeToken) {
      const y = i.getQueryData([...Oe, a.themeId]), I = Array.from(l.current).map((v) => {
        var T, A;
        const k = (A = (T = y == null ? void 0 : y.config) == null ? void 0 : T.widgetConfig) == null ? void 0 : A[v];
        return Jn({
          themeId: a.themeId,
          widgetId: v,
          widgetState: k ?? {},
          editThemeToken: a.editThemeToken
        });
      });
      try {
        await Promise.all(I), l.current.clear();
      } catch (v) {
        console.error("Failed to save child widget configs:", v);
      }
    }
  }, [b, i, a]), m = me(
    (y, I) => {
      if (y === "layoutPreset" && I !== "custom") {
        const v = Pl[I];
        v && (Object.entries(v.layout).forEach(([k, T]) => {
          g(k, T);
        }), S(v));
      }
      g(y, I);
    },
    [g, S]
  );
  if (p)
    return /* @__PURE__ */ o(tl, {});
  const H = r(d, x);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: tn,
      editValues: d,
      onEditChange: m,
      onSave: f ? F : void 0,
      isSaving: h,
      savedKeys: z,
      onResetField: B,
      themeColors: C,
      triggerMode: "persistent",
      triggerIcon: "gear",
      triggerPosition: "bottom-right",
      triggerLabel: "Edit Home Layout",
      children: H
    }
  );
}, Ml = {
  logoIcon: "default",
  logoWidth: 200,
  logoMaxHeight: 80,
  logoOpacity: 1,
  marginBottom: 0,
  mobile_logoWidth: 140,
  mobile_marginBottom: 0
}, on = [
  {
    key: "logoIcon",
    label: "Logo Image",
    type: "icon"
  },
  {
    key: "logoWidth",
    label: "Logo Width",
    type: "number",
    min: 60,
    max: 400,
    step: 10,
    responsive: !0
  },
  {
    key: "logoMaxHeight",
    label: "Max Height",
    type: "number",
    min: 30,
    max: 200,
    step: 10
  },
  {
    key: "logoOpacity",
    label: "Opacity",
    type: "number",
    min: 0.1,
    max: 1,
    step: 0.1
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 96,
    step: 4,
    responsive: !0
  }
], cc = ({
  widgetId: e = "concierge-home-logo",
  displayName: t = "Brand Logo",
  initialState: n = {},
  logoUrl: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeIcons: g,
    canSave: b
  } = te(
    e,
    { ...Ml, ...n },
    on
  ), B = i.logoIcon && i.logoIcon !== "default" ? g[i.logoIcon] : null, z = B ? B.url : r;
  if (a || !z)
    return /* @__PURE__ */ o($, {});
  const C = `logo-${e || "default"}`, x = `logo-wrap-${e || "default"}`, f = i.mobile_marginBottom ?? i.marginBottom, S = i.mobile_logoWidth ?? i.logoWidth, F = `
    .${x} {
      margin-bottom: ${i.marginBottom}px;
    }
    .${C} img {
      width: ${i.logoWidth}px;
    }
    @media (max-width: 767px) {
      .${x} {
        margin-bottom: ${f}px !important;
      }
      .${C} img {
        width: ${S}px !important;
      }
    }
  `.trim(), m = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: F }),
    /* @__PURE__ */ o(
      "div",
      {
        className: `${x} ${C}`,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%"
        },
        children: /* @__PURE__ */ o(
          "img",
          {
            src: z,
            alt: B ? B.name : "Brand logo",
            style: {
              maxHeight: i.logoMaxHeight,
              opacity: i.logoOpacity,
              objectFit: "contain"
            }
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: on,
      editValues: i,
      onEditChange: d,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeIcons: g,
      children: m
    }
  );
}, El = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Al = {
  text: "CONCIERGE BY",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  color: s("textPrimary"),
  letterSpacing: 2,
  textTransform: "uppercase",
  marginBottom: 8,
  mobile_fontSize: 14,
  mobile_marginBottom: 8
}, nn = [
  { key: "text", label: "Label Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: 0,
    max: 10,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    responsive: !0
  }
], dc = ({
  widgetId: e = "concierge-home-brand-label",
  displayName: t = "Brand Label",
  initialState: n = {}
}) => {
  const {
    state: r,
    isLoading: i,
    isSaving: a,
    handleEditChange: l,
    handleSave: d,
    themeColors: p,
    themeFonts: h,
    resolveColor: g,
    canSave: b
  } = te(
    e,
    { ...Al, ...n },
    nn
  ), B = r.fontFamily, z = B && B !== "inherit" ? h[B] : null, C = z && z.format === "google" ? z.url : null;
  if (X(() => {
    C && El(C);
  }, [C]), i)
    return /* @__PURE__ */ o($, {});
  const x = z ? z.format === "system" ? z.url : `"${z.name}", sans-serif` : "inherit", f = z && z.format !== "system" && z.format !== "google", S = `brand-label-${e || "default"}`, F = r.mobile_fontSize ?? r.fontSize, m = r.mobile_marginBottom ?? r.marginBottom, H = `
    ${f ? `
      @font-face {
        font-family: "${z.name}";
        src: url("${z.url}") format("${z.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${S} { font-family: ${x} !important; }` : ""}
    .${S}-container {
      margin-bottom: ${r.marginBottom}px;
    }
    .${S}-text {
      font-size: ${r.fontSize}px;
    }
    @media (max-width: 767px) {
      .${S}-container {
        margin-bottom: ${m}px !important;
      }
      .${S}-text {
        font-size: ${F}px !important;
      }
    }
  `.trim(), y = r.fontWeight === "normal" ? 400 : r.fontWeight === "medium" ? 500 : r.fontWeight === "semibold" ? 600 : 700, I = /* @__PURE__ */ u($, { children: [
    H && /* @__PURE__ */ o("style", { children: H }),
    /* @__PURE__ */ o(
      "div",
      {
        className: `${S}-container ${x !== "inherit" ? S : ""}`,
        style: {
          textAlign: "center"
        },
        children: /* @__PURE__ */ o(
          "span",
          {
            className: `${S}-text`,
            style: {
              fontWeight: y,
              color: g(r.color),
              letterSpacing: r.letterSpacing,
              textTransform: r.textTransform
            },
            children: r.text
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: nn,
      editValues: r,
      onEditChange: l,
      onSave: b ? d : void 0,
      isSaving: a,
      themeColors: p,
      themeFonts: h,
      children: I
    }
  );
}, Hl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ll = ({ size: e, color: t }) => /* @__PURE__ */ o("svg", { width: e, height: e, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o(
  "path",
  {
    d: "M48 22.8232H29.0836L46.1268 14.4962L45.1182 12.3764L28.0749 20.7034L39.8703 5.69848L38.0548 4.23074L26.2622 19.2357L30.4697 0.52336L28.2104 0L24 18.7123L19.7896 0L17.5274 0.52336L21.7378 19.2357L9.94236 4.23074L8.12968 5.69848L19.9222 20.7034L2.87896 12.3764L1.8732 14.4962L18.9164 22.8232H0V25.1768H18.9164L1.8732 33.5038L2.87896 35.6265L19.9222 27.2995L8.12968 42.3044L9.94236 43.7722L21.7378 28.7673L17.5274 47.4766L19.7896 48L24 29.2906L28.2104 48L30.4697 47.4766L26.2622 28.7673L38.0548 43.7722L39.8703 42.3044L28.0749 27.2995L45.1182 35.6265L46.1268 33.5038L29.0836 25.1768H48V22.8232Z",
    fill: t
  }
) }), Rl = {
  greetingTemplate: "Hi, {name}.",
  loggedOutGreeting: "Hello",
  greetingFontSize: 24,
  greetingFontWeight: "semibold",
  greetingFontFamily: "inherit",
  greetingColor: s("textPrimary"),
  showUserName: !0,
  iconType: "brand-icon",
  emoji: "👋",
  brandIcon: "",
  iconSize: 32,
  iconColor: s("primary"),
  iconRotationAnimation: !0,
  iconRotationDuration: 8,
  iconMarginBottom: 8,
  greetingMarginBottom: 16,
  mobile_greetingMarginBottom: 8,
  mobile_greetingFontSize: 18,
  mobile_iconSize: 28
}, rn = [
  // Greeting text
  {
    key: "greetingTemplate",
    label: "Greeting Text",
    type: "text",
    group: "Greeting Text"
  },
  {
    key: "showUserName",
    label: "Show User Name",
    type: "toggle",
    group: "Greeting Text"
  },
  {
    key: "greetingFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Greeting Text",
    responsive: !0
  },
  {
    key: "greetingFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Greeting Text"
  },
  {
    key: "greetingFontFamily",
    label: "Font Family",
    type: "font",
    group: "Greeting Text"
  },
  {
    key: "greetingColor",
    label: "Color",
    type: "color",
    group: "Greeting Text"
  },
  {
    key: "greetingMarginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Greeting Text",
    responsive: !0
  },
  // Icon
  {
    key: "iconType",
    label: "Icon Type",
    type: "options",
    options: [
      { label: "Brand Icon", value: "brand-icon" },
      { label: "Emoji", value: "emoji" }
    ],
    group: "Greeting Icon"
  },
  {
    key: "emoji",
    label: "Emoji",
    type: "text",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "emoji" }
  },
  {
    key: "brandIcon",
    label: "Icon",
    type: "icon",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Greeting Icon",
    responsive: !0
  },
  {
    key: "iconColor",
    label: "Icon Color",
    type: "color",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconRotationAnimation",
    label: "Rotation Animation",
    type: "toggle",
    group: "Greeting Icon"
  },
  {
    key: "iconRotationDuration",
    label: "Rotation Speed (seconds)",
    type: "number",
    min: 1,
    max: 30,
    step: 1,
    group: "Greeting Icon",
    condition: "iconRotationAnimation"
  },
  {
    key: "iconMarginBottom",
    label: "Icon Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 4,
    group: "Greeting Icon"
  }
], pc = ({
  widgetId: e = "concierge-home-greeting",
  displayName: t = "Greeting",
  initialState: n = {},
  userName: r,
  showIcon: i = !1,
  iconPosition: a = "above"
}) => {
  const {
    state: l,
    isLoading: d,
    isSaving: p,
    handleEditChange: h,
    handleSave: g,
    resetField: b,
    savedKeys: B,
    themeColors: z,
    themeFonts: C,
    themeIcons: x,
    resolveColor: f,
    canSave: S
  } = te(e, { ...Rl, ...n }, rn), F = l.greetingFontFamily, m = F && F !== "inherit" ? C[F] : C["studio-brand-font"] ?? Object.values(C)[0] ?? null, H = m && m.format === "google" ? m.url : null;
  if (X(() => {
    H && Hl(H);
  }, [H]), d)
    return /* @__PURE__ */ o($, {});
  const y = m ? m.format === "system" ? m.url : `"${m.name}", sans-serif` : "inherit", I = m && m.format !== "system" && m.format !== "google", v = `greeting-${e || "default"}`, k = l.mobile_greetingFontSize ?? l.greetingFontSize, T = l.mobile_iconSize ?? l.iconSize, A = l.mobile_greetingMarginBottom ?? l.greetingMarginBottom, P = `
    ${I ? `
      @font-face {
        font-family: "${m.name}";
        src: url("${m.url}") format("${m.format}");
        font-display: swap;
      }
    ` : ""}
    ${y !== "inherit" ? `.${v} { font-family: ${y} !important; }` : ""}
    .${v}-wrap {
      margin-bottom: ${l.greetingMarginBottom}px;
    }
    @media (max-width: 767px) {
      .${v}-wrap {
        margin-bottom: ${A}px !important;
      }
      .${v}-text {
        font-size: ${k}px !important;
        line-height: 26px !important;
        letter-spacing: 0.08px !important;
      }
      .${v}-icon {
        width: ${T}px !important;
        height: ${T}px !important;
      }
      .${v}-icon svg {
        width: ${T}px !important;
        height: ${T}px !important;
      }
    }
  `.trim();
  let W;
  l.showUserName && r ? W = l.greetingTemplate.replace("{name}", r) : W = l.loggedOutGreeting || "Hello";
  const w = l.greetingFontWeight === "normal" ? 400 : l.greetingFontWeight === "medium" ? 500 : l.greetingFontWeight === "semibold" ? 600 : 700, M = f(l.iconColor), O = `greeting-icon-spin-${e || "default"}`, J = l.iconRotationAnimation ? `@keyframes ${O} { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }` : "", L = l.iconRotationAnimation ? {
    animation: `${O} ${l.iconRotationDuration}s linear infinite`
  } : {}, R = () => {
    if (!i) return null;
    let Y = null;
    return l.iconType === "emoji" ? Y = /* @__PURE__ */ o("span", { style: { fontSize: l.iconSize }, children: l.emoji }) : l.brandIcon && x[l.brandIcon] ? Y = /* @__PURE__ */ o(
      "div",
      {
        style: {
          width: l.iconSize,
          height: l.iconSize,
          backgroundColor: M,
          WebkitMaskImage: `url(${x[l.brandIcon].url})`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskImage: `url(${x[l.brandIcon].url})`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          maskPosition: "center"
        }
      }
    ) : Y = /* @__PURE__ */ o(Ll, { size: l.iconSize, color: M }), /* @__PURE__ */ o(
      "div",
      {
        className: `${v}-icon`,
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...L
        },
        children: Y
      }
    );
  }, D = a === "inline", N = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: P }),
    J && /* @__PURE__ */ o("style", { children: J }),
    /* @__PURE__ */ u(
      "div",
      {
        className: `${v}-wrap${y !== "inherit" ? ` ${v}` : ""}`,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center"
        },
        children: [
          i && !D && /* @__PURE__ */ o("div", { style: { marginBottom: l.iconMarginBottom }, children: R() }),
          /* @__PURE__ */ u(
            "span",
            {
              className: `${v}-text`,
              style: {
                display: "inline-flex",
                alignItems: "center",
                gap: D && i ? 8 : 0,
                fontSize: l.greetingFontSize,
                fontWeight: w,
                color: f(l.greetingColor),
                lineHeight: 1.2
              },
              children: [
                i && D && R(),
                W
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: rn,
      editValues: l,
      onEditChange: h,
      onSave: S ? g : void 0,
      isSaving: p,
      savedKeys: B,
      onResetField: b,
      themeColors: z,
      themeFonts: C,
      themeIcons: x,
      children: N
    }
  );
}, Nl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Wl = {
  textTemplate: "I'm {concierge_name}, your shopping assistant for {brand}.",
  fontSize: 24,
  fontWeight: "semibold",
  fontFamily: "inherit",
  color: s("textPrimary"),
  lineHeight: 1.2,
  letterSpacing: 0.08,
  maxWidth: 830,
  marginTop: 0,
  marginBottom: 0,
  mobile_fontSize: 18
}, an = [
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 32,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: -1,
    max: 2,
    step: 0.01
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 200,
    max: 900,
    step: 10
  },
  {
    key: "marginTop",
    label: "Spacing Above",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  }
], gc = ({
  widgetId: e = "concierge-home-subtitle",
  displayName: t = "Subtitle",
  initialState: n = {},
  brandName: r = "",
  conciergeName: i = "Concierge"
}) => {
  const {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: h,
    resetField: g,
    savedKeys: b,
    themeColors: B,
    themeFonts: z,
    resolveColor: C,
    canSave: x
  } = te(e, { ...Wl, ...n }, an), f = a.fontFamily, S = f && f !== "inherit" ? z[f] : z["studio-brand-font"] ?? Object.values(z)[0] ?? null, F = S && S.format === "google" ? S.url : null;
  if (X(() => {
    F && Nl(F);
  }, [F]), l)
    return /* @__PURE__ */ o($, {});
  const m = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", H = S && S.format !== "system" && S.format !== "google", y = `subtitle-${e || "default"}`, I = a.mobile_fontSize ?? a.fontSize, v = `
    ${H ? `
      @font-face {
        font-family: "${S.name}";
        src: url("${S.url}") format("${S.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${y} { font-family: ${m} !important; }` : ""}
    @media (max-width: 767px) {
      .${y}-wrapper {
        padding-left: 16px !important;
        padding-right: 16px !important;
        box-sizing: border-box !important;
      }
      .${y}-text {
        font-size: ${I}px !important;
        line-height: 28px !important;
        letter-spacing: 0.08px !important;
      }
    }
  `.trim(), A = !r || r.toLowerCase() === "brandclub" ? `I'm ${i}, your Brandclub shopping assistant.` : a.textTemplate.replace("{concierge_name}", i).replace("{brand}", r), P = a.fontWeight === "normal" ? 400 : a.fontWeight === "medium" ? 500 : a.fontWeight === "semibold" ? 600 : 700, W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: v }),
    /* @__PURE__ */ o(
      "div",
      {
        className: `${y}-wrapper${m !== "inherit" ? ` ${y}` : ""}`,
        style: {
          textAlign: "center",
          marginTop: a.marginTop,
          marginBottom: a.marginBottom,
          width: "100%"
        },
        children: /* @__PURE__ */ o(
          "p",
          {
            className: `${y}-text`,
            style: {
              fontSize: a.fontSize,
              fontWeight: P,
              color: C(a.color),
              lineHeight: a.lineHeight,
              letterSpacing: a.letterSpacing ? `${a.letterSpacing}px` : void 0,
              maxWidth: a.maxWidth,
              margin: "0 auto"
            },
            children: A
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: an,
      editValues: a,
      onEditChange: p,
      onSave: x ? h : void 0,
      isSaving: d,
      savedKeys: b,
      onResetField: g,
      themeColors: B,
      themeFonts: z,
      children: W
    }
  );
}, Dl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIxKSI+CjxwYXRoIGQ9Ik0xOC4wMDE3IDAuMDAwNjI1NjFDMjcuOTQyMyAwLjAwMDYyNTYxIDM2LjAwMjkgOC4wNTg5NSAzNi4wMDI5IDE4LjAwMTdDMzYuMDAyOSAyNy45NDQ1IDI3Ljk0NDUgMzYuMDAyOSAxOC4wMDE3IDM2LjAwMjlDOC4wNTg5NSAzNi4wMDI5IDAuMDAwNjI1NjEgMjcuOTQyMyAwLjAwMDYyNTYxIDE4LjAwMTdIMTguMDAxN1YwLjAwMDYyNTYxWiIgZmlsbD0iI0Q2OTM4QSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXIxIj4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", Ol = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIyKSI+CjxwYXRoIGQ9Ik0wIDM2QzAgMjYuMDU5MiA4LjA1OTIgMTggMTggMThDMjcuOTQwOCAxOCAzNiAyNi4wNTkyIDM2IDM2SDBaIiBmaWxsPSIjOEFCMkJGIi8+CjxwYXRoIGQ9Ik0zNiAwQzM2IDkuOTQwOCAyNy45NDA4IDE4IDE4IDE4QzguMDU5MiAxOCAwIDkuOTQwOCAwIDBIMzZaIiBmaWxsPSIjOEFCMkJGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfc3RhcnRlcjIiPgo8cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+", jl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIzKSI+CjxwYXRoIGQ9Ik0wIDBMMTggMThWMEgwWiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMzYgMFYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPHBhdGggZD0iTTM2IDM2TDE4IDE4VjM2SDM2WiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMCAzNlYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF9zdGFydGVyMyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=", Gl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXI0KSI+CjxwYXRoIGQ9Ik0zMi41NjU4IDYuODg0NjdMMjYuNTYwOSAxNS4wODA2TDM2IDE4LjAwOUwyNi41NTg3IDIwLjkyODRMMzIuNTU2OCAyOS4xMzExTDIzLjI4NTkgMjUuNjU4NEwyMy41NTI5IDM2TDE3Ljk5NDQgMjcuNDYyMkwxMi40MjkyIDM1Ljk5NTVMMTIuNzA3MyAyNS42NTM5TDMuNDMxOTkgMjkuMTE3Nkw5LjQzOTA5IDIwLjkxOTRMMCAxNy45OTFMOS40NDEzNCAxNS4wNzE2TDMuNDQzMjEgNi44NzExN0wxMi43MTQxIDEwLjM0MzlMMTIuNDQ0OSAwTDE4LjAwMzQgOC41Mzc4TDIzLjU3MDggMC4wMDQ0OTgzMUwyMy4yOTI3IDEwLjM0ODRMMzIuNTY1OCA2Ljg4NDY3WiIgZmlsbD0iIzlBNzI2MSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXI0Ij4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", $l = [
  Dl,
  Ol,
  jl,
  Gl
], Yl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, Ql = {
  // Pill styling — matches Figma 3468:4971 (fully rounded pill)
  pillPaddingX: 24,
  pillPaddingY: 12,
  pillBorderRadius: 100,
  pillBorderWidth: 1,
  pillBorderColor: s("borderColor"),
  pillBgColor: s("background"),
  pillBgColorHover: s("background"),
  pillTextColor: s("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillShadowEnabled: !0,
  pillShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.05)",
  pillGap: 8,
  fontFamily: "inherit",
  // Card styling
  cardWidth: 183,
  cardHeight: 124,
  cardPadding: 16,
  cardBorderRadius: 12,
  cardBorderWidth: 0,
  cardBorderColor: s("borderColor"),
  cardBgColor: s("background"),
  cardBgColorHover: s("background"),
  cardTextColor: s("textPrimary"),
  cardFontSize: 14,
  cardGap: 12,
  cardIconSize: 32,
  // Default icons (will be replaced by bundled SVGs)
  starterIcon1: "",
  starterIcon2: "",
  starterIcon3: "",
  starterIcon4: "",
  // Container
  containerMaxWidth: 768,
  containerMarginTop: 16,
  // Mobile overrides — matches Figma 3468:4971 (padding 12×16, 14/22 Inter Medium)
  mobile_pillFontSize: 14,
  mobile_pillPaddingX: 16,
  mobile_pillPaddingY: 12,
  mobile_cardGap: 8
}, ln = [
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderColor",
    label: "Pill Border Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColor",
    label: "Pill Background",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColorHover",
    label: "Pill Bg (Hover)",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillTextColor",
    label: "Pill Text Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Pill Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  // Card styling
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 120,
    max: 240,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardHeight",
    label: "Card Height",
    type: "number",
    min: 80,
    max: 180,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColorHover",
    label: "Card Bg (Hover)",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardTextColor",
    label: "Card Text Color",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardFontSize",
    label: "Card Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 4,
    group: "Card Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardIconSize",
    label: "Card Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  // Icons
  {
    key: "starterIcon1",
    label: "Starter 1 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon2",
    label: "Starter 2 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon3",
    label: "Starter 3 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon4",
    label: "Starter 4 Icon",
    type: "icon",
    group: "Icons"
  },
  // Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // Container
  {
    key: "containerMaxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 900,
    step: 50,
    group: "Container"
  },
  {
    key: "containerMarginTop",
    label: "Margin Top",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Container"
  }
], mc = ({
  widgetId: e = "concierge-home-starters",
  displayName: t = "Conversation Starters",
  initialState: n = {},
  mode: r,
  elementStyle: i = "default",
  cardLayoutDirection: a = "stacked",
  maxStarters: l = 4,
  queries: d,
  onSearch: p
}) => {
  const {
    state: h,
    isLoading: g,
    isSaving: b,
    handleEditChange: B,
    handleSave: z,
    resetField: C,
    savedKeys: x,
    themeColors: f,
    themeFonts: S,
    themeIcons: F,
    resolveColor: m,
    canSave: H
  } = te(
    e,
    { ...Ql, ...n, _startersMode: r },
    ln
  ), y = { ...h, _startersMode: r }, I = y.fontFamily, v = I && I !== "inherit" ? S[I] : null, k = v && v.format === "google" ? v.url : null;
  if (X(() => {
    k && Yl(k);
  }, [k]), g || r === "hidden" || d.length === 0)
    return /* @__PURE__ */ o($, {});
  const T = v ? v.format === "system" ? v.url : `"${v.name}", sans-serif` : "inherit", A = v && v.format !== "system" && v.format !== "google", P = `starters-font-${e || "default"}`, W = `
    ${A ? `
      @font-face {
        font-family: "${v.name}";
        src: url("${v.url}") format("${v.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${P} { font-family: ${T} !important; }` : ""}
  `.trim(), w = d.slice(0, l), M = [
    y.starterIcon1,
    y.starterIcon2,
    y.starterIcon3,
    y.starterIcon4
  ], O = (Q) => {
    const _ = M[Q];
    return _ && F[_] ? F[_].url : $l[Q] || null;
  }, J = () => {
    if (i === "grey-fill" || i === "grey-fill-stroke")
      return "#f6f8fa";
  }, L = () => {
    if (i === "grey-fill-stroke")
      return "1px solid #e5e7eb";
    if (i === "grey-fill")
      return "none";
  }, R = (Q) => Q === "normal" ? 400 : Q === "medium" ? 500 : Q === "semibold" ? 600 : 700, D = (Q, _) => {
    const re = r === "pills-icons", V = O(_), ne = J(), ee = L();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => p(Q),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: `${y.pillPaddingY}px ${y.pillPaddingX}px`,
          borderRadius: y.pillBorderRadius,
          border: ee ?? `${y.pillBorderWidth}px solid ${m(y.pillBorderColor)}`,
          backgroundColor: ne ?? m(y.pillBgColor),
          color: m(y.pillTextColor),
          fontSize: y.pillFontSize,
          lineHeight: "22px",
          fontWeight: R(y.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          whiteSpace: "nowrap",
          boxShadow: y.pillShadowEnabled ? y.pillShadow : "none"
        },
        onMouseEnter: (fe) => {
          fe.currentTarget.style.backgroundColor = m(y.pillBgColorHover) || ne || m(y.pillBgColor);
        },
        onMouseLeave: (fe) => {
          fe.currentTarget.style.backgroundColor = ne ?? m(y.pillBgColor);
        },
        children: [
          re && V && /* @__PURE__ */ o(
            "img",
            {
              src: V,
              alt: "",
              style: {
                width: 24,
                height: 24,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          Q
        ]
      },
      _
    );
  }, N = (Q, _) => {
    const re = O(_), V = J(), ne = L(), ee = a === "inline";
    return /* @__PURE__ */ u(
      "button",
      {
        onClick: () => p(Q),
        style: {
          display: "flex",
          flexDirection: ee ? "row" : "column",
          alignItems: ee ? "center" : void 0,
          gap: ee ? "16px" : "12px",
          padding: y.cardPadding,
          borderRadius: y.cardBorderRadius,
          border: ne ?? (y.cardBorderWidth > 0 ? `${y.cardBorderWidth}px solid ${m(y.cardBorderColor)}` : "none"),
          backgroundColor: V ?? m(y.cardBgColor),
          color: m(y.cardTextColor),
          fontSize: y.cardFontSize,
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          width: r === "cards-grid" ? "100%" : y.cardWidth,
          minHeight: ee ? void 0 : y.cardHeight,
          flexShrink: 0
        },
        onMouseEnter: (fe) => {
          fe.currentTarget.style.backgroundColor = m(y.cardBgColorHover) || V || m(y.cardBgColor);
        },
        onMouseLeave: (fe) => {
          fe.currentTarget.style.backgroundColor = V ?? m(y.cardBgColor);
        },
        children: [
          re && /* @__PURE__ */ o(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: y.cardIconSize,
                height: y.cardIconSize,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ o("span", { style: { lineHeight: 1.4 }, children: Q })
        ]
      },
      _
    );
  }, Y = (Q, _) => {
    const re = O(_), V = J(), ne = L();
    return /* @__PURE__ */ u(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => p(Q),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: `${y.pillPaddingY}px ${y.pillPaddingX}px`,
          borderRadius: y.pillBorderRadius > 20 ? 10 : y.pillBorderRadius,
          border: ne ?? `${y.pillBorderWidth}px solid ${m(y.pillBorderColor)}`,
          backgroundColor: V ?? m(y.pillBgColor),
          color: m(y.pillTextColor),
          fontSize: y.pillFontSize,
          fontWeight: R(y.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        },
        onMouseEnter: (ee) => {
          ee.currentTarget.style.backgroundColor = m(y.pillBgColorHover) || V || m(y.pillBgColor);
        },
        onMouseLeave: (ee) => {
          ee.currentTarget.style.backgroundColor = V ?? m(y.pillBgColor);
        },
        children: [
          re && /* @__PURE__ */ o(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: 16,
                height: 16,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          Q
        ]
      },
      _
    );
  }, G = () => {
    if (r === "pills" || r === "pills-icons") {
      const Q = y.pillShadowEnabled ? 16 : 0;
      return /* @__PURE__ */ o(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            gap: y.pillGap,
            justifyContent: "center",
            maxWidth: y.containerMaxWidth,
            margin: `0 auto -${Q}px`,
            padding: `0 0 ${Q}px`
          },
          className: "concierge-home-starters-pills",
          children: w.map((_, re) => D(_, re))
        }
      );
    }
    return r === "pills-icons-list" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: y.pillGap,
          maxWidth: y.containerMaxWidth,
          margin: "0 auto",
          width: "100%"
        },
        className: "concierge-home-starters-pills-list",
        children: w.map((Q, _) => Y(Q, _))
      }
    ) : r === "cards-row" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "flex",
          gap: y.cardGap,
          justifyContent: "center",
          maxWidth: y.containerMaxWidth,
          margin: "0 auto",
          flexWrap: "wrap"
        },
        className: "concierge-home-starters-cards-row",
        children: w.map((Q, _) => N(Q, _))
      }
    ) : r === "cards-grid" ? /* @__PURE__ */ o(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: y.cardGap,
          maxWidth: y.containerMaxWidth,
          margin: "0 auto"
        },
        className: "concierge-home-starters-cards-grid",
        children: w.map((Q, _) => N(Q, _))
      }
    ) : null;
  }, K = /* @__PURE__ */ u(
    "div",
    {
      className: T !== "inherit" ? P : void 0,
      style: { marginTop: y.containerMarginTop, width: "100%" },
      children: [
        /* @__PURE__ */ o("style", { children: `
        ${W || ""}
        /* Responsive: pills become horizontally scrollable on mobile */
        @media (max-width: 767px) {
          .concierge-home-starters-pills {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 4px;
            padding-left: 16px !important;
            padding-right: 16px !important;
          }
          .concierge-home-starters-pills::-webkit-scrollbar {
            display: none;
          }
          .concierge-home-starters-pill {
            padding: ${y.mobile_pillPaddingY ?? y.pillPaddingY}px ${y.mobile_pillPaddingX ?? y.pillPaddingX}px !important;
            font-size: ${y.mobile_pillFontSize ?? y.pillFontSize}px !important;
            line-height: 22px !important;
          }
          /* Vertical pill list on mobile */
          .concierge-home-starters-pills-list {
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          /* Cards row becomes 2-column grid on mobile */
          .concierge-home-starters-cards-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: ${y.mobile_cardGap}px !important;
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          .concierge-home-starters-cards-row > button {
            width: 100% !important;
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-row > button img {
            width: 16px !important;
            height: 16px !important;
          }
          /* Cards grid stays 2-column on mobile with compact sizing */
          .concierge-home-starters-cards-grid {
            gap: ${y.mobile_cardGap}px !important;
            padding: 0 16px !important;
            box-sizing: border-box !important;
          }
          .concierge-home-starters-cards-grid > button {
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-grid > button img {
            width: 16px !important;
            height: 16px !important;
          }
        }
      ` }),
        G()
      ]
    }
  );
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: ln,
      editValues: y,
      onEditChange: B,
      onSave: H ? z : void 0,
      isSaving: b,
      savedKeys: x,
      onResetField: C,
      themeColors: f,
      themeFonts: S,
      themeIcons: F,
      children: K
    }
  );
}, Xl = {
  // Hamburger icon
  hamburgerIcon: "default",
  hamburgerIconSize: 32,
  hamburgerIconColor: s("textPrimary"),
  // Close icon
  closeIcon: "default",
  closeIconSize: 32,
  closeIconColor: s("textPrimary"),
  // Logo visibility
  showLogo: !0,
  // Layout
  navHeight: 80,
  navPaddingX: 24,
  navPaddingY: 24,
  navBgColor: s("transparent")
}, sn = [
  // Hamburger icon
  {
    key: "hamburgerIcon",
    label: "Menu Icon",
    type: "icon",
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconColor",
    label: "Color",
    type: "color",
    group: "Menu Icon"
  },
  // Close icon
  {
    key: "closeIcon",
    label: "Close Icon",
    type: "icon",
    group: "Close Icon"
  },
  {
    key: "closeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Close Icon"
  },
  {
    key: "closeIconColor",
    label: "Color",
    type: "color",
    group: "Close Icon"
  },
  // Logo visibility
  {
    key: "showLogo",
    label: "Show Logo",
    type: "toggle",
    group: "Logo"
  },
  // Layout
  {
    key: "navHeight",
    label: "Height",
    type: "number",
    min: 40,
    max: 120,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navBgColor",
    label: "Background",
    type: "color",
    group: "Layout"
  }
], uc = ({
  widgetId: e = "concierge-home-mobile-nav",
  displayName: t = "Mobile Nav Header",
  initialState: n = {},
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeIcons: g,
    resolveColor: b,
    canSave: B
  } = te(
    e,
    { ...Xl, ...n },
    sn
  ), z = i.hamburgerIcon && i.hamburgerIcon !== "default" ? g[i.hamburgerIcon] : null, C = i.closeIcon && i.closeIcon !== "default" ? g[i.closeIcon] : null, x = {
    hamburgerIconUrl: z ? z.url : null,
    closeIconUrl: C ? C.url : null
  };
  if (a)
    return /* @__PURE__ */ o($, {});
  const f = r(i, x, b);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: sn,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeIcons: g,
      children: f
    }
  );
}, lr = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  // Brandclub primary color
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Jl = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], cn = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Jl,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], $t = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, sr = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, Ul = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ o("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), _l = ({ survey: e, state: t, onClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: n,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: n ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (r) => {
      n && (r.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (r) => {
      r.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: t.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ o(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ o(
            "span",
            {
              style: {
                fontSize: t.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: t.surveyBadgeBgColor,
                color: t.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ o("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: $t(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ u("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ u("span", { style: { fontSize: t.metaFontSize, color: t.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: $t(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            sr(e.rewardAmount)
          ]
        }
      )
    ]
  }
), hc = ({
  widgetId: e,
  displayName: t = "Surveys",
  surveys: n,
  isLoading: r = !1,
  error: i,
  onSurveyClick: a,
  headerText: l,
  showHeader: d = !0,
  emptyMessage: p = "No surveys available right now",
  className: h,
  children: g
}) => {
  const {
    state: b,
    handleEditChange: B,
    handleSave: z,
    isSaving: C,
    themeColors: x,
    themeFonts: f,
    canSave: S
  } = te(
    e,
    lr,
    cn
  );
  if (g)
    return /* @__PURE__ */ o($, { children: g(b, n) });
  if (r)
    return /* @__PURE__ */ o(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: b.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (i)
    return /* @__PURE__ */ o(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (n.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: h,
        style: {
          maxWidth: b.maxWidth,
          padding: `${b.paddingY}px ${b.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ o(Ul, { size: b.emptyIconSize, color: b.emptyTextColor }),
          /* @__PURE__ */ o("div", { style: { fontSize: b.emptyTextFontSize, color: b.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const F = n.reduce((y, I) => y + I.rewardAmount, 0), m = l || `${n.length} Survey${n.length !== 1 ? "s" : ""} (${sr(F)} potential)`, H = /* @__PURE__ */ u(
    "div",
    {
      className: h,
      style: {
        maxWidth: b.maxWidth,
        padding: `${b.paddingY}px ${b.paddingX}px`,
        backgroundColor: b.backgroundColor,
        borderRadius: b.borderRadius
      },
      children: [
        d && /* @__PURE__ */ o(
          "h3",
          {
            style: {
              fontSize: b.headerFontSize,
              fontWeight: $t(b.headerFontWeight),
              color: b.headerColor,
              marginBottom: b.headerMarginBottom,
              margin: 0,
              marginBlockEnd: b.headerMarginBottom
            },
            children: m
          }
        ),
        /* @__PURE__ */ o("div", { style: { display: "flex", flexDirection: "column", gap: b.cardGap }, children: n.map((y) => /* @__PURE__ */ o(
          _l,
          {
            survey: y,
            state: b,
            onClick: a ? () => a(y) : void 0
          },
          y.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: e,
      displayName: t,
      editFields: cn,
      editValues: b,
      onEditChange: B,
      onSave: S ? z : void 0,
      isSaving: C,
      themeColors: x,
      themeFonts: f,
      children: H
    }
  );
}, Zl = "#181d56", dn = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, Vl = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", ql = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, Kl = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, es = ({
  size: e = 40,
  color: t = "#9ca3af"
}) => /* @__PURE__ */ u(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 12H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9 16H13",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), yc = ({
  survey: e,
  state: t,
  onClick: n,
  className: r,
  width: i = 280
}) => {
  const [a, l] = j(!1);
  ({ ...lr, ...t });
  const d = () => {
    n ? n() : window.location.href = `/survey/${e.campaignId}`;
  }, p = e.brandLogoUrl || (e.brandId ? Kl(e.brandId) : void 0), h = !!p;
  return /* @__PURE__ */ u(
    "div",
    {
      className: r,
      onClick: d,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        width: typeof i == "number" ? `${i}px` : i,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: a ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: h ? /* @__PURE__ */ o(
              "img",
              {
                src: p,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ o(es, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: Zl,
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ u(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: dn.bg,
                          color: dn.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ o(
                            "img",
                            {
                              src: Vl,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ o("span", { children: ql(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ o(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, ts = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Yt = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, cr = (e) => {
  const t = Number(e);
  return `$${Number.isFinite(t) ? t.toFixed(2) : "0.00"}`;
}, os = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, ns = ({ size: e, color: t }) => /* @__PURE__ */ u("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: t, strokeWidth: "2", children: [
  /* @__PURE__ */ o("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ o("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), rs = ({ type: e, state: t }) => {
  const r = ((i) => {
    switch (i) {
      case "survey":
        return { bg: t.surveyBadgeBgColor, text: t.surveyBadgeTextColor };
      case "content":
        return { bg: t.contentBadgeBgColor, text: t.contentBadgeTextColor };
      case "membership":
        return { bg: t.membershipBadgeBgColor, text: t.membershipBadgeTextColor };
      case "review":
        return { bg: t.reviewBadgeBgColor, text: t.reviewBadgeTextColor };
      case "referral":
        return { bg: t.referralBadgeBgColor, text: t.referralBadgeTextColor };
      case "affiliate":
        return { bg: t.affiliateBadgeBgColor, text: t.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ o(
    "span",
    {
      style: {
        fontSize: t.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${t.typeBadgePaddingY}px ${t.typeBadgePaddingX}px`,
        borderRadius: t.typeBadgeBorderRadius,
        backgroundColor: r.bg,
        color: r.text,
        whiteSpace: "nowrap"
      },
      children: os[e] || e
    }
  );
}, is = ({ opportunity: e, state: t, onClick: n }) => /* @__PURE__ */ u(
  "div",
  {
    onClick: n,
    style: {
      backgroundColor: t.cardBgColor,
      border: `${t.cardBorderWidth}px solid ${t.cardBorderColor}`,
      borderRadius: t.cardBorderRadius,
      padding: t.cardPadding,
      cursor: n ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (r) => {
      n && (r.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (r) => {
      r.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: t.brandLogoSize,
            height: t.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ o(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ u("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ o(rs, { type: e.type, state: t }),
          /* @__PURE__ */ o("span", { style: { fontSize: t.brandNameFontSize, color: t.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.titleFontSize,
              fontWeight: Yt(t.titleFontWeight),
              color: t.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ o(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ u(
          "div",
          {
            style: {
              fontSize: t.descriptionFontSize,
              color: t.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            fontSize: t.rewardFontSize,
            fontWeight: Yt(t.rewardFontWeight),
            color: t.rewardColor,
            backgroundColor: t.rewardBgColor,
            padding: "6px 10px",
            borderRadius: t.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            cr(e.rewardAmount)
          ]
        }
      )
    ]
  }
), bc = ({
  widgetId: e,
  opportunities: t,
  isLoading: n = !1,
  error: r,
  onOpportunityClick: i,
  headerText: a,
  showHeader: l = !0,
  emptyMessage: d = "No reward opportunities available",
  className: p,
  children: h
}) => {
  const { state: g } = te(
    e,
    ts,
    []
    // No edit fields for now
  );
  if (h)
    return /* @__PURE__ */ o($, { children: h(g, t) });
  if (n)
    return /* @__PURE__ */ o(
      "div",
      {
        className: p,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (r)
    return /* @__PURE__ */ o(
      "div",
      {
        className: p,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ o("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: r })
      }
    );
  if (t.length === 0)
    return /* @__PURE__ */ u(
      "div",
      {
        className: p,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ o(ns, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ o("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor, marginTop: 12 }, children: d })
        ]
      }
    );
  const b = t.reduce((z, C) => z + C.rewardAmount, 0), B = a || `${t.length} Reward Opportunity${t.length !== 1 ? "s" : ""} (${cr(b)} potential)`;
  return /* @__PURE__ */ u(
    "div",
    {
      className: p,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        l && /* @__PURE__ */ o(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: Yt(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: B
          }
        ),
        /* @__PURE__ */ o("div", { style: { display: "flex", flexDirection: "column", gap: g.cardGap }, children: t.map((z) => /* @__PURE__ */ o(
          is,
          {
            opportunity: z,
            state: g,
            onClick: i ? () => i(z) : void 0
          },
          z.id || z.campaignId || `${z.type}-${z.title}`
        )) })
      ]
    }
  );
}, as = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, ls = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, pn = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ge
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], fc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  excludeEditFields: r
}) => {
  const i = r ? pn.filter((v) => !r.includes(v.key)) : pn, {
    state: a,
    isLoading: l,
    isSaving: d,
    handleEditChange: p,
    handleSave: h,
    themeColors: g,
    themeFonts: b,
    resolveColor: B,
    canSave: z
  } = te(
    t,
    { ...ls, ...e },
    i
  ), C = a.fontFamily, x = C && C !== "inherit" ? b[C] : null, f = x && x.format === "google" ? x.url : null;
  if (X(() => {
    f && as(f);
  }, [f]), l)
    return /* @__PURE__ */ o($, {});
  const S = (v) => {
    const k = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, T = parseInt(v, 10);
    return isNaN(T) ? k[v] || 500 : T;
  }, F = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", m = `textbox-${t || "default"}`, y = `
    ${x && x.format !== "system" && x.format !== "google" ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${F !== "inherit" ? `.${m} { font-family: ${F} !important; }` : ""}
  `.trim(), I = /* @__PURE__ */ u($, { children: [
    y && /* @__PURE__ */ o("style", { children: y }),
    /* @__PURE__ */ o(
      "span",
      {
        className: `textbox-content ${m}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...F === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${a.fontSize}px`,
          fontWeight: S(a.fontWeight),
          color: B(a.color),
          textAlign: a.textAlign,
          lineHeight: a.lineHeight,
          letterSpacing: `${a.letterSpacing}px`,
          textTransform: a.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: a.content
      }
    )
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: i,
      editValues: a,
      onEditChange: p,
      onSave: z ? h : void 0,
      isSaving: d,
      themeColors: g,
      themeFonts: b,
      children: I
    }
  );
}, gn = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const n = document.createElement("link");
  n.rel = "stylesheet", n.href = e, document.head.appendChild(n);
}, ss = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: q("rgba(236, 121, 46, 0.3)"),
  instantTextColor: q("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: q("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: q("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: q("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: q("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: q("rgba(162, 34, 114, 0.3)"),
  contentTextColor: q("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: s("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, mn = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...ge]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], xc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    themeFonts: g,
    resolveColor: b,
    canSave: B
  } = te(
    t,
    { ...ss, ...e },
    mn
  ), z = i.pillFontFamily, C = z && z !== "inherit" ? g[z] : null, x = i.subfixFontFamily, f = x && x !== "inherit" ? g[x] : null, S = C && C.format === "google" ? C.url : null, F = f && f.format === "google" ? f.url : null;
  if (X(() => {
    S && gn(S);
  }, [S]), X(() => {
    F && gn(F);
  }, [F]), a)
    return /* @__PURE__ */ o($, {});
  const m = C ? C.format === "system" ? C.url : `"${C.name}", sans-serif` : "inherit", H = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", y = C && C.format !== "system" && C.format !== "google", I = f && f.format !== "system" && f.format !== "google", v = `reward-pill-${t || "default"}`, k = `
    ${y ? `
      @font-face {
        font-family: "${C.name}";
        src: url("${C.url}") format("${C.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${m !== "inherit" ? `.${v} [data-pill-text] { font-family: ${m} !important; }` : ""}
    ${H !== "inherit" ? `.${v} [data-subfix-text] { font-family: ${H} !important; }` : ""}
  `.trim(), T = {
    ...i,
    pillFontFamilyCss: m,
    subfixFontFamilyCss: H
  }, A = /* @__PURE__ */ u($, { children: [
    k && /* @__PURE__ */ o("style", { children: k }),
    r(T, b)
  ] });
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: mn,
      editValues: i,
      onEditChange: d,
      onSave: B ? p : void 0,
      isSaving: l,
      themeColors: h,
      themeFonts: g,
      children: A
    }
  );
}, cs = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: s("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, un = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...ge]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], Cc = ({
  initialState: e = {},
  widgetId: t,
  displayName: n,
  children: r
}) => {
  const {
    state: i,
    isLoading: a,
    isSaving: l,
    handleEditChange: d,
    handleSave: p,
    themeColors: h,
    resolveColor: g,
    canSave: b
  } = te(
    t,
    { ...cs, ...e },
    un
  );
  if (a)
    return /* @__PURE__ */ o($, {});
  const B = r(i, g);
  return /* @__PURE__ */ o(
    U,
    {
      widgetId: t,
      displayName: n,
      editFields: un,
      editValues: i,
      onEditChange: d,
      onSave: b ? p : void 0,
      isSaving: l,
      themeColors: h,
      children: B
    }
  );
}, ds = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, E = (e) => e.map((t) => ({
  weight: t,
  label: ds[t] || `Weight ${t}`
})), mt = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: E([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: E([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: E([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: E([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: E([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: E([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: E([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: E([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: E([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: E([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: E([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: E([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: E([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: E([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: E([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: E([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: E([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: E([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: E([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: E([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: E([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: E([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: E([400, 500, 700])
  }
], ps = (e, t = [500]) => {
  const n = e.replace(/ /g, "+"), r = t.join(";");
  return `https://fonts.googleapis.com/css2?family=${n}:wght@${r}&display=swap`;
}, gs = (e) => `https://fonts.googleapis.com/css2?${e.map((n) => {
  const r = n.name.replace(/ /g, "+"), i = n.weights.join(";");
  return `family=${r}:wght@${i}`;
}).join("&")}&display=swap`, ms = (e) => {
  const t = mt.find(
    (n) => n.name.toLowerCase() === e.toLowerCase()
  );
  return (t == null ? void 0 : t.variants) || [{ weight: 500, label: "Medium" }];
};
let dt = null;
const dr = () => dt || (dt = new Promise((e) => {
  const t = mt.map((i) => ({
    name: i.name,
    weights: [400, 500]
  })), n = gs(t), r = document.createElement("link");
  r.href = n, r.rel = "stylesheet", r.onload = () => {
    e();
  }, r.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(r);
}), dt), us = (e) => {
  if (!e) return "#000000ff";
  const t = e.startsWith("#") ? e : `#${e}`;
  return t.length === 9 ? t : t.length === 7 ? `${t}ff` : t.padEnd(9, "f").slice(0, 9);
}, hn = (e) => {
  const t = us(e);
  return t.length === 9 && t.slice(7, 9).toLowerCase() === "ff" ? t.slice(0, 7) : t;
}, Re = (e, t, n) => {
  var i;
  const r = {
    type: Un,
    payload: { updateType: t, themeId: n }
  };
  (i = e == null ? void 0 : e.current) != null && i.contentWindow ? e.current.contentWindow.postMessage(
    r,
    window.location.origin
  ) : window.postMessage(r, window.location.origin);
}, hs = (e) => {
  var n;
  switch ((n = e.split(".").pop()) == null ? void 0 : n.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, ys = ({
  themeId: e,
  editThemeToken: t,
  iframeRef: n,
  refreshThemeColors: r,
  refreshThemeFonts: i,
  refreshThemeIcons: a
}) => {
  const [l, d] = j(!1), [p, h] = j(null), [g, b] = j(null), [B, z] = j(!1), [C, x] = j(""), [f, S] = j("#000000ff"), [F, m] = j(
    null
  ), H = async () => {
    if (!C.trim()) {
      h("Color name is required");
      return;
    }
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    d(!0), h(null), b(null);
    try {
      await ko({
        themeId: e,
        colorKey: C.trim(),
        colorValue: hn(f),
        editThemeToken: t
      }), await r(), Re(n, "colors", e), x(""), S("#000000ff"), z(!1), b("Color added successfully"), setTimeout(() => b(null), 2e3);
    } catch (L) {
      h(L.message || "Failed to add color");
    } finally {
      d(!1);
    }
  }, y = async (L, R) => {
    if (!(!t || !e)) {
      d(!0), h(null), b(null);
      try {
        await ko({
          themeId: e,
          colorKey: L,
          colorValue: hn(R),
          editThemeToken: t
        }), await r(), Re(n, "colors", e), b("Color updated successfully"), setTimeout(() => b(null), 2e3);
      } catch (D) {
        h(D.message || "Failed to update color");
      } finally {
        d(!1);
      }
    }
  }, I = async (L, R) => {
    if (!(!t || !e)) {
      if (!R.trim()) {
        h("Color name is required");
        return;
      }
      if (L !== R.trim()) {
        d(!0), h(null), b(null);
        try {
          await pa({
            themeId: e,
            oldColorKey: L,
            newColorKey: R.trim(),
            editThemeToken: t
          }), await r(), Re(n, "colors", e), b("Color renamed successfully"), setTimeout(() => b(null), 2e3);
        } catch (D) {
          h(D.message || "Failed to rename color");
        } finally {
          d(!1);
        }
      }
    }
  }, v = (L) => {
    !t || !e || m({ type: "color", key: L });
  }, k = async (L) => {
    if (!(!t || !e)) {
      d(!0), h(null), b(null);
      try {
        await da({
          themeId: e,
          colorKey: L,
          editThemeToken: t
        }), await r(), Re(n, "colors", e), b("Color deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete color");
      } finally {
        d(!1);
      }
    }
  }, T = async (L) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    d(!0), h(null), b(null);
    try {
      let R, D;
      switch (L.type) {
        case "system":
          R = L.value || L.name, D = "system";
          break;
        case "google":
          const Y = ms(L.name).map((Q) => Q.weight);
          Y.includes(800) || Y.push(800), Y.includes(900) || Y.push(900), R = ps(L.name, Y), D = "google";
          break;
        case "upload":
          if (!L.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: G, objectPublicUrl: K } = await vo({
            themeId: e,
            fileName: L.file.name,
            contentType: L.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: t
          });
          await wo({
            file: L.file,
            signedUploadUrl: G
          }), R = K, D = hs(L.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await ga({
        themeId: e,
        fontKey: L.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: L.name,
          url: R,
          format: D
        },
        editThemeToken: t
      }), await i(), Re(n, "fonts", e), b("Font added successfully"), setTimeout(() => b(null), 2e3);
    } catch (R) {
      h(R.message || "Failed to add font");
    } finally {
      d(!1);
    }
  }, A = (L) => {
    !t || !e || m({ type: "font", key: L });
  }, P = async (L) => {
    if (!(!t || !e)) {
      d(!0), h(null), b(null);
      try {
        await ma({
          themeId: e,
          fontKey: L,
          editThemeToken: t
        }), await i(), Re(n, "fonts", e), b("Font deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete font");
      } finally {
        d(!1);
      }
    }
  }, W = async (L) => {
    if (!t || !e) {
      h("Theme ID and edit token are required");
      return;
    }
    d(!0), h(null), b(null);
    try {
      let R;
      switch (L.type) {
        case "lucide":
          if (R = L.url || "", !R)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!L.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: D, objectPublicUrl: N } = await vo({
            themeId: e,
            fileName: L.file.name,
            contentType: L.file.type || (L.file.name.endsWith(".svg") ? "image/svg+xml" : "application/octet-stream"),
            assetType: "icon",
            editThemeToken: t
          });
          await wo({
            file: L.file,
            signedUploadUrl: D
          }), R = N;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await ua({
        themeId: e,
        iconKey: L.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: L.name,
          url: R
        },
        editThemeToken: t
      }), await a(), Re(n, "icons", e), b("Icon added successfully"), setTimeout(() => b(null), 2e3);
    } catch (R) {
      h(R.message || "Failed to add icon");
    } finally {
      d(!1);
    }
  }, w = (L) => {
    !t || !e || m({ type: "icon", key: L });
  }, M = async (L) => {
    if (!(!t || !e)) {
      d(!0), h(null), b(null);
      try {
        await ha({
          themeId: e,
          iconKey: L,
          editThemeToken: t
        }), await a(), Re(n, "icons", e), b("Icon deleted successfully"), setTimeout(() => b(null), 2e3);
      } catch (R) {
        h(R.message || "Failed to delete icon");
      } finally {
        d(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: l,
    error: p,
    successMessage: g,
    // Color state
    isAddingColor: B,
    setIsAddingColor: z,
    newColorKey: C,
    setNewColorKey: x,
    newColorValue: f,
    setNewColorValue: S,
    // Color Handlers
    handleAddColor: H,
    handleUpdateColor: y,
    handleRenameColor: I,
    handleDeleteColor: v,
    // Font Handlers
    handleAddFont: T,
    handleDeleteFont: A,
    // Icon Handlers
    handleAddIcon: W,
    handleDeleteIcon: w,
    // Delete confirmation
    pendingDelete: F,
    confirmDelete: async () => {
      if (!F) return;
      const { type: L, key: R } = F;
      switch (m(null), L) {
        case "color":
          await k(R);
          break;
        case "font":
          await P(R);
          break;
        case "icon":
          await M(R);
          break;
      }
    },
    cancelDelete: () => {
      m(null);
    }
  };
}, yn = ({
  onClose: e,
  successMessage: t,
  error: n,
  children: r
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ o("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ o(
      oe,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ o(Ge, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-sidepanel-content", children: [
    t && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ o(Pr, { size: 14 }),
      " ",
      t
    ] }),
    n && /* @__PURE__ */ u("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ o(Fr, { size: 14 }),
      " ",
      n
    ] }),
    r
  ] })
] }), bn = ({
  themeFonts: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  onDeleteFont: i,
  onOpenFontPicker: a,
  studioLockedFontKeys: l
}) => {
  const [d, p] = j(!1);
  X(() => {
    t && !d && dr().then(() => p(!0));
  }, [t, d]);
  const h = (g) => {
    switch (g) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return g;
    }
  };
  return /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
      /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ o(
        ht,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
        }
      )
    ] }),
    t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([g, b]) => {
        const B = (l == null ? void 0 : l.has(g)) ?? !1;
        return /* @__PURE__ */ u("div", { className: "bc-theme-editor-row bc-font-row", children: [
          /* @__PURE__ */ o(
            "span",
            {
              className: "bc-font-preview-name",
              style: {
                fontFamily: d ? `'${b.name}', sans-serif` : "inherit"
              },
              children: b.name
            }
          ),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-asset-format", children: B ? "Concierge Studio" : h(b.format) }),
          B ? /* @__PURE__ */ o(
            "span",
            {
              title: "Edit this font from Concierge Studio",
              style: {
                display: "inline-flex",
                alignItems: "center",
                color: c.blue,
                padding: "4px",
                cursor: "help"
              },
              children: /* @__PURE__ */ o(Jt, { size: 14 })
            }
          ) : /* @__PURE__ */ o(
            "button",
            {
              className: "bc-theme-editor-delete-btn",
              onClick: () => i(g),
              disabled: r,
              "aria-label": "Delete font",
              children: /* @__PURE__ */ o(Ge, { size: 16 })
            }
          )
        ] }, g);
      }),
      /* @__PURE__ */ o(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ o(Ut, { size: 12 }),
          onClick: a,
          disabled: r,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, fn = ({
  themeIcons: e,
  isExpanded: t,
  onToggle: n,
  isLoading: r,
  onDeleteIcon: i,
  onOpenIconPicker: a
}) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ u("div", { className: "bc-theme-editor-section-header", onClick: n, children: [
    /* @__PURE__ */ u("h3", { className: "bc-theme-editor-section-title", children: [
      "Images and Icons",
      /* @__PURE__ */ o("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ o(
      ht,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${t ? "expanded" : ""}`
      }
    )
  ] }),
  t && /* @__PURE__ */ o("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ u("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([l, d]) => /* @__PURE__ */ u("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ o("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ o("img", { src: d.url, alt: d.name }) }),
      /* @__PURE__ */ o(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: d.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ o(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => i(l),
          disabled: r,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ o(Ge, { size: 16 })
        }
      )
    ] }, l)),
    /* @__PURE__ */ o(
      oe,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ o(Ut, { size: 12 }),
        onClick: a,
        disabled: r,
        children: "Add Image"
      }
    )
  ] }) })
] }), xn = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], bs = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${c.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${c.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${c.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${c.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${c.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${c.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${c.primary};
    background: ${c.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${c.blue};
    background: ${c.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${c.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${c.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${c.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${c.primary};
  }

  .font-picker-tab.active {
    color: ${c.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${c.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${c.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${c.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${c.border_glass};
  }

  .font-picker-item:hover {
    background: ${c.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${c.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${c.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${c.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${c.bg_light};
    border-bottom: 1px solid ${c.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${c.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${c.primary};
    background: ${c.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${c.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${c.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${c.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${c.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${c.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${c.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${c.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${c.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${c.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${c.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${c.primary};
    background: ${c.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${c.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${c.border_glass};
    background: ${c.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, Cn = ({
  isOpen: e,
  onClose: t,
  onSelect: n,
  isLoading: r = !1
}) => {
  const [i, a] = j("system"), [l, d] = j(""), [p, h] = j(null), [g, b] = j(null), [B, z] = j(""), C = le(null), [x, f] = j(!1);
  X(() => {
    e && (d(""), h(null), b(null), z(""));
  }, [e]), X(() => {
    i === "google" && !x && dr().then(() => {
      f(!0);
    });
  }, [i, x]);
  const S = pe(() => {
    if (!l) return xn;
    const w = l.toLowerCase();
    return xn.filter(
      (M) => M.name.toLowerCase().includes(w) || M.category.toLowerCase().includes(w)
    );
  }, [l]), F = pe(() => {
    if (!l) return mt;
    const w = l.toLowerCase();
    return mt.filter(
      (M) => M.name.toLowerCase().includes(w) || M.category.toLowerCase().includes(w)
    );
  }, [l]), m = (w) => {
    h({
      type: "system",
      name: w.name,
      value: w.value
    });
  }, H = (w) => {
    h({
      type: "google",
      name: w.name
    });
  }, y = (w) => {
    var O;
    const M = (O = w.target.files) == null ? void 0 : O[0];
    if (M) {
      b(M);
      const J = M.name.replace(/\.[^/.]+$/, "");
      z(J), h({
        type: "upload",
        name: J,
        file: M,
        format: I(M.name)
      });
    }
  }, I = (w) => {
    var O;
    switch ((O = w.split(".").pop()) == null ? void 0 : O.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, v = (w) => {
    z(w), (p == null ? void 0 : p.type) === "upload" && g && h({
      ...p,
      name: w
    });
  }, k = () => {
    p && (n(p), t());
  }, T = r || !p || p.type === "upload" && (!g || !B.trim()), A = pe(() => {
    const w = {};
    return F.forEach((M) => {
      w[M.category] || (w[M.category] = []), w[M.category].push(M);
    }), w;
  }, [F]), P = pe(() => {
    const w = {};
    return S.forEach((M) => {
      w[M.category] || (w[M.category] = []), w[M.category].push(M);
    }), w;
  }, [S]);
  if (!e) return null;
  const W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: bs() }),
    /* @__PURE__ */ o("div", { className: "font-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "font-picker-modal", onClick: (w) => w.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ o("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ o(Ge, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ o(yt, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: l,
            onChange: (w) => d(w.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "system" ? "active" : ""}`,
            onClick: () => a("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "google" ? "active" : ""}`,
            onClick: () => a("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `font-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => a("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-content", children: [
        i === "system" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(P).map(
            ([w, M]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ o("h4", { className: "font-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
              M.map((O) => /* @__PURE__ */ u(
                "div",
                {
                  className: `font-picker-item ${(p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === O.name ? "selected" : ""}`,
                  onClick: () => m(O),
                  children: [
                    /* @__PURE__ */ o(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: O.value },
                        children: O.name
                      }
                    ),
                    (p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === O.name && /* @__PURE__ */ o(nt, { size: 16, className: "font-picker-check" })
                  ]
                },
                O.name
              ))
            ] }, w)
          )
        ] }),
        i === "google" && /* @__PURE__ */ u("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(A).map(
            ([w, M]) => /* @__PURE__ */ u("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ o("h4", { className: "font-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
              M.map((O) => {
                const J = (p == null ? void 0 : p.type) === "google" && (p == null ? void 0 : p.name) === O.name;
                return /* @__PURE__ */ o("div", { children: /* @__PURE__ */ u(
                  "div",
                  {
                    className: `font-picker-item ${J ? "selected" : ""}`,
                    onClick: () => H(O),
                    children: [
                      /* @__PURE__ */ o(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: x ? `'${O.name}', sans-serif` : "inherit"
                          },
                          children: O.name
                        }
                      ),
                      J && /* @__PURE__ */ o(
                        nt,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, O.name);
              })
            ] }, w)
          )
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ o("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ o(
            "input",
            {
              ref: C,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: y,
              style: { display: "none" }
            }
          ),
          g ? /* @__PURE__ */ u("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ o("span", { className: "font-picker-upload-filename", children: g.name }),
              /* @__PURE__ */ o(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var w;
                    return (w = C.current) == null ? void 0 : w.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ u("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ o("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: B,
                  onChange: (w) => v(w.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var w;
                return (w = C.current) == null ? void 0 : w.click();
              },
              children: [
                /* @__PURE__ */ o(Tn, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ o("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ o("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ o(oe, { variant: "outline", onClick: t, disabled: r, children: "Cancel" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            onClick: k,
            disabled: T,
            children: r ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return je.createPortal(W, bt());
}, kn = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], ut = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], vn = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, fs = (e) => {
  const t = e.toLowerCase().trim();
  return t ? ut.filter(
    (n) => n.name.toLowerCase().includes(t) || n.tags.some((r) => r.toLowerCase().includes(t)) || n.category.toLowerCase().includes(t)
  ) : ut;
}, wn = (e) => ut.filter((t) => t.category === e), xs = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${c.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${c.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${c.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${c.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${c.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${c.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${c.primary};
    background: ${c.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${c.blue};
    background: ${c.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${c.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${c.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${c.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${c.primary};
  }

  .icon-picker-tab.active {
    color: ${c.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${c.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${c.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${c.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${c.border_glass};
    border-radius: 20px;
    background: ${c.white};
    font-size: 12px;
    font-weight: 500;
    color: ${c.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${c.blue};
    color: ${c.blue};
  }

  .icon-picker-category-btn.active {
    background: ${c.primary};
    border-color: ${c.primary};
    color: ${c.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${c.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${c.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${c.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${c.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${c.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${c.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${c.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${c.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${c.bg_light};
    border-top: 1px solid ${c.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${c.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${c.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${c.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${c.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${c.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${c.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${c.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-image-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-image-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-image-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${c.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${c.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${c.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${c.primary};
    background: ${c.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${c.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${c.border_glass};
    background: ${c.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, Sn = ({
  isOpen: e,
  onClose: t,
  onSelect: n,
  isLoading: r = !1
}) => {
  const [i, a] = j("upload"), [l, d] = j(""), [p, h] = j(null), [g, b] = j("all"), [B, z] = j(null), [C, x] = j(""), [f, S] = j(null), [F, m] = j(null), H = le(null);
  X(() => {
    e && (a("upload"), d(""), h(null), b("all"), z(null), x(""), S(null), m(null));
  }, [e]);
  const y = pe(() => {
    let w;
    return l ? w = fs(l) : g === "all" ? w = ut : w = wn(g), w;
  }, [l, g]), I = pe(() => {
    if (l || g !== "all")
      return {
        [g === "all" ? "results" : g]: y
      };
    const w = {};
    return kn.forEach((M) => {
      w[M] = wn(M);
    }), w;
  }, [y, l, g]), v = (w) => {
    h({
      type: "lucide",
      name: w.name,
      url: vn(w.name)
    });
  }, k = async (w) => {
    var O;
    const M = (O = w.target.files) == null ? void 0 : O[0];
    if (M) {
      z(M);
      const J = M.name.replace(/\.[^/.]+$/, "");
      if (x(J), F && (URL.revokeObjectURL(F), m(null)), S(null), M.type === "image/svg+xml" || M.name.endsWith(".svg")) {
        const R = new FileReader();
        R.onload = (D) => {
          var N;
          S((N = D.target) == null ? void 0 : N.result);
        }, R.readAsText(M);
      } else
        m(URL.createObjectURL(M));
      h({
        type: "upload",
        name: J,
        file: M
      });
    }
  }, T = (w) => {
    x(w), (p == null ? void 0 : p.type) === "upload" && B && h({
      ...p,
      name: w
    });
  }, A = () => {
    p && (n(p), t());
  }, P = r || !p || p.type === "upload" && (!B || !C.trim());
  if (!e) return null;
  const W = /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: xs() }),
    /* @__PURE__ */ o("div", { className: "icon-picker-overlay", onClick: t, children: /* @__PURE__ */ u("div", { className: "icon-picker-modal", onClick: (w) => w.stopPropagation(), children: [
      /* @__PURE__ */ u("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ o("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: t,
            "aria-label": "Close",
            children: /* @__PURE__ */ o(Ge, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ o(yt, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ o(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: l,
            onChange: (w) => d(w.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ o(
          "button",
          {
            className: `icon-picker-tab ${i === "lucide" ? "active" : ""}`,
            onClick: () => a("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            className: `icon-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => a("upload"),
            children: "Upload Image"
          }
        )
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-content", children: [
        i === "lucide" && /* @__PURE__ */ u($, { children: [
          /* @__PURE__ */ u("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ o(
              "button",
              {
                className: `icon-picker-category-btn ${g === "all" ? "active" : ""}`,
                onClick: () => b("all"),
                children: "All"
              }
            ),
            kn.map((w) => /* @__PURE__ */ o(
              "button",
              {
                className: `icon-picker-category-btn ${g === w ? "active" : ""}`,
                onClick: () => b(w),
                children: w.charAt(0).toUpperCase() + w.slice(1)
              },
              w
            ))
          ] }),
          /* @__PURE__ */ u("div", { className: "icon-picker-icons-container", children: [
            Object.entries(I).map(([w, M]) => /* @__PURE__ */ u(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !l && g === "all" && /* @__PURE__ */ o("h4", { className: "icon-picker-category-title", children: w.charAt(0).toUpperCase() + w.slice(1) }),
                  /* @__PURE__ */ o("div", { className: "icon-picker-grid", children: M.map((O) => /* @__PURE__ */ u(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === O.name ? "selected" : ""}`,
                      onClick: () => v(O),
                      title: O.name,
                      children: [
                        /* @__PURE__ */ o(
                          "img",
                          {
                            src: vn(O.name),
                            alt: O.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === O.name && /* @__PURE__ */ o("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ o(nt, { size: 12 }) })
                      ]
                    },
                    O.name
                  )) })
                ]
              },
              w
            )),
            y.length === 0 && /* @__PURE__ */ o("div", { className: "icon-picker-empty", children: /* @__PURE__ */ u("p", { children: [
              'No icons found for "',
              l,
              '"'
            ] }) })
          ] }),
          (p == null ? void 0 : p.type) === "lucide" && /* @__PURE__ */ u("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ o(
              "img",
              {
                src: p.url,
                alt: p.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ o("span", { className: "icon-picker-selected-name", children: p.name })
          ] })
        ] }),
        i === "upload" && /* @__PURE__ */ u("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ o("p", { className: "icon-picker-description", children: "Upload your own image or icon file." }),
          /* @__PURE__ */ o(
            "input",
            {
              ref: H,
              type: "file",
              accept: ".png,.jpg,.jpeg,.gif,.webp,.svg,image/*",
              onChange: k,
              style: { display: "none" }
            }
          ),
          B ? /* @__PURE__ */ u("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-file", children: [
              f && /* @__PURE__ */ o(
                "div",
                {
                  className: "icon-picker-image-preview",
                  dangerouslySetInnerHTML: { __html: f }
                }
              ),
              F && /* @__PURE__ */ o("div", { className: "icon-picker-image-preview", children: /* @__PURE__ */ o("img", { src: F, alt: C }) }),
              /* @__PURE__ */ u("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-filename", children: B.name }),
                /* @__PURE__ */ o(
                  oe,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var w;
                      return (w = H.current) == null ? void 0 : w.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ u("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ o("label", { className: "icon-picker-upload-label", children: "Image name" }),
              /* @__PURE__ */ o(
                "input",
                {
                  type: "text",
                  value: C,
                  onChange: (w) => T(w.target.value),
                  placeholder: "Enter image name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ u(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var w;
                return (w = H.current) == null ? void 0 : w.click();
              },
              children: [
                /* @__PURE__ */ o(Tn, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-text", children: "Click to upload image" }),
                /* @__PURE__ */ o("span", { className: "icon-picker-upload-hint", children: "PNG, JPG, GIF, WEBP, SVG" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ u("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ o(oe, { variant: "outline", onClick: t, disabled: r, children: "Cancel" }),
        /* @__PURE__ */ o(
          oe,
          {
            variant: "primary",
            onClick: A,
            disabled: P,
            children: r ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return je.createPortal(W, bt());
}, kc = () => {
  const e = Je(), t = Mn(), [n, r] = j("checking"), [i, a] = j("desktop"), l = le(null), [d, p] = j(!1), { data: h } = Se(), g = (h == null ? void 0 : h.themeName) || e.themeId, { themeColors: b, refreshThemeColors: B } = qt(), { themeFonts: z, refreshThemeFonts: C } = _n(), { themeIcons: x, refreshThemeIcons: f } = Zn(), { data: S } = Se(), F = pe(() => {
    var D;
    const R = (D = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : D.colors;
    return R != null && R.length ? new Set(R) : void 0;
  }, [S]), m = pe(() => {
    var D;
    const R = (D = S == null ? void 0 : S.studioControlledKeys) == null ? void 0 : D.fonts;
    return R != null && R.length ? new Set(R) : void 0;
  }, [S]), [H, y] = j(null), [I, v] = j(!1), [k, T] = j(!1), A = (R) => {
    y((D) => D === R ? null : R);
  }, P = ys({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: n === "iframe" ? l : null,
    refreshThemeColors: B,
    refreshThemeFonts: C,
    refreshThemeIcons: f
  });
  X(() => {
    t || Qi();
  }, [t]), X(() => Wi(() => {
    T(!0);
  }), []);
  const W = !!(e.themeId || e.appId);
  X(() => {
    if (t || !W) return;
    (async () => {
      const D = await ei();
      r(D ? "iframe" : "inline");
    })();
  }, [t, W]), X(() => {
    if (t || e.previewMode || !e.themeId || !e.editThemeToken || e.appId) return;
    let R = !1;
    return ca({
      themeId: e.themeId,
      editThemeToken: e.editThemeToken
    }).then((D) => {
      R || D || (wt(), St(), window.location.reload());
    }), () => {
      R = !0;
    };
  }, [
    t,
    e.themeId,
    e.editThemeToken,
    e.previewMode,
    e.origin,
    e.appId
  ]);
  const w = me(() => {
    var R;
    if (l.current)
      try {
        const D = new URL(
          ((R = l.current.contentWindow) == null ? void 0 : R.location.href) || ""
        ), N = new URL(window.location.href);
        N.pathname = D.pathname;
        const Y = new URLSearchParams(D.search), G = new URLSearchParams();
        e.themeId && G.set("themeId", e.themeId), e.editMode && G.set("editMode", "true"), e.editThemeToken && G.set("editThemeToken", e.editThemeToken), e.appId && G.set("appId", e.appId), e.scope && G.set("scope", e.scope), Y.forEach((K, Q) => {
          Q !== "frameMode" && Q !== "themeId" && Q !== "editMode" && Q !== "editThemeToken" && Q !== "appId" && Q !== "scope" && G.set(Q, K);
        }), N.search = G.toString(), window.history.replaceState({}, "", N.toString());
      } catch (D) {
        console.debug("Could not access iframe URL (cross-origin):", D);
      }
  }, [e]);
  if (!W || t)
    return null;
  if (e.previewMode) {
    const R = () => {
      wt(), St();
      const D = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
      window.location.href = D;
    };
    return /* @__PURE__ */ u($, { children: [
      /* @__PURE__ */ o("style", { children: `
          body { padding-top: 60px !important; }
        ` }),
      /* @__PURE__ */ u(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: 60,
            background: "#f5f5f7",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            gap: 16,
            zIndex: 1000001,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          },
          children: [
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ o(
                "div",
                {
                  style: {
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ o(Ar, { size: 18, color: "white" })
                }
              ),
              /* @__PURE__ */ o("span", { style: { fontWeight: 600, fontSize: 15, color: "#1a1a2e" }, children: "Theme Preview" })
            ] }),
            /* @__PURE__ */ u("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ o("span", { style: { fontSize: 12, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px" }, children: "Theme:" }),
              /* @__PURE__ */ o("span", { style: { fontSize: 14, fontWeight: 500, color: "#1a1a2e" }, children: g }),
              (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u(
                "span",
                {
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#22c55e",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  },
                  children: [
                    /* @__PURE__ */ o(
                      "span",
                      {
                        style: {
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#22c55e"
                        }
                      }
                    ),
                    "Live"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ o("div", { style: { flex: 1 } }),
            /* @__PURE__ */ o(
              oe,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: /* @__PURE__ */ o(vt, { size: 14 }),
                onClick: R,
                children: "Exit Preview"
              }
            )
          ]
        }
      )
    ] });
  }
  if (n === "checking")
    return /* @__PURE__ */ u(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ o(Rr, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ o("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ o("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const M = () => {
    wt(), St();
    const R = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = R;
  }, O = () => {
    p(!d);
  }, J = async (R) => {
    await P.handleAddFont(R);
  }, L = async (R) => {
    await P.handleAddIcon(R);
  };
  return n === "inline" ? /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: Mo({ showSettings: d, viewMode: i, editorMode: n }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ o("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ o(io, { size: 18 }) }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-id", children: g }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ o("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ o("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ o(Tt, { size: 14 }),
              onClick: O,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ o(vt, { size: 14 }),
              onClick: M,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      d && /* @__PURE__ */ u(
        yn,
        {
          onClose: () => p(!1),
          successMessage: P.successMessage,
          error: P.error,
          children: [
            /* @__PURE__ */ o(
              Co,
              {
                themeColors: b,
                isExpanded: H === "colors",
                onToggle: () => A("colors"),
                isLoading: P.isLoading,
                isAddingColor: P.isAddingColor,
                setIsAddingColor: P.setIsAddingColor,
                newColorKey: P.newColorKey,
                setNewColorKey: P.setNewColorKey,
                newColorValue: P.newColorValue,
                setNewColorValue: P.setNewColorValue,
                onAddColor: P.handleAddColor,
                onUpdateColor: P.handleUpdateColor,
                onRenameColor: P.handleRenameColor,
                onDeleteColor: P.handleDeleteColor,
                studioLockedColorKeys: F
              }
            ),
            /* @__PURE__ */ o(
              bn,
              {
                themeFonts: z,
                isExpanded: H === "fonts",
                onToggle: () => A("fonts"),
                isLoading: P.isLoading,
                onDeleteFont: P.handleDeleteFont,
                onOpenFontPicker: () => v(!0),
                studioLockedFontKeys: m
              }
            ),
            /* @__PURE__ */ o(
              fn,
              {
                themeIcons: x,
                isExpanded: H === "icons",
                onToggle: () => A("icons"),
                isLoading: P.isLoading,
                onDeleteIcon: P.handleDeleteIcon,
                onOpenIconPicker: () => T(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ o(
        Cn,
        {
          isOpen: I,
          onClose: () => v(!1),
          onSelect: J,
          isLoading: P.isLoading
        }
      ),
      /* @__PURE__ */ o(
        Sn,
        {
          isOpen: k,
          onClose: () => T(!1),
          onSelect: L,
          isLoading: P.isLoading
        }
      ),
      P.pendingDelete && /* @__PURE__ */ o(
        rt,
        {
          title: `Delete ${P.pendingDelete.type}`,
          message: `Are you sure you want to delete "${P.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: P.confirmDelete,
          onCancel: P.cancelDelete,
          isLoading: P.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ u($, { children: [
    /* @__PURE__ */ o("style", { children: Mo({ showSettings: d, viewMode: i, editorMode: n }) }),
    /* @__PURE__ */ u("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ u("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ o("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ o(io, { size: 18 }) }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ o("span", { className: "bc-theme-editor-theme-id", children: g }),
          (h == null ? void 0 : h.isPublished) && /* @__PURE__ */ u("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ o("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: i === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => a("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ o(In, { size: 16 })
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: i === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => a("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ o(Fn, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ o("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ u("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ o(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ o(Tt, { size: 14 }),
              onClick: O,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ o(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ o(vt, { size: 14 }),
              onClick: M,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ o("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ o("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ o("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ o(
        "iframe",
        {
          ref: l,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: w,
          title: "Theme Preview"
        }
      ) }) }) }),
      d && /* @__PURE__ */ u(
        yn,
        {
          onClose: () => p(!1),
          successMessage: P.successMessage,
          error: P.error,
          children: [
            /* @__PURE__ */ o(
              Co,
              {
                themeColors: b,
                isExpanded: H === "colors",
                onToggle: () => A("colors"),
                isLoading: P.isLoading,
                isAddingColor: P.isAddingColor,
                setIsAddingColor: P.setIsAddingColor,
                newColorKey: P.newColorKey,
                setNewColorKey: P.setNewColorKey,
                newColorValue: P.newColorValue,
                setNewColorValue: P.setNewColorValue,
                onAddColor: P.handleAddColor,
                onUpdateColor: P.handleUpdateColor,
                onRenameColor: P.handleRenameColor,
                onDeleteColor: P.handleDeleteColor
              }
            ),
            /* @__PURE__ */ o(
              bn,
              {
                themeFonts: z,
                isExpanded: H === "fonts",
                onToggle: () => A("fonts"),
                isLoading: P.isLoading,
                onDeleteFont: P.handleDeleteFont,
                onOpenFontPicker: () => v(!0)
              }
            ),
            /* @__PURE__ */ o(
              fn,
              {
                themeIcons: x,
                isExpanded: H === "icons",
                onToggle: () => A("icons"),
                isLoading: P.isLoading,
                onDeleteIcon: P.handleDeleteIcon,
                onOpenIconPicker: () => T(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ o(
        Cn,
        {
          isOpen: I,
          onClose: () => v(!1),
          onSelect: J,
          isLoading: P.isLoading
        }
      ),
      /* @__PURE__ */ o(
        Sn,
        {
          isOpen: k,
          onClose: () => T(!1),
          onSelect: L,
          isLoading: P.isLoading
        }
      ),
      P.pendingDelete && /* @__PURE__ */ o(
        rt,
        {
          title: `Delete ${P.pendingDelete.type}`,
          message: `Are you sure you want to delete "${P.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: P.confirmDelete,
          onCancel: P.cancelDelete,
          isLoading: P.isLoading
        }
      )
    ] })
  ] });
};
export {
  oe as Button,
  ka as CHAT_INPUT_PRESETS,
  ac as ChainOfThoughtWidget,
  Zs as ChatHistoryWidget,
  Ds as ChatInput,
  tl as ConciergeContentSkeleton,
  Us as ConciergeFullPageSkeleton,
  Js as ConciergeHeaderWidget,
  dc as ConciergeHomeBrandLabelWidget,
  pc as ConciergeHomeGreetingWidget,
  sc as ConciergeHomeLayoutWidget,
  cc as ConciergeHomeLogoWidget,
  uc as ConciergeHomeMobileNavWidget,
  mc as ConciergeHomeStartersWidget,
  gc as ConciergeHomeSubtitleWidget,
  tc as ConciergePanelWidget,
  ir as ConciergeSidebarSkeleton,
  _s as ConciergeSidebarWidget,
  nc as ConfirmActionDialogWidget,
  $s as ConversationStartersWidget,
  Fe as DEFAULT_STUDIO_SUPPORT_BRANDING,
  js as ELEMENT_GROUPS,
  On as EditPanel,
  Vs as FloatingButtonWidget,
  Qs as FollowUpQueriesWidget,
  Xs as HeaderWidget,
  Pl as LAYOUT_PRESETS,
  ic as LoginDialogWidget,
  Os as MessageBubbleWidget,
  Ws as PANEL_CHAT_INPUT_PRESETS,
  zl as PRESET_LABELS,
  lc as PromptLoginWidget,
  Cc as RetailerIconWidget,
  bc as RewardOpportunitiesWidget,
  xc as RewardPillWidget,
  Ys as SearchPanelWidget,
  rc as ShareConversationDialogWidget,
  ec as SuggestionListWidget,
  yc as SurveyCard,
  hc as SurveysWidget,
  fc as TextBox,
  kc as ThemeManager,
  Ks as TrendingCardWidget,
  Gs as TypingIndicatorWidget,
  oc as VariantPickerWidget,
  Oe as WIDGET_THEME_QUERY_KEY,
  qs as WelcomeScreenWidget,
  Ui as WidgetEditSuppressProvider,
  Es as WidgetEditUnsuppressProvider,
  U as WidgetWrapper,
  Ps as calculateRewardPercent,
  wt as clearThemeParams,
  St as clearUrlParams,
  c as colors,
  q as customColor,
  Bl as defaultPromptLoginState,
  Bs as formatDate,
  Ss as formatMoney,
  Is as formatRelativeTime,
  Fs as getFontWeightValue,
  Yi as getThemeParams,
  Ei as isColorValue,
  $i as saveThemeParams,
  zs as slugify,
  Qi as syncUrlToStorage,
  s as themeColor,
  Ts as truncateText,
  Ms as updateUrlParams,
  Jn as updateWidgetConfig,
  Zt as useEditMode,
  Ns as useResolveColor,
  Hs as useStudioAgentName,
  Ls as useStudioAgreement,
  As as useStudioAvailability,
  Rs as useStudioSupportBranding,
  qt as useThemeColors,
  _n as useThemeFonts,
  Zn as useThemeIcons,
  ba as useWidgetConfig,
  Dt as useWidgetEdit,
  _i as useWidgetEditSuppressed,
  te as useWidgetEditable,
  Se as useWidgetTheme,
  Je as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
